import "./module.css";
import {createContext as $kIarK$createContext, useRef as $kIarK$useRef, useEffect as $kIarK$useEffect, createRef as $kIarK$createRef, useState as $kIarK$useState, useCallback as $kIarK$useCallback, useMemo as $kIarK$useMemo, Suspense as $kIarK$Suspense, useContext as $kIarK$useContext, lazy as $kIarK$lazy, memo as $kIarK$memo, forwardRef as $kIarK$forwardRef, useLayoutEffect as $kIarK$useLayoutEffect} from "react";
import {jsx as $kIarK$jsx, jsxs as $kIarK$jsxs, Fragment as $kIarK$Fragment} from "react/jsx-runtime";
import {i18n as $kIarK$i18n} from "@lingui/core";
import {Trans as $kIarK$Trans, useLingui as $kIarK$useLingui, I18nProvider as $kIarK$I18nProvider} from "@lingui/react";
import {decamelizeKeys as $kIarK$decamelizeKeys, camelize as $kIarK$camelize, decamelize as $kIarK$decamelize} from "humps";
import {Tag as $kIarK$Tag, useTestId as $kIarK$useTestId, Button as $kIarK$Button, Spinner as $kIarK$Spinner, setCustomButtonColors as $kIarK$setCustomButtonColors, Table as $kIarK$Table, Text as $kIarK$Text, Toggle as $kIarK$Toggle, Input as $kIarK$Input, RangeSlider as $kIarK$RangeSlider, Skeleton as $kIarK$Skeleton, useToggle as $kIarK$useToggle} from "@marketertechnologies/ui-library";
import $kIarK$classnames from "classnames";
import {useMediaQuery as $kIarK$useMediaQuery} from "react-responsive";
import {CaretLeft as $kIarK$CaretLeft, X as $kIarK$X, Info as $kIarK$Info, CheckSquare as $kIarK$CheckSquare, Square as $kIarK$Square, CaretUp as $kIarK$CaretUp, FadersHorizontal as $kIarK$FadersHorizontal, SquaresFour as $kIarK$SquaresFour, Rows as $kIarK$Rows, Buildings as $kIarK$Buildings, ArrowLeft as $kIarK$ArrowLeft, CaretRight as $kIarK$CaretRight, MagnifyingGlassMinus as $kIarK$MagnifyingGlassMinus, MagnifyingGlassPlus as $kIarK$MagnifyingGlassPlus} from "@phosphor-icons/react";
import {mergeDeepRight as $kIarK$mergeDeepRight, compose as $kIarK$compose, equals as $kIarK$equals, prop as $kIarK$prop, isNil as $kIarK$isNil, pick as $kIarK$pick, uniq as $kIarK$uniq, uniqBy as $kIarK$uniqBy, path as $kIarK$path, partition as $kIarK$partition, defaultTo as $kIarK$defaultTo, countBy as $kIarK$countBy, groupBy as $kIarK$groupBy, clamp as $kIarK$clamp, identity as $kIarK$identity, sortWith as $kIarK$sortWith, ascend as $kIarK$ascend, descend as $kIarK$descend, pipe as $kIarK$pipe, map as $kIarK$map, isEmpty as $kIarK$isEmpty, sort as $kIarK$sort} from "ramda";
import $kIarK$reactmodal from "react-modal";
import $kIarK$chromajs from "chroma-js";
import {useForm as $kIarK$useForm, Form as $kIarK$Form, Field as $kIarK$Field, useFormState as $kIarK$useFormState} from "react-final-form";
import {shallow as $kIarK$shallow} from "zustand/shallow";
import {createWithEqualityFn as $kIarK$createWithEqualityFn} from "zustand/traditional";
import $kIarK$dashify from "dashify";
import $kIarK$lodashdebounce from "lodash.debounce";
import "swiper/css";
import {Navigation as $kIarK$Navigation, FreeMode as $kIarK$FreeMode} from "swiper/modules";
import {Swiper as $kIarK$Swiper, SwiperSlide as $kIarK$SwiperSlide} from "swiper/react";
import {twMerge as $kIarK$twMerge} from "tailwind-merge";
import {select as $kIarK$select, easeLinear as $kIarK$easeLinear, easeExpInOut as $kIarK$easeExpInOut, polygonHull as $kIarK$polygonHull, selectAll as $kIarK$selectAll, zoom as $kIarK$zoom, easeQuadInOut as $kIarK$easeQuadInOut} from "d3";
import {createPortal as $kIarK$createPortal} from "react-dom";
import {renderToString as $kIarK$renderToString} from "react-dom/server";
import $kIarK$bowser from "bowser";
import {useFloating as $kIarK$useFloating, autoUpdate as $kIarK$autoUpdate, flip as $kIarK$flip, shift as $kIarK$shift, offset as $kIarK$offset, arrow as $kIarK$arrow, FloatingArrow as $kIarK$FloatingArrow} from "@floating-ui/react";
import $kIarK$reacthookresizeobserver from "@react-hook/resize-observer";
import $kIarK$lodashmemoize from "lodash.memoize";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("BO02E", function(module, exports) {

$parcel$export(module.exports, "MainContext", () => $cecf912047d0797a$export$dacf816d2691e708);

const $cecf912047d0797a$var$emptyFn = ()=>{};
const $cecf912047d0797a$export$dacf816d2691e708 = (0, $kIarK$createContext)({
    showUnconfiguredOverlay: false,
    setShowUnconfiguredOverlay: $cecf912047d0797a$var$emptyFn,
    hasPlayed: false,
    setHasPlayed: $cecf912047d0797a$var$emptyFn,
    activeScene: null,
    setActiveScene: $cecf912047d0797a$var$emptyFn,
    activeAngle: null,
    activeUnit: null,
    setActiveUnit: $cecf912047d0797a$var$emptyFn,
    activeTab: null,
    setActiveTab: $cecf912047d0797a$var$emptyFn,
    showFilters: false,
    setShowFilters: $cecf912047d0797a$var$emptyFn,
    detailsView: null,
    setDetailsView: $cecf912047d0797a$var$emptyFn,
    appHistory: [],
    setAppHistory: $cecf912047d0797a$var$emptyFn,
    share: false,
    setShare: $cecf912047d0797a$var$emptyFn,
    isMobile: false,
    onRegisterInterestSubmit: $cecf912047d0797a$var$emptyFn,
    implementationRef: null,
    previewMode: false,
    hovered: null,
    setHovered: $cecf912047d0797a$var$emptyFn,
    view: null,
    references: [],
    focusedElement: null,
    setFocusedElement: $cecf912047d0797a$var$emptyFn
});

});

parcelRegister("beILY", function(module, exports) {

$parcel$export(module.exports, "canonicalUnitStates", () => $22da792bf2f2765d$export$cf445adf8834ba8e);
$parcel$export(module.exports, "getCanonicalUnitStates", () => $22da792bf2f2765d$export$40abfdaf35e862f);
$parcel$export(module.exports, "canonicalUnitProperties", () => $22da792bf2f2765d$export$69b2099bc5b0f366);
$parcel$export(module.exports, "canonicalNorwegianUnitProperties", () => $22da792bf2f2765d$export$f6b49dfa8be01020);
$parcel$export(module.exports, "canonicalStageAndBuildingProperties", () => $22da792bf2f2765d$export$893b0b701ceb2985);
$parcel$export(module.exports, "canonicalFacingDirections", () => $22da792bf2f2765d$export$f430ff32467a335c);
$parcel$export(module.exports, "getCanonicalBalconyDirections", () => $22da792bf2f2765d$export$aa0e4248bfbab598);
$parcel$export(module.exports, "getBalconyDirections", () => $22da792bf2f2765d$export$557420aacf0c73a4);
$parcel$export(module.exports, "getCanonicalOwnershipTypes", () => $22da792bf2f2765d$export$91ca1c9c5ee219c6);
$parcel$export(module.exports, "getCanonicalUnitTypes", () => $22da792bf2f2765d$export$c0cc5e033dc26dec);
$parcel$export(module.exports, "canonicalFilterLabels", () => $22da792bf2f2765d$export$8bb58c0d41cc9934);
$parcel$export(module.exports, "getCanonicalFacilities", () => $22da792bf2f2765d$export$1320c989ad2b448);



const $22da792bf2f2765d$export$cf445adf8834ba8e = {
    reserved: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "Uwsg2F"
    }),
    sold: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "s9KGXU"
    }),
    coming_for_sale: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "PJR11c"
    }),
    archived: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "s9KGXU"
    }),
    for_sale: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "BFN94d"
    }),
    partially_owned: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "OxbACX"
    }),
    rented: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "vWP2Gj"
    }),
    for_rent: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "4Ri+A0"
    }),
    sold_out: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "lgFfeO"
    })
};
const $22da792bf2f2765d$export$40abfdaf35e862f = ()=>({
        reserved: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "Uwsg2F"
        }),
        sold: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "s9KGXU"
        }),
        coming_for_sale: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "PJR11c"
        }),
        archived: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "s9KGXU"
        }),
        for_sale: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "BFN94d"
        }),
        partially_owned: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "OxbACX"
        }),
        rented: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "vWP2Gj"
        }),
        for_rent: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "4Ri+A0"
        }),
        sold_out: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "lgFfeO"
        })
    });
const $22da792bf2f2765d$export$69b2099bc5b0f366 = {
    unitId: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "aSwfbR"
    }),
    sizeM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "t6yDp0"
    }),
    grossFloorAreaM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "+lY7Ar"
    }),
    fromToPrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "0a7PDu"
    }),
    purchasePrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "a7u1N9"
    }),
    usableAreaM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "IodKQ0"
    }),
    usableAreaI: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "JwqVXG"
    }),
    usableAreaE: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "ij53KS"
    }),
    usableAreaB: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "9U5DaL"
    }),
    openArea: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "rWaJtl"
    }),
    lotSizeM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "EQQRc5"
    }),
    type: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "+zy2Nq"
    }),
    floorNumber: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "oCHfGC"
    }),
    buildingName: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "oZd08v"
    }),
    stageName: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "3PRxO3"
    }),
    totalPrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "qqsfDU"
    }),
    totalCosts: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "mEKLZL"
    }),
    sharedPrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "hmd2Ji"
    }),
    jointDebt: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "OgACWb"
    }),
    deposit: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "kj3M8S"
    }),
    ownershipType: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "oDAEQq"
    }),
    roomCount: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "Fglnvp"
    }),
    bedroomCount: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "mMQSH4"
    }),
    bathroomCount: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "t45b0O"
    }),
    partiallyOwned: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "UbX/QK"
    }),
    monthlyRentalAmount: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "56vwJs"
    }),
    purchasePricePartOwnership: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "1Euao/"
    }),
    state: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "RS0o7b"
    }),
    rentalPrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "7aYzgc"
    }),
    rentalDeposit: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "MepnY2"
    }),
    rentalsServiceCharge: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "2eknBD"
    }),
    description: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "Nu4oKW"
    }),
    energyLabel: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "H9a3W2"
    })
};
const $22da792bf2f2765d$export$f6b49dfa8be01020 = {
    usableAreaI: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "JwqVXG"
    }),
    usableAreaE: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "ij53KS"
    }),
    usableAreaB: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "9U5DaL"
    }),
    openArea: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "suo7tL"
    })
};
const $22da792bf2f2765d$export$893b0b701ceb2985 = {
    title: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "MHrjPM"
    }),
    price: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "oyIs+l"
    }),
    purchasePrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "a7u1N9"
    }),
    totalPrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "qqsfDU"
    }),
    sizeM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "kJ9iPL"
    }),
    grossFloorAreaM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "+lY7Ar"
    }),
    usableAreaM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "hs3P0F"
    }),
    usableAreaI: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "rAvVFz"
    }),
    usableAreaE: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "8XQ4MD"
    }),
    usableAreaB: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "BLlipz"
    }),
    availableUnits: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "XwoMlz"
    }),
    unitTypes: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "SIFrwC"
    }),
    state: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "RS0o7b"
    }),
    rentalPrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "7aYzgc"
    }),
    rentalDeposit: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "MepnY2"
    })
};
const $22da792bf2f2765d$export$f430ff32467a335c = {
    N: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "QPfvuh"
    }),
    E: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "E16z5a"
    }),
    S: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "RxbC6J"
    }),
    W: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "FqEJnO"
    }),
    NE: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "wjJ1Xm"
    }),
    SE: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "AuzRy6"
    }),
    SW: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "v+WL2j"
    }),
    NW: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "2yZc/R"
    })
};
const $22da792bf2f2765d$export$aa0e4248bfbab598 = ()=>({
        north: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "vyqaYx"
        }),
        east: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "zz/Pi8"
        }),
        south: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "p6Hb+r"
        }),
        west: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "DR14bo"
        }),
        north_east: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "4Xwqm8"
        }),
        south_east: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "g3Kx2K"
        }),
        north_west: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "jK5kZi"
        }),
        south_west: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "mknggx"
        })
    });
const $22da792bf2f2765d$export$557420aacf0c73a4 = ()=>({
        north: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "qV2cO3"
        }),
        east: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "w52jYu"
        }),
        south: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "CHWYig"
        }),
        west: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "kZ3clk"
        }),
        'north-east': (0, $kIarK$i18n)._(/*i18n*/ {
            id: "Vdegzk"
        }),
        'south-east': (0, $kIarK$i18n)._(/*i18n*/ {
            id: "WmT2An"
        }),
        'north-west': (0, $kIarK$i18n)._(/*i18n*/ {
            id: "qy1mWq"
        }),
        'south-west': (0, $kIarK$i18n)._(/*i18n*/ {
            id: "ax3q27"
        })
    });
const $22da792bf2f2765d$export$91ca1c9c5ee219c6 = ()=>({
        owned: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "qEAgqe"
        }),
        cooperative: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "GkviEB"
        }),
        stock: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "blbbPS"
        }),
        bond: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "IN0LBx"
        }),
        other: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "/IX/7x"
        })
    });
const $22da792bf2f2765d$export$c0cc5e033dc26dec = ()=>({
        apartment: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "hwpQaF"
        }),
        townhouse: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "LKiZeZ"
        }),
        detached: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "taSY7H"
        }),
        semi_detached: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "zTbQzK"
        }),
        single_family_house: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "o2D1vi"
        }),
        storage: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "BrrIs8"
        }),
        residential_lot: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "cwbbeN"
        }),
        leisure: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "VRKd4g"
        }),
        leisure_lot: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "CChbRW"
        }),
        commercial: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "gyjsV2"
        }),
        commercial_lot: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "VMRFQE"
        }),
        commercial_farm: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "M/2JLO"
        }),
        commercial_homestead: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "AbQxQE"
        }),
        recreational: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "RMYlfD"
        }),
        recreational_lot: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "CnSFS4"
        }),
        recreational_other: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "fvj3Pv"
        }),
        duplex: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "tFDeqA"
        }),
        other: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "/IX/7x"
        }),
        microhouse: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "dke9GB"
        })
    });
const $22da792bf2f2765d$export$88e703220d0329f2 = {
    purchasePrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "a7u1N9"
    }),
    bedroomCount: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "mMQSH4"
    }),
    size: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "t6yDp0"
    }),
    grossFloorArea: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "+lY7Ar"
    }),
    usableArea: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "IodKQ0"
    }),
    usableAreaI: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "M6Pl2B"
    }),
    usableAreaE: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "b7Fian"
    }),
    usableAreaB: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "Xs+IX4"
    }),
    openArea: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "rWaJtl"
    }),
    lotSizeM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "EQQRc5"
    }),
    type: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "+zy2Nq"
    })
};
const $22da792bf2f2765d$export$8bb58c0d41cc9934 = {
    purchasePrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "a7u1N9"
    }),
    rentalPrice: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "7aYzgc"
    }),
    bedroomCount: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "mMQSH4"
    }),
    roomCount: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "Fglnvp"
    }),
    size: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "Cj2Gtd"
    }),
    grossFloorArea: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "+lY7Ar"
    }),
    usableArea: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "IodKQ0"
    }),
    usableAreaI: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "M6Pl2B"
    }),
    usableAreaE: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "b7Fian"
    }),
    usableAreaB: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "Xs+IX4"
    }),
    openArea: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "rWaJtl"
    }),
    lotSizeM2: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "suo7tL"
    }),
    type: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
        id: "mG3RZE"
    })
};
const $22da792bf2f2765d$export$1320c989ad2b448 = ()=>({
        pets_allowed: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "/lAbub"
        }),
        roof_terrace: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "OQo3/D"
        }),
        no_residents: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "qFBgMp"
        }),
        caretaker: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "QWMjOn"
        }),
        fishing: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "IiMldu"
        }),
        swimming: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "uHafbT"
        }),
        trails: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "5jH2KN"
        }),
        ev_charging: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "oZkx0m"
        }),
        custodian: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "g8peZ2"
        }),
        fireplace: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "dTn+sm"
        }),
        child_friendly: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "hSN6Cn"
        }),
        elevator: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "lpREU8"
        }),
        central: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "NGf84j"
        }),
        parking: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "yacEUu"
        }),
        quiet: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "r1MpXi"
        }),
        view: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "jpctdh"
        }),
        garden: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "vvnngZ"
        }),
        balcony: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "F8iSVI"
        }),
        boat_parking: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "/f40S9"
        }),
        gym: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "z6a1pf"
        }),
        bike_parking: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "/oFfmS"
        }),
        storage_room: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "nYbYac"
        }),
        ground_terrace: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "k8+Gnx"
        }),
        wheelchair_accessible: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "r8qAvZ"
        }),
        pool: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "ou6PkF"
        }),
        keyless_entry: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "GKlmeQ"
        })
    });

});

parcelRegister("37CU7", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $535bf9b8a37e6985$export$e955abb82869dc84);

const $535bf9b8a37e6985$export$e955abb82869dc84 = (projectId)=>{
    const event = ({ type: type, unitUuid: unitUuid, additionalParameters: additionalParameters })=>{
        const analyticsPayload = {
            eventType: type,
            projectId: projectId
        };
        if (unitUuid) analyticsPayload.propertyId = unitUuid;
        if (additionalParameters) analyticsPayload.additionalParameters = additionalParameters;
        window.parent.postMessage(JSON.stringify({
            analyticsPayload: (0, $kIarK$decamelizeKeys)(analyticsPayload)
        }), '*');
    };
    return {
        event: event
    };
};

});

parcelRegister("bWmJ8", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $3238d528fa23d17d$export$37acb3580601e69a);



const $3238d528fa23d17d$var$themeMapping = {
    forSale: 'default',
    for_sale: 'default',
    sold: 'black',
    soldOut: 'portal',
    archived: 'black',
    reserved: 'warning',
    comingForSale: 'portal',
    coming_for_sale: 'portal',
    rented: 'black',
    forRent: 'fresh',
    for_rent: 'fresh'
};
const $3238d528fa23d17d$export$37acb3580601e69a = ({ type: type, value: value, className: className })=>{
    const isPartiallyOwned = type === 'partiallyOwned'; // Check if the badge type is `partiallyOwned`
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Tag), {
        "data-type": type,
        theme: $3238d528fa23d17d$var$themeMapping[type],
        className: (0, $kIarK$classnames)(isPartiallyOwned ? 'bg-[#ae68ba] text-white' : '', className),
        children: value
    });
};

});

parcelRegister("68z5m", function(module, exports) {
module.exports = import("./UnitModal.49b6734e.js").then(()=>parcelRequire('iGGuN'));

});

parcelRegister("dqNEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $58abf67c2a6fb8d4$export$2e2bcd8739ae039);

var $bGgiT = parcelRequire("bGgiT");
const $58abf67c2a6fb8d4$var$enabled = (()=>{
    try {
        return !!window.localStorage.getItem('pp-debug');
    } catch (e) {
        console.log(e);
        return false;
    }
})();
const $58abf67c2a6fb8d4$var$debug = (title, ...restParams)=>{
    if (!$58abf67c2a6fb8d4$var$enabled) return;
    const params = [
        `%c ${title}`,
        'background: #222; color: #bada55',
        '\n'
    ];
    if (restParams) params.push(restParams);
    console.log(...params);
};
try {
    if ($58abf67c2a6fb8d4$var$enabled) {
        const { version: version } = (0, (/*@__PURE__*/$parcel$interopDefault($bGgiT)));
        if (version) $58abf67c2a6fb8d4$var$debug('PropertyPicker:version', version);
    }
} catch (e) {
    console.error('Failed to start PP debugger', e);
}
var $58abf67c2a6fb8d4$export$2e2bcd8739ae039 = $58abf67c2a6fb8d4$var$debug;

});
parcelRegister("bGgiT", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@marketertechnologies/property-picker\",\"version\":\"2.137.1\",\"description\":\"\",\"author\":\"marketertechnologies\",\"license\":\"UNLICENSED\",\"sideEffects\":false,\"files\":[\"dist\"],\"source\":\"src/index.ts\",\"main\":\"dist/main.js\",\"module\":\"dist/module.js\",\"types\":\"dist/types.d.ts\",\"alias\":{\"react\":false,\"react-dom\":false},\"size-limit\":[{\"path\":\"dist/*.js\",\"limit\":\"200kb\"},{\"path\":\"dist/*.css\",\"limit\":\"200kb\"}],\"scripts\":{\"clean\":\"rimraf dist\",\"build\":\"yarn clean && run-p build:locales build:tailwind build:copyfonts build:sources\",\"build:locales\":\"lingui compile\",\"build:sources\":\"parcel build\",\"build:tailwind\":\"postcss src/index.css -o dist/index.min.css --minify\",\"build:copyfonts\":\"copyfiles -f src/fonts/* dist/fonts\",\"start\":\"yarn storybook\",\"format\":\"prettier --write \\\"src/**/*.{ts,tsx,json,js,jsx}\\\"\",\"format:check\":\"prettier --list-different \\\"src/**/*.{ts,tsx,json,js,jsx}\\\"\",\"lint\":\"run-p lint:script lint:style\",\"lint:script\":\"eslint ./src --ext .js,.jsx,.ts,.tsx\",\"lint:style\":\"stylelint 'src/**/*.css'\",\"circular-deps:check-src\":\"dpdm --no-warning --no-tree --exit-code circular:1 'src/**/*.ts'\",\"circular-deps:check-pw\":\"dpdm --no-warning --no-tree --exit-code circular:1 'playwright/**/*.ts'\",\"circular-deps:check\":\"yarn circular-deps:check-src && yarn circular-deps:check-pw\",\"storybook\":\"storybook dev -p 9001\",\"storybook:build\":\"storybook build -c .storybook -o public\",\"test\":\"jest --maxWorkers=2 --passWithNoTests\",\"test:watch\":\"yarn test --watch --passWithNoTests\",\"test:coverage\":\"jest --coverage --colors --maxWorkers=2 --passWithNoTests\",\"pw:test\":\"yarn playwright test\",\"pw:test-ui\":\"yarn playwright test --ui\",\"start:vite\":\"npx vite dev --host --port 5173 ./playwright --config ./vite.config.ts\",\"ci\":\"run-p lint format test\",\"extract-i18n\":\"lingui extract --clean --overwrite --verbose\",\"upload-english-strings\":\"po-editor upload\",\"download-translations\":\"po-editor download\",\"prepare\":\"husky\",\"size\":\"yarn build && size-limit\"},\"lint-staged\":{\"src/**/*.{ts,tsx,json,js,jsx}\":[\"yarn prettier --list-different\"]},\"publishConfig\":{\"registry\":\"https://npm.pkg.github.com\",\"access\":\"restricted\"},\"importSort\":{\".js, .jsx, .ts, .tsx\":{\"style\":\"@marketertechnologies/import-sort-style\",\"parser\":\"typescript\"}},\"prettier\":\"@marketertechnologies/prettier-config\",\"dependencies\":{\"@floating-ui/react\":\"^0.26.23\",\"@lingui/core\":\"^5.2.0\",\"@lingui/macro\":\"^5.2.0\",\"@lingui/react\":\"^5.2.0\",\"@marketertechnologies/ui-library\":\"5.0.0\",\"@phosphor-icons/react\":\"^2.0.15\",\"@react-hook/resize-observer\":\"^1.2.6\",\"bowser\":\"^2.11.0\",\"chroma-js\":\"^2.4.2\",\"classnames\":\"^2.5.1\",\"d3\":\"^7.8.5\",\"dashify\":\"^2.0.0\",\"final-form\":\"^4.20.10\",\"humps\":\"^2.0.1\",\"lodash.debounce\":\"^4.0.8\",\"lodash.memoize\":\"^4.1.2\",\"ramda\":\"^0.29.1\",\"react-final-form\":\"^6.5.9\",\"react-modal\":\"^3.16.1\",\"react-number-format\":\"^5.3.3\",\"react-responsive\":\"9.0.2\",\"swiper\":\"^11.1.4\",\"tailwind-clip-path\":\"^1.0.0\",\"tailwind-merge\":\"^3.3.0\",\"yet-another-react-lightbox\":\"^3.21.8\",\"zustand\":\"^4.5.4\"},\"peerDependencies\":{\"react\":\"^18.3.1\",\"react-dom\":\"^18.3.1\"},\"devDependencies\":{\"@commitlint/cli\":\"^19.1.0\",\"@commitlint/config-conventional\":\"^19.1.0\",\"@faker-js/faker\":\"^9.6.0\",\"@lingui/babel-plugin-lingui-macro\":\"^5.2.0\",\"@lingui/cli\":\"^5.2.0\",\"@lingui/swc-plugin\":\"^5.5.0\",\"@lingui/vite-plugin\":\"^5.2.0\",\"@marketertechnologies/eslint-config\":\"^0.7.1\",\"@marketertechnologies/po-editor-scripts\":\"^1.0.7\",\"@marketertechnologies/prettier-config\":\"^0.7.0\",\"@parcel/compressor-brotli\":\"^2.13.3\",\"@parcel/compressor-gzip\":\"^2.13.3\",\"@parcel/packager-ts\":\"^2.13.3\",\"@parcel/reporter-bundle-analyzer\":\"^2.13.3\",\"@parcel/transformer-typescript-types\":\"^2.13.3\",\"@playwright/test\":\"1.53\",\"@size-limit/preset-app\":\"^11.1.3\",\"@storybook/addon-docs\":\"^9.0.15\",\"@storybook/addon-links\":\"^9.0.15\",\"@storybook/addon-onboarding\":\"^9.0.15\",\"@storybook/cli\":\"^9.0.15\",\"@storybook/react-vite\":\"^9.0.15\",\"@tailwindcss/nesting\":\"^0.0.0-insiders.565cd3e\",\"@tailwindcss/postcss\":\"^4.1.8\",\"@tanstack/react-query\":\"^5.75.2\",\"@testing-library/jest-dom\":\"^6.4.2\",\"@testing-library/react\":\"^14.2.1\",\"@trivago/prettier-plugin-sort-imports\":\"^5.2.2\",\"@types/classnames\":\"^2.3.0\",\"@types/d3\":\"^7.4.3\",\"@types/dashify\":\"^1.0.3\",\"@types/humps\":\"^2.0.6\",\"@types/jest\":\"^29.5.12\",\"@types/lodash\":\"^4.17.16\",\"@types/lodash.debounce\":\"^4.0.9\",\"@types/node\":\"^22\",\"@types/ramda\":\"^0.29.11\",\"@types/react\":\"^18.2.65\",\"@types/react-dom\":\"^18.2.21\",\"@types/react-modal\":\"^3.16.3\",\"@vitejs/plugin-react\":\"^4.3.4\",\"autoprefixer\":\"^10.4.21\",\"axios\":\"^1.8.2\",\"babel-plugin-macros\":\"^3.0.1\",\"conventional-changelog-conventionalcommits\":\"^7.0.2\",\"copyfiles\":\"^2.4.1\",\"cross-env\":\"^7.0.3\",\"cssnano\":\"^7.0.4\",\"dpdm\":\"^3.14.0\",\"eslint\":\"^8.57.0\",\"eslint-plugin-storybook\":\"^9.0.15\",\"http-server\":\"^14.1.1\",\"husky\":\"^9.1.1\",\"identity-obj-proxy\":\"^3.0.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"jira-prepare-commit-msg\":\"^1.7.2\",\"lint-staged\":\"^15.2.8\",\"lodash\":\"^4.17.21\",\"node-forge\":\"^1.3.1\",\"npm-run-all\":\"^4.1.5\",\"parcel\":\"^2.13.3\",\"parcel-resolver-tspaths\":\"^0.0.9\",\"postcss\":\"^8.5.4\",\"postcss-cli\":\"^11.0.1\",\"prettier-plugin-tailwindcss\":\"^0.6.11\",\"react\":\"^18.3.1\",\"react-dom\":\"^18.3.1\",\"rimraf\":\"^6.0.1\",\"simplify-geometry\":\"^0.0.2\",\"size-limit\":\"^11.1.3\",\"storybook\":\"^9.0.15\",\"storybook-css-modules\":\"^1.0.8\",\"stylelint\":\"^16.18.0\",\"stylelint-config-standard\":\"^36.0.0\",\"stylelint-scss\":\"^6.11.1\",\"tailwindcss\":\"^4.1.8\",\"ts-jest\":\"^29.4.0\",\"ts-node\":\"^10.9.2\",\"tsconfig-replace-paths\":\"^0.0.14\",\"typescript\":\"5.7.2\",\"typescript-plugin-css-modules\":\"^5.1.0\",\"vite\":\"^7.0.2\",\"vite-bundle-visualizer\":\"^1.1.0\",\"vite-plugin-checker\":\"^0.9.0\"},\"resolutions\":{\"postcss-calc\":\"10.1.1\"},\"jira-prepare-commit-msg\":{\"messagePattern\":\"[$J] $M\",\"jiraTicketPattern\":\"(MT(\\\\d+)?-\\\\d+)\",\"commentChar\":\"#\",\"isConventionalCommit\":false,\"allowEmptyCommitMessage\":false,\"gitRoot\":\"\"},\"engines\":{\"node\":\">=22.11.0\",\"yarn\":\">=1.22.10\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/marketertechnologies/property-picker.git\"}}");

});


parcelRegister("f9meZ", function(module, exports) {

$parcel$export(module.exports, "useIsMobile", () => $602b36157e55938b$export$2b96349243a56116);

const $602b36157e55938b$export$2b96349243a56116 = ()=>(0, $kIarK$useMediaQuery)({
        maxWidth: 1023
    });

});

parcelRegister("1LB4H", function(module, exports) {

$parcel$export(module.exports, "ModalSkeleton", () => $a787b5256506e4f7$export$ba38383f4d71feb1);









var $cOQJC = parcelRequire("cOQJC");

var $d9U4a = parcelRequire("d9U4a");

var $f9meZ = parcelRequire("f9meZ");

var $hWdtT = parcelRequire("hWdtT");
const $a787b5256506e4f7$export$ba38383f4d71feb1 = (props)=>{
    const { backLabel: backLabel, withClose: withClose, title: title, show: show, isLoading: isLoading, onClose: onClose, children: children, testId: testId, closeTimeoutMS: closeTimeoutMS = 0, right: right, style: style = {}, className: className } = props;
    const isMobile = (0, $f9meZ.useIsMobile)();
    const modalStyles = (0, $kIarK$mergeDeepRight)(isMobile ? (0, $hWdtT.mobileStyles) : (0, $hWdtT.desktopStyles), style);
    const tid = (0, $kIarK$useTestId)('modal');
    const bodyPaddingRef = (0, $kIarK$useRef)(0);
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$reactmodal), {
        testId: testId,
        isOpen: show,
        shouldCloseOnOverlayClick: true,
        closeTimeoutMS: closeTimeoutMS,
        ariaHideApp: false,
        style: modalStyles,
        onRequestClose: onClose,
        onAfterOpen: ()=>{
            bodyPaddingRef.current = (0, $cOQJC.getBodyPadding)();
            document.body.style.paddingRight = `${(0, $d9U4a.getScrollbarWidth)() + bodyPaddingRef.current}px`;
            document.body.style.overflow = 'hidden';
        },
        onAfterClose: ()=>{
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = `${bodyPaddingRef.current}px`;
        },
        children: /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
            onClick: (e)=>e.stopPropagation(),
            className: (0, $kIarK$classnames)('inset-0 m-0 flex h-auto flex-col', className),
            children: [
                /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                    className: "border-custom-ui-70 flex w-full items-center justify-between border-b px-3 py-2",
                    ...tid('title'),
                    children: [
                        backLabel ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                            onClick: onClose,
                            testId: tid('back-button')['data-testid'],
                            theme: "transparentDark",
                            icon: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$CaretLeft), {
                                size: 16
                            }),
                            className: "pl-1",
                            children: backLabel
                        }) : null,
                        title,
                        right,
                        withClose ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                            onClick: onClose,
                            icon: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$X), {
                                size: 16
                            }),
                            theme: "transparentDark",
                            className: "pr-1",
                            children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                                id: "yz7wBu"
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                    className: "flex w-full grow items-center justify-center",
                    children: children
                }),
                isLoading ? /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                    className: "absolute inset-0 m-auto h-full w-full",
                    style: {
                        backgroundColor: (0, $hWdtT.baseModalStyles).overlay.backgroundColor
                    },
                    children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Spinner), {
                        size: 10,
                        weight: "medium",
                        className: "absolute inset-0"
                    })
                }) : null
            ]
        })
    });
};

});
parcelRegister("cOQJC", function(module, exports) {

$parcel$export(module.exports, "getBodyPadding", () => $168e4a3e2ca96197$export$b05946372741938c);

var $dqNEo = parcelRequire("dqNEo");
const $168e4a3e2ca96197$export$b05946372741938c = ()=>{
    try {
        return parseFloat(window.getComputedStyle(document.body).getPropertyValue('padding-right').match(/\d+/)[0]);
    } catch (err) {
        (0, $dqNEo.default)(err);
        return 0;
    }
};

});

parcelRegister("d9U4a", function(module, exports) {

$parcel$export(module.exports, "getScrollbarWidth", () => $9f2afd5c3bb44ef3$export$ace028f8da1a6300);
function $9f2afd5c3bb44ef3$export$ace028f8da1a6300() {
    const html = document.documentElement;
    const isScrollable = html.scrollHeight > html.clientHeight;
    if (!isScrollable) return 0;
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}

});

parcelRegister("hWdtT", function(module, exports) {

$parcel$export(module.exports, "baseModalStyles", () => $07111b96e088eb58$export$896c2ff10d240ad8);
$parcel$export(module.exports, "desktopStyles", () => $07111b96e088eb58$export$483ff17aed57bd5a);
$parcel$export(module.exports, "mobileStyles", () => $07111b96e088eb58$export$721e179e65e1c3b8);
$parcel$export(module.exports, "shareAndRegisterDesktopStyles", () => $07111b96e088eb58$export$edd8bc7b8fdeeac3);
const $07111b96e088eb58$export$896c2ff10d240ad8 = {
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.3)',
        zIndex: 600
    },
    content: {
        maxHeight: '100%',
        background: 'var(--color-ui-100)',
        border: '0',
        borderRadius: 'var(--rounded-m)',
        padding: '0',
        color: 'var(--color-ui-100-text-primary)',
        boxSizing: 'border-box'
    }
};
const $07111b96e088eb58$export$483ff17aed57bd5a = {
    overlay: $07111b96e088eb58$export$896c2ff10d240ad8.overlay,
    content: {
        ...$07111b96e088eb58$export$896c2ff10d240ad8.content,
        height: 'fit-content',
        width: '95vw',
        maxHeight: '95vh',
        outline: 'none',
        inset: '50% 0 0 50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        backfaceVisibility: 'hidden'
    }
};
const $07111b96e088eb58$export$721e179e65e1c3b8 = {
    overlay: $07111b96e088eb58$export$896c2ff10d240ad8.overlay,
    content: {
        ...$07111b96e088eb58$export$896c2ff10d240ad8.content,
        maxWidth: '100vw',
        height: '100%',
        margin: '0',
        outline: 'none',
        display: 'flex',
        flexDirection: 'column',
        inset: 0
    }
};
const $07111b96e088eb58$export$edd8bc7b8fdeeac3 = {
    content: {
        width: 'fit-content'
    }
};

});


parcelRegister("8TOsp", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $f8fd86a9e1315ad2$export$ac16a6a04d9b7c84);


const $f8fd86a9e1315ad2$export$ac16a6a04d9b7c84 = (props)=>{
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
        ...props,
        theme: "custom"
    });
};

});

parcelRegister("1KlOg", function(module, exports) {

$parcel$export(module.exports, "active", () => $145b014457f2de77$export$89da14300d534261, (v) => $145b014457f2de77$export$89da14300d534261 = v);
$parcel$export(module.exports, "archived", () => $145b014457f2de77$export$8408853b8ba2a5a4, (v) => $145b014457f2de77$export$8408853b8ba2a5a4 = v);
$parcel$export(module.exports, "availableHover", () => $145b014457f2de77$export$dec0e0405bbf5345, (v) => $145b014457f2de77$export$dec0e0405bbf5345 = v);
$parcel$export(module.exports, "card", () => $145b014457f2de77$export$aa3e815946b80764, (v) => $145b014457f2de77$export$aa3e815946b80764 = v);
$parcel$export(module.exports, "comingForSale", () => $145b014457f2de77$export$a74cfd3009711dba, (v) => $145b014457f2de77$export$a74cfd3009711dba = v);
$parcel$export(module.exports, "expanded", () => $145b014457f2de77$export$52105d146316f63c, (v) => $145b014457f2de77$export$52105d146316f63c = v);
$parcel$export(module.exports, "floorplan", () => $145b014457f2de77$export$bc65d6a1962f268f, (v) => $145b014457f2de77$export$bc65d6a1962f268f = v);
$parcel$export(module.exports, "focused", () => $145b014457f2de77$export$4c2b230493b2b322, (v) => $145b014457f2de77$export$4c2b230493b2b322 = v);
$parcel$export(module.exports, "forRent", () => $145b014457f2de77$export$617df37ed63f1cd2, (v) => $145b014457f2de77$export$617df37ed63f1cd2 = v);
$parcel$export(module.exports, "forSale", () => $145b014457f2de77$export$d30623bd736fd295, (v) => $145b014457f2de77$export$d30623bd736fd295 = v);
$parcel$export(module.exports, "hovered", () => $145b014457f2de77$export$e5ef4f853dad983a, (v) => $145b014457f2de77$export$e5ef4f853dad983a = v);
$parcel$export(module.exports, "isLoading", () => $145b014457f2de77$export$20bb0d907fbbe433, (v) => $145b014457f2de77$export$20bb0d907fbbe433 = v);
$parcel$export(module.exports, "loading", () => $145b014457f2de77$export$46c1c92549715335, (v) => $145b014457f2de77$export$46c1c92549715335 = v);
$parcel$export(module.exports, "navigation", () => $145b014457f2de77$export$428e7c787d57587d, (v) => $145b014457f2de77$export$428e7c787d57587d = v);
$parcel$export(module.exports, "overlay", () => $145b014457f2de77$export$29dd17c7f3c81c36, (v) => $145b014457f2de77$export$29dd17c7f3c81c36 = v);
$parcel$export(module.exports, "partiallyOwned", () => $145b014457f2de77$export$85ca6a66fcca6ab0, (v) => $145b014457f2de77$export$85ca6a66fcca6ab0 = v);
$parcel$export(module.exports, "pointerDown", () => $145b014457f2de77$export$e6e29dfeb5ef19c1, (v) => $145b014457f2de77$export$e6e29dfeb5ef19c1 = v);
$parcel$export(module.exports, "polygon", () => $145b014457f2de77$export$b7b19aa0ee06c73, (v) => $145b014457f2de77$export$b7b19aa0ee06c73 = v);
$parcel$export(module.exports, "pulse", () => $145b014457f2de77$export$f3aaf94dc96a60de, (v) => $145b014457f2de77$export$f3aaf94dc96a60de = v);
$parcel$export(module.exports, "rented", () => $145b014457f2de77$export$91097e02e0ed3a97, (v) => $145b014457f2de77$export$91097e02e0ed3a97 = v);
$parcel$export(module.exports, "reserved", () => $145b014457f2de77$export$e46d647da3214494, (v) => $145b014457f2de77$export$e46d647da3214494 = v);
$parcel$export(module.exports, "rotate", () => $145b014457f2de77$export$bb628a54ab399bc9, (v) => $145b014457f2de77$export$bb628a54ab399bc9 = v);
$parcel$export(module.exports, "scene", () => $145b014457f2de77$export$33aff30b8aa0934e, (v) => $145b014457f2de77$export$33aff30b8aa0934e = v);
$parcel$export(module.exports, "scenesContainer", () => $145b014457f2de77$export$61f7c4ac80a64bcb, (v) => $145b014457f2de77$export$61f7c4ac80a64bcb = v);
$parcel$export(module.exports, "slide", () => $145b014457f2de77$export$c1742949d0193489, (v) => $145b014457f2de77$export$c1742949d0193489 = v);
$parcel$export(module.exports, "sold", () => $145b014457f2de77$export$947009bbfded9491, (v) => $145b014457f2de77$export$947009bbfded9491 = v);
$parcel$export(module.exports, "tooltip", () => $145b014457f2de77$export$4e6f96734dfe12f4, (v) => $145b014457f2de77$export$4e6f96734dfe12f4 = v);
$parcel$export(module.exports, "visual", () => $145b014457f2de77$export$496f218b657bbde0, (v) => $145b014457f2de77$export$496f218b657bbde0 = v);
$parcel$export(module.exports, "withBorderColor", () => $145b014457f2de77$export$6138d5c07cfc0c7a, (v) => $145b014457f2de77$export$6138d5c07cfc0c7a = v);
$parcel$export(module.exports, "withBorderColorHover", () => $145b014457f2de77$export$19c2b3a7902c70bc, (v) => $145b014457f2de77$export$19c2b3a7902c70bc = v);
$parcel$export(module.exports, "withFillColor", () => $145b014457f2de77$export$58bb4bf3a1ba83b3, (v) => $145b014457f2de77$export$58bb4bf3a1ba83b3 = v);
$parcel$export(module.exports, "withFillColorHover", () => $145b014457f2de77$export$a7e30f833f9efbb8, (v) => $145b014457f2de77$export$a7e30f833f9efbb8 = v);
var $145b014457f2de77$export$89da14300d534261;
var $145b014457f2de77$export$8408853b8ba2a5a4;
var $145b014457f2de77$export$dec0e0405bbf5345;
var $145b014457f2de77$export$aa3e815946b80764;
var $145b014457f2de77$export$a74cfd3009711dba;
var $145b014457f2de77$export$52105d146316f63c;
var $145b014457f2de77$export$bc65d6a1962f268f;
var $145b014457f2de77$export$4c2b230493b2b322;
var $145b014457f2de77$export$617df37ed63f1cd2;
var $145b014457f2de77$export$d30623bd736fd295;
var $145b014457f2de77$export$e5ef4f853dad983a;
var $145b014457f2de77$export$20bb0d907fbbe433;
var $145b014457f2de77$export$46c1c92549715335;
var $145b014457f2de77$export$428e7c787d57587d;
var $145b014457f2de77$export$29dd17c7f3c81c36;
var $145b014457f2de77$export$85ca6a66fcca6ab0;
var $145b014457f2de77$export$e6e29dfeb5ef19c1;
var $145b014457f2de77$export$b7b19aa0ee06c73;
var $145b014457f2de77$export$f3aaf94dc96a60de;
var $145b014457f2de77$export$91097e02e0ed3a97;
var $145b014457f2de77$export$e46d647da3214494;
var $145b014457f2de77$export$bb628a54ab399bc9;
var $145b014457f2de77$export$33aff30b8aa0934e;
var $145b014457f2de77$export$61f7c4ac80a64bcb;
var $145b014457f2de77$export$c1742949d0193489;
var $145b014457f2de77$export$947009bbfded9491;
var $145b014457f2de77$export$4e6f96734dfe12f4;
var $145b014457f2de77$export$496f218b657bbde0;
var $145b014457f2de77$export$6138d5c07cfc0c7a;
var $145b014457f2de77$export$19c2b3a7902c70bc;
var $145b014457f2de77$export$58bb4bf3a1ba83b3;
var $145b014457f2de77$export$a7e30f833f9efbb8;
$145b014457f2de77$export$89da14300d534261 = `t15U2q_active`;
$145b014457f2de77$export$8408853b8ba2a5a4 = `t15U2q_archived`;
$145b014457f2de77$export$dec0e0405bbf5345 = `t15U2q_availableHover`;
$145b014457f2de77$export$aa3e815946b80764 = `t15U2q_card`;
$145b014457f2de77$export$a74cfd3009711dba = `t15U2q_comingForSale`;
$145b014457f2de77$export$52105d146316f63c = `t15U2q_expanded`;
$145b014457f2de77$export$bc65d6a1962f268f = `t15U2q_floorplan`;
$145b014457f2de77$export$4c2b230493b2b322 = `t15U2q_focused`;
$145b014457f2de77$export$617df37ed63f1cd2 = `t15U2q_forRent`;
$145b014457f2de77$export$d30623bd736fd295 = `t15U2q_forSale`;
$145b014457f2de77$export$e5ef4f853dad983a = `t15U2q_hovered`;
$145b014457f2de77$export$20bb0d907fbbe433 = `t15U2q_isLoading`;
$145b014457f2de77$export$46c1c92549715335 = `t15U2q_loading`;
$145b014457f2de77$export$428e7c787d57587d = `t15U2q_navigation`;
$145b014457f2de77$export$29dd17c7f3c81c36 = `t15U2q_overlay`;
$145b014457f2de77$export$85ca6a66fcca6ab0 = `t15U2q_partiallyOwned`;
$145b014457f2de77$export$e6e29dfeb5ef19c1 = `t15U2q_pointerDown`;
$145b014457f2de77$export$b7b19aa0ee06c73 = `t15U2q_polygon`;
$145b014457f2de77$export$f3aaf94dc96a60de = `t15U2q_pulse`;
$145b014457f2de77$export$f3aaf94dc96a60de;
$145b014457f2de77$export$91097e02e0ed3a97 = `t15U2q_rented`;
$145b014457f2de77$export$e46d647da3214494 = `t15U2q_reserved`;
$145b014457f2de77$export$bb628a54ab399bc9 = `t15U2q_rotate`;
$145b014457f2de77$export$33aff30b8aa0934e = `t15U2q_scene`;
$145b014457f2de77$export$61f7c4ac80a64bcb = `t15U2q_scenesContainer`;
$145b014457f2de77$export$c1742949d0193489 = `t15U2q_slide`;
$145b014457f2de77$export$c1742949d0193489;
$145b014457f2de77$export$947009bbfded9491 = `t15U2q_sold`;
$145b014457f2de77$export$4e6f96734dfe12f4 = `t15U2q_tooltip`;
$145b014457f2de77$export$496f218b657bbde0 = `t15U2q_visual`;
$145b014457f2de77$export$6138d5c07cfc0c7a = `t15U2q_withBorderColor`;
$145b014457f2de77$export$19c2b3a7902c70bc = `t15U2q_withBorderColorHover`;
$145b014457f2de77$export$58bb4bf3a1ba83b3 = `t15U2q_withFillColor`;
$145b014457f2de77$export$a7e30f833f9efbb8 = `t15U2q_withFillColorHover`;

});

parcelRegister("4A1DC", function(module, exports) {

$parcel$export(module.exports, "getPolygonColorProperties", () => $585f818f59ac82e1$export$a2495950cf2eca59);

const $585f818f59ac82e1$export$a2495950cf2eca59 = ({ settings: settings, element: element })=>{
    // TODO: https://marketer.atlassian.net/browse/MT3-6795
    const state = element.state == 'archived' ? 'sold' : element.state;
    return settings.settings?.polygonColorProperties?.[element.type]?.[(0, $kIarK$camelize)(state)] ?? {};
};

});

parcelRegister("9APwq", function(module, exports) {

$parcel$export(module.exports, "getPolygonAttributes", () => $a79a2c5d247b85a9$export$7446903f21faa651);




var $1KlOg = parcelRequire("1KlOg");
const $a79a2c5d247b85a9$export$593691da9aee0e1 = (pred, list)=>list.reduce((accum, value)=>{
        const previousSegments = accum.slice(0, -1) || [];
        const currentSegment = accum[accum.length - 1] || [];
        return pred(value) ? [
            ...previousSegments,
            currentSegment,
            [
                value
            ]
        ] : [
            ...previousSegments,
            [
                ...currentSegment,
                value
            ]
        ];
    }, []).filter((segment)=>segment.length);
const $a79a2c5d247b85a9$export$9f070f529898fbe7 = (list)=>$a79a2c5d247b85a9$export$593691da9aee0e1((0, $kIarK$compose)((0, $kIarK$equals)('M'), (0, $kIarK$prop)('cmd')), list);
const $a79a2c5d247b85a9$export$7446903f21faa651 = (props)=>{
    const { element: element, points: points, colorProperties: colorProperties = {}, showPartiallyOwnedStatus: showPartiallyOwnedStatus } = props;
    const { fillColor: fillColor = true, fillColorHover: fillColorHover = true, borderColor: borderColor = true, borderColorHover: borderColorHover = true } = colorProperties;
    const className = (0, $kIarK$classnames)((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).polygon, `polygon-${element.uuid}`, (0, (/*@__PURE__*/$parcel$interopDefault($1KlOg)))[(0, $kIarK$camelize)(element.state)], element.notAvailable ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).availableHover, element.partiallyOwned && showPartiallyOwnedStatus && element.state !== 'sold' && element.state !== 'archived' ? (0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).partiallyOwned : null, {
        [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).withFillColor]: fillColor,
        [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).withFillColorHover]: fillColorHover,
        [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).withBorderColor]: borderColor,
        [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).withBorderColorHover]: borderColorHover
    });
    return {
        className: className,
        definitions: $a79a2c5d247b85a9$export$b3de42a4248587ef(points)
    };
};
const $a79a2c5d247b85a9$export$b3de42a4248587ef = (points)=>$a79a2c5d247b85a9$export$9f070f529898fbe7(points).map((points)=>points.reduce((acc, curr, index)=>{
            const { x: x, y: y } = curr;
            const cmd = index === 0 ? 'M' : curr.cmd ?? 'L';
            const command = `${cmd}${x},${y}`;
            return acc.concat(`${command} `);
        }, '')).map((def)=>`${def}Z`);

});

parcelRegister("647nY", function(module, exports) {

$parcel$export(module.exports, "shouldRenderPolygon", () => $7a63b4398467c973$export$1ea8fb8f5ff85428);
const $7a63b4398467c973$export$1ea8fb8f5ff85428 = (args)=>{
    const { reference: reference } = args;
    if (reference.points.length < 3) return false;
    return true;
};

});

parcelRegister("6SLKk", function(module, exports) {

$parcel$export(module.exports, "Card", () => $d359754011608e37$export$60332b2344f7fe41);






var $bWmJ8 = parcelRequire("bWmJ8");
const $d359754011608e37$export$60332b2344f7fe41 = (props)=>{
    (0, $kIarK$useLingui)();
    const { sections: sections, children: children, isDisabled: isDisabled, isError: isError, isHover: isHover, imageURL: imageURL, withBorder: withBorder = false, className: className, ctaLabel: ctaLabel, onClick: onClick, shouldFullClick: shouldFullClick, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter } = props;
    const handleClick = shouldFullClick && onClick ? onClick : ()=>{};
    const cardClasses = [
        'flex',
        'flex-col',
        'p-4',
        'bg-custom-background',
        'whitespace-pre-wrap',
        withBorder ? 'border border-s border-[#e6e6e6] rounded-l' : '',
        isHover ? 'hover:border-primary-50' : '',
        isDisabled ? 'border-ui-90 cursor-default' : '',
        isError ? 'cursor-default opacity-60' : '',
        className
    ].filter(Boolean).join(' ');
    const tid = (0, $kIarK$useTestId)('card');
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        ...tid('root'),
        className: (0, $kIarK$classnames)(cardClasses),
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter,
        onClick: handleClick,
        children: [
            sections && sections.filter(Boolean).map((section, index)=>/*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                    className: "border-custom-ui-90 border-b last:border-none",
                    children: [
                        section.label ? /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                            className: (0, $kIarK$classnames)('flex w-full gap-[0.5px]', section.label.badges ? 'justify-between' : 'flex-col'),
                            ...tid('header'),
                            children: [
                                /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                                    className: "text-m text-custom-text-dark-primary truncate leading-[22px] font-normal",
                                    children: section.label.label
                                }),
                                /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                                    className: "text-custom-ui-100-secondary gap-m flex text-xl leading-[26px] font-medium",
                                    children: section.label.badges ? section.label.badges.map((badge)=>/*#__PURE__*/ (0, $kIarK$jsx)((0, $bWmJ8.Badge), {
                                            ...badge
                                        }, badge.type)) : section.label.displayValue
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                            className: "flex flex-col py-4",
                            ...tid('property-list'),
                            children: Object.entries(section.properties).filter((entry)=>entry[1]).map(([id, row])=>/*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                                    className: "grid grid-cols-2",
                                    "data-testid": `${row.label?.toLowerCase()}-row`,
                                    children: [
                                        /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                                            className: "text-custom-ui-100-primary text-m leading-[22px] font-normal",
                                            "data-testid": `${row.label?.toLowerCase()}-label`,
                                            children: row.label ? `${row.label}:` : null
                                        }),
                                        /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                                            className: (0, $kIarK$classnames)('text-custom-ui-100-secondary text-m leading-[22px] font-medium', id === 'description' ? 'line-clamp-2' : ''),
                                            "data-testid": `${row.label?.toLowerCase()}-value`,
                                            children: row.displayValue || '-'
                                        })
                                    ]
                                }, id))
                        })
                    ]
                }, index)),
            imageURL ? /*#__PURE__*/ (0, $kIarK$jsx)("img", {
                src: imageURL,
                className: "max-w-full rounded-xl",
                alt: (0, $kIarK$i18n)._(/*i18n*/ {
                    id: "vCYnNv"
                }),
                ...tid('target-scene-img-preview')
            }) : null,
            ctaLabel && onClick && !isError && !isDisabled ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                onClick: onClick,
                testId: "card-button",
                theme: "oxford",
                size: "small",
                children: ctaLabel
            }) : null,
            children
        ]
    });
};

});

parcelRegister("eqIVn", function(module, exports) {

$parcel$export(module.exports, "getContentTypes", () => $09081693b7f8ac9c$export$e930ef3a1ad21ec4);
const $09081693b7f8ac9c$export$e930ef3a1ad21ec4 = (unitPlanTypes)=>{
    const hasImage = unitPlanTypes.includes('image');
    const hasPdf = unitPlanTypes.includes('pdf');
    if (hasImage && hasPdf) return null;
    if (hasImage) return [
        'image/jpeg',
        'image/png',
        'image/webp'
    ];
    if (hasPdf) return [
        'application/pdf'
    ];
    return null;
};

});

parcelRegister("6wwRp", function(module, exports) {

$parcel$export(module.exports, "LinguiProvider", () => $e8b1f13a256ce0d3$export$5eb22588c386efa7);




parcelRequire("03tHb");
var $2FtpP = parcelRequire("2FtpP");

var $40UfZ = parcelRequire("40UfZ");

var $cXa8C = parcelRequire("cXa8C");

var $1bFbh = parcelRequire("1bFbh");

var $5DRrY = parcelRequire("5DRrY");

var $aDutZ = parcelRequire("aDutZ");

var $8GmNf = parcelRequire("8GmNf");

var $9cyvU = parcelRequire("9cyvU");
(0, $kIarK$i18n).load({
    en: (0, $cXa8C.messages),
    no: (0, $8GmNf.messages),
    fr: (0, $5DRrY.messages),
    de: (0, $40UfZ.messages),
    nl: (0, $aDutZ.messages),
    fi: (0, $1bFbh.messages),
    sv: (0, $9cyvU.messages)
});
const $e8b1f13a256ce0d3$export$5eb22588c386efa7 = ({ children: children, lang: lang })=>{
    (0, $kIarK$useEffect)(()=>{
        const isLanguageSupported = (0, $2FtpP.supportedUILanguages).includes(lang);
        const uiLanguage = isLanguageSupported ? lang : 'en';
        (0, $kIarK$i18n).activate(uiLanguage);
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$I18nProvider), {
        i18n: (0, $kIarK$i18n),
        children: children
    });
};

});
parcelRegister("03tHb", function(module, exports) {

var $hGnqz = parcelRequire("hGnqz");

var $hboHB = parcelRequire("hboHB");

var $1isp0 = parcelRequire("1isp0");

var $4l8zw = parcelRequire("4l8zw");

var $982iL = parcelRequire("982iL");

var $b1GU3 = parcelRequire("b1GU3");

var $eYvp0 = parcelRequire("eYvp0");

var $2FtpP = parcelRequire("2FtpP");

var $1csXF = parcelRequire("1csXF");
$parcel$exportWildcard(module.exports, $hGnqz);
$parcel$exportWildcard(module.exports, $hboHB);
$parcel$exportWildcard(module.exports, $1isp0);
$parcel$exportWildcard(module.exports, $4l8zw);
$parcel$exportWildcard(module.exports, $982iL);
$parcel$exportWildcard(module.exports, $b1GU3);
$parcel$exportWildcard(module.exports, $eYvp0);
$parcel$exportWildcard(module.exports, $2FtpP);
$parcel$exportWildcard(module.exports, $1csXF);

});
parcelRegister("hGnqz", function(module, exports) {

$parcel$export(module.exports, "saleStates", () => $f1a29ef58a0b983e$export$28f3bb13af512577);
$parcel$export(module.exports, "availableUnitStates", () => $f1a29ef58a0b983e$export$ec55e7edc35ff440);
$parcel$export(module.exports, "unavailableUnitStates", () => $f1a29ef58a0b983e$export$f978264a445a9948);
$parcel$export(module.exports, "unitStates", () => $f1a29ef58a0b983e$export$947ceeb5312d4f1f);
const $f1a29ef58a0b983e$export$28f3bb13af512577 = [
    'under_development',
    'coming_for_sale',
    'for_sale',
    'for_rent'
];
const $f1a29ef58a0b983e$export$ec55e7edc35ff440 = [
    'for_sale',
    'for_rent'
];
const $f1a29ef58a0b983e$export$f978264a445a9948 = [
    'coming_for_sale',
    'reserved',
    'rented',
    'sold',
    'sold_out',
    'archived'
];
const $f1a29ef58a0b983e$export$947ceeb5312d4f1f = [
    ...$f1a29ef58a0b983e$export$ec55e7edc35ff440,
    ...$f1a29ef58a0b983e$export$f978264a445a9948
];

});

parcelRegister("hboHB", function(module, exports) {

});

parcelRegister("1isp0", function(module, exports) {

});

parcelRegister("4l8zw", function(module, exports) {

$parcel$export(module.exports, "isBadgeType", () => $2c72fc00c5c70175$export$f1e8f31da7383564);
const $2c72fc00c5c70175$var$badgeTypes = [
    'comingForSale',
    'forSale',
    'archived',
    'reserved',
    'sold',
    'soldOut',
    'partiallyOwned',
    'rented',
    'forRent'
];
const $2c72fc00c5c70175$export$f1e8f31da7383564 = (value)=>$2c72fc00c5c70175$var$badgeTypes.includes(value);

});

parcelRegister("982iL", function(module, exports) {

});

parcelRegister("b1GU3", function(module, exports) {

});

parcelRegister("eYvp0", function(module, exports) {

$parcel$export(module.exports, "filterTypes", () => $aabc524a7210db72$export$18932e8706af151c);
$parcel$export(module.exports, "FilterToPropertyMap", () => $aabc524a7210db72$export$76a1f5f3b098ab67);
$parcel$export(module.exports, "norwegianFilters", () => $aabc524a7210db72$export$1c961c4c1212e7ea);
$parcel$export(module.exports, "rangeFilters", () => $aabc524a7210db72$export$25629b43b3340b0f);
$parcel$export(module.exports, "checkboxFilters", () => $aabc524a7210db72$export$430b53e6132181a7);
$parcel$export(module.exports, "booleanFilters", () => $aabc524a7210db72$export$fe1b9a1a77be3bc5);
$parcel$export(module.exports, "isNorwegianFilter", () => $aabc524a7210db72$export$742c4abf52faf26e);
const $aabc524a7210db72$export$18932e8706af151c = [
    'purchasePrice',
    'rentalPrice',
    'size',
    'bedroomCount',
    'roomCount',
    'usableArea',
    'usableAreaI',
    'usableAreaE',
    'usableAreaB',
    'openArea',
    'lotSizeM2',
    'grossFloorArea',
    'type',
    'showSoldUnits'
];
const $aabc524a7210db72$export$76a1f5f3b098ab67 = {
    size: 'sizeM2',
    usableArea: 'usableAreaM2',
    grossFloorArea: 'grossFloorAreaM2'
};
const $aabc524a7210db72$export$1c961c4c1212e7ea = [
    'usableAreaI',
    'usableAreaE',
    'usableAreaB',
    'openArea'
];
const $aabc524a7210db72$export$25629b43b3340b0f = [
    'purchasePrice',
    'rentalPrice',
    'bedroomCount',
    'roomCount',
    'size',
    'usableArea',
    'usableAreaI',
    'usableAreaE',
    'usableAreaB',
    'openArea',
    'lotSizeM2',
    'grossFloorArea'
];
const $aabc524a7210db72$export$430b53e6132181a7 = [
    'type'
];
const $aabc524a7210db72$export$fe1b9a1a77be3bc5 = [
    'showSoldUnits'
];
const $aabc524a7210db72$export$742c4abf52faf26e = (filter)=>$aabc524a7210db72$export$1c961c4c1212e7ea.includes(filter);

});

parcelRegister("2FtpP", function(module, exports) {

$parcel$export(module.exports, "supportedUILanguages", () => $68250e1d00a08e90$export$e9d90cf6acb280f6);
const $68250e1d00a08e90$export$e9d90cf6acb280f6 = [
    'en',
    'no',
    'fr',
    'de',
    'nl',
    'fi'
];

});

parcelRegister("1csXF", function(module, exports) {

});


parcelRegister("40UfZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8a9ce988571a5437$export$defe85febe8b728c);
/*eslint-disable*/ const $8a9ce988571a5437$export$defe85febe8b728c = JSON.parse('{"/pkNvF":["Ausstattung"],"hwpQaF":["Wohnung"],"DB8zMK":["Anwenden"],"XwoMlz":["Verf\xfcgbare Einheiten"],"hwfc0K":["Zur\xfcck zu den Details zu ",["0"]],"F8iSVI":["Balkon/Terrasse"],"/oFfmS":["Fahrradstellplatz"],"/f40S9":["Parkplatz f\xfcr Boote"],"oZd08v":["Geb\xe4ude"],"NdocGG":["Wenn Sie sich registrieren und Ihr Interesse bekunden, erhalten Sie Informationen zum Projekt."],"QWMjOn":["Hausmeister"],"NGf84j":["Zentrale Lage"],"hSN6Cn":["Kinderfreundlich"],"yz7wBu":["Schlie\xdfen"],"PJR11c":["Bald im Verkauf"],"NBdIgR":["Kommentar"],"gyjsV2":["Gewerbe"],"VMRFQE":["Gewerbegrundst\xfcck"],"PiH3UR":["Kopiert!"],"he3ygx":["Kopieren"],"g8peZ2":["Hausmeister"],"URmyfc":["Details"],"oZkx0m":["Ladestation f\xfcr Elektrofahrzeuge"],"w52jYu":["Ost"],"lpREU8":["Aufzug"],"O3oNi5":["Email"],"Neb9s8":["Bsp.: +49 123 45 678"],"8gV9/c":["Beispiel: John Smith"],"sCDTOp":["Beispiel: john.smith@example.com"],"cSev+j":["Filter"],"dTn+sm":["Kamin"],"IiMldu":["Angeln"],"WEXsZg":["Stockwerk"],"ejVYRQ":["Aus"],"vvnngZ":["Garten"],"k8+Gnx":["Gartenterrasse"],"z6a1pf":["Fitnessstudio"],"hG89Ed":["Bild"],"2UaC4G":["Inklusive Parkplatz"],"OgACWb":["Anteil an gemeinsamen Verpflichtungen"],"GKlmeQ":["Schl\xfcsselloser Zugang"],"vifyyw":["Legal"],"VRKd4g":["Freizeit"],"CChbRW":["Freizeitgrundst\xfcck"],"yzF66j":["Verkn\xfcpfung"],"2BBAbc":["Liste"],"G79EVt":["Angebot abgeben"],"fj5byd":["nicht zutreffend"],"DXfKkE":["Keine Geb\xe4ude gefunden"],"qFBgMp":["Keine Bewohner"],"kUxKbX":["Keine Abschnitte gefunden"],"AAc6m8":["Keine Einheiten gefunden"],"qV2cO3":["Norden"],"Vdegzk":["Nord-Ost"],"qy1mWq":["Nord-West"],"ow3fug":["Keine Ergebnisse"],"ora1Cm":["Anzahl der R\xe4ume"],"LLAa/9":["Optional"],"7vJHGg":["Optionales Parken ",["0"]],"/IX/7x":["Andere"],"yacEUu":["Parken"],"/lAbub":["Haustiere erlaubt"],"ou6PkF":["Pool"],"a7u1N9":["Preis"],"7Bu2+f":["Preisspanne"],"r1MpXi":["Ruhig"],"wVyozX":["Informationen anfordern"],"Uwsg2F":["Reserviert"],"OfhWJH":["Zur\xfccksetzen"],"cwbbeN":["Wohngrundst\xfcck"],"OQo3/D":["Dachterrasse"],"5aP2OI":["Zimmer"],"Fglnvp":["Zimmer"],"TEERTx":["SMS"],"GRqhSA":["W\xe4hlen Sie einen anderen Blickwinkel des Geb\xe4udes, um die Lage dieser Einheit zu sehen"],"zTbQzK":["Doppelhaush\xe4lfte"],"Z8lGw6":["Teilen"],"hmd2Ji":["Geteilte Kosten"],"1G7KS/":["Verkaufte Einheiten anzeigen"],"o2D1vi":["Einfamilienhaus"],"Cj2Gtd":["Gr\xf6\xdfe"],"iVwd98":["Gr\xf6\xdfenbereich"],"s9KGXU":["Verkauft"],"CHWYig":["S\xfcd"],"WmT2An":["S\xfcd-Ost"],"ax3q27":["S\xfcd-West"],"3PRxO3":["Abschnitt"],"BrrIs8":["Lager"],"nYbYac":["Lagerraum"],"uHafbT":["Schwimmen"],"kHNitE":["Danke f\xfcr Ihr Interesse."],"/jQctM":["Zu"],"suyLVm":["Gesamtkosten"],"qqsfDU":["Gesamtpreis"],"LKiZeZ":["Reihenhaus"],"5jH2KN":["Wanderwege"],"+zy2Nq":["Art"],"4ZIbGc":["Immobilienart"],"aSwfbR":["Einheit"],"RsG/0i":["Anzahl der Einheiten"],"mG3RZE":["Art der Einheit"],"IodKQ0":["Wohnfl\xe4che"],"jpctdh":["Sicht"],"2Eoi/a":["Details anzeigen"],"RRlgIL":["Weitere ",["0"]," anzeigen"],"kZ3clk":["Westen"],"r8qAvZ":["Barrierefrei"],"99lkH1":["Sie erhalten in K\xfcrze weitere Informationen zum Projekt."],"z8F4/3":["E-Mail-Adresse"],"q8yluz":["Name"],"19n8mj":["Telefon"],"7aqkHl":["Raum/R\xe4ume"],"cBmLPZ":[["0"]," Balkon"],"FGOUAP":[["0"]," von ",["1"]],"gPLAkr":[["referencesLength","plural",{"one":["#"," Geb\xe4ude"],"other":["#"," Geb\xe4ude"]}]],"632AMB":[["referencesLength","plural",{"one":["#"," stage"],"other":["#"," stages"]}]],"oLlfRg":[["referencesLength","plural",{"one":["#"," Einheit"],"other":["#"," Einheiten"]}]],"vcMa5w":[["filteredElementsCount"]," Einheiten anzeigen"],"mMQSH4":["Schlafzimmer"],"0SV2H4":[["filteredElementsCount","plural",{"one":["1 Einheit anzeigen"],"other":[["filteredElementsCount"]," Einheiten anzeigen"]}]],"Z3FXyt":["Wird geladen..."],"HTgB23":["Datei konnte nicht geladen werden."],"qtWvA3":["Balkone"],"qWfOMq":["Anzahl der Schlafzimmer"],"FqEJnO":["Ostfassade"],"v+WL2j":["Nordostfassade"],"AuzRy6":["Nordwestfassade"],"RxbC6J":["Nordfassade"],"2yZc/R":["S\xfcdostfassade"],"wjJ1Xm":["S\xfcdwestfassade"],"QPfvuh":["S\xfcdfassade"],"E16z5a":["Westfassade"],"5FOB1h":["Alles zur\xfccksetzen"],"oyIs+l":["Preise"],"kJ9iPL":["Gr\xf6\xdfen"],"MHrjPM":["Titel"],"SIFrwC":["Einheitstypen"],"hs3P0F":["Wohnfl\xe4chen"],"+lY7Ar":["Bruttogeschossfl\xe4che"],"XfxfGf":["Bruttogrundfl\xe4chenbereich"],"idlK/+":["Nutzfl\xe4chenbereich"],"Fq8AAY":["Ostbalkon"],"jtPORH":["Nordbalkon"],"bmO/4h":["S\xfcdbalkon"],"djectt":["Westbalkon"],"R1k4um":["Wohnungen"],"M/2JLO":["Kommerzieller Bauernhof"],"AbQxQE":["Gewerbehof"],"CP/f3O":["Gewerbegrundst\xfcck"],"taSY7H":["freistehend"],"tFDeqA":["Duplex"],"8H7DUB":["Freizeit lo"],"RMYlfD":["Freizeit"],"/5MyP5":["Freizeitgrundst\xfcck"],"fvj3Pv":["Erholungsgrundst\xfcck"],"sZE0ZO":["Wohngrundst\xfcck"],"CnSFS4":["Freizeitgrundst\xfcck"],"zz/Pi8":["Nach Osten ausgerichtet"],"4Xwqm8":["Nord-Ost-Ausrichtung"],"jK5kZi":["Nordwestlich ausgerichtet"],"vyqaYx":["Nordausrichtung"],"g3Kx2K":["S\xfcd-Ost-Ausrichtung"],"mknggx":["Ausrichtung nach S\xfcdwesten"],"p6Hb+r":["S\xfcdlage"],"DR14bo":["Nach Westen ausgerichtet"],"LF/DpI":["Einheiten"],"1Z+s8a":[["0"],"/",["1"]," verf\xfcgbar"],"mzI/c+":["Herunterladen"],"t45b0O":["Badezimmer"],"IN0LBx":["Anleihe"],"GkviEB":["Kooperative"],"kj3M8S":["Kaution"],"qEAgqe":["Im Besitz"],"PU+Y9x":["Eigentumstyp"],"blbbPS":["Aktie"],"BFN94d":["Zu verkaufen"],"dke9GB":["Mikrohaus"],"56vwJs":["Monatliche Miete"],"oDAEQq":["Eigentum"],"UbX/QK":["Teilweise im Besitz"],"mEKLZL":["Nebenkosten"],"iH8pgl":["Zur\xfcck"],"Xs+IX4":["BGF"],"I9IEty":["BGF Bereich"],"b7Fian":["NF Extern"],"kJYB2t":["NF Extern Bereich"],"M6Pl2B":["NF Intern"],"ZDI6y4":["NF Intern Bereich"],"ij53KS":["Au\xdfennutzfl\xe4che (NF Extern)"],"oB+XVA":["Nutzfl\xe4che Balkon (NF Balkon)"],"JwqVXG":["Innennutzfl\xe4che (NF Intern)"],"suo7tL":["Grundst\xfccksfl\xe4che"],"EQQRc5":["Grundst\xfccksfl\xe4che"],"8g08eq":["Grundst\xfccksfl\xe4che Bereich"],"rWaJtl":["Offene Fl\xe4che"],"DcooRM":["Offene Fl\xe4che Bereich"],"uIZ2tg":["Link teilen"],"sRFr28":["Zu verkaufen"],"1Euao/":["Kaufpreis Miteigentum"],"RS0o7b":["Status"],"+XT9pd":[["filteredElementsCount","plural",{"one":["Ansicht 1 Einheit"],"other":["View ","#","Einheiten"]}]],"wJijgU":["Standort"],"t6yDp0":["Wohnfl\xe4che"],"oCHfGC":["Stockwerk"],"K0UlbV":[["filteredElementsCount","plural",{"one":["Zeige (1) Einheit"],"other":["Zeige (","#",") Einheiten"]}]],"LFeFvs":["Vorschau der n\xe4chsten Ansicht"],"7zP2Sb":["Filter schlie\xdfen"],"Kz5xj/":["Vorschau der aktuellen Ansicht"],"vCYnNv":["Standort"],"CK1KXz":["Max"],"eTUF28":["Min"],"dIKut9":["Keine Einheiten mit den gew\xe4hlten Filtern gefunden"],"s64RjX":["Alle Filter zur\xfccksetzen"],"BowKyI":["Details zeigen"],"8XQ4MD":["Au\xdfennutzfl\xe4che (NF Extern)"],"BLlipz":["Nutzfl\xe4che Balkon (NF Balkon)"],"rAvVFz":["Innennutzfl\xe4che (NF Intern)"],"UUJ0y6":["Vorschau Perspektive"],"JlFcis":["Senden"],"E/muDO":["Unterlagen"],"TdfEV7":["Archiviert"],"OxbACX":["Teilweise im Besitz"],"OzDiZm":["Vorschau Einheit"],"kryGs+":["Karte"],"lXzzVA":[["filteredElementsCount","plural",{"one":["1 verf\xfcgbare Einheit"],"other":["#"," verf\xfcgbare Einheiten"]}]],"KXbgIx":["Kein ",["translatedDataType"]," in den aktiven Filtern gefunden"],"Re8hm5":["Beziehungen"],"c9bpF5":["Abschnitte und Geb\xe4ude"],"VNCpBk":["Zum Mieten"],"4Ri+A0":["Zur Miete"],"MepnY2":["Kaution"],"7aYzgc":["Mietpreis"],"2eknBD":["Mietpreisgeb\xfchren"],"vWP2Gj":["Vermietet"],"PZtPFD":["Grundriss herunterladen"],"dhu12h":["Bild herunterladen"],"2pOUCj":["Grundriss herunterladen (pdf)"],"dcb95U":["O"],"eKhYz9":["N"],"C+dBfp":["NO"],"K38WB7":["NW"],"ZQA8ce":["S"],"a9d3NA":["SO"],"7Kfz4p":["SW"],"QnXXNN":["W"],"/QcZLG":["Marketer"],"g2UNkE":["Powered by"],"INHBKa":["Skip video"],"KMgp2+":[["0"]," verf\xfcgbar"],"Ig4phb":[["countLabel"]," verf\xfcgbar"],"Nu4oKW":["Description"],"H9a3W2":["Energy Label"],"G2QGrk":["<0>View in 3D</0>"],"qXjON+":["Back to unit details"],"7cjMnD":["Experience the home"],"1ODx06":["Walk around the home in 3D and get to know the apartment in a whole new way!"],"9q90xa":["See other angle of stage to see the location of this building"],"ScJ9fj":["Datenschutzerkl\xe4rung"],"tvnPhU":["From-to price"],"0a7PDu":["From-To Price"],"IS0D1W":["3D Interior"],"U+kFad":["Gallery"],"GEqWeF":["Floorplans / Gallery"],"EIxe+B":["Purchase price (from)"],"Ex5oXc":["Purchase price (to)"],"9Qv28Z":["Balcony View"],"lgFfeO":["Sold out"],"BdyTPm":["Download video"],"9U5DaL":["Glazed balcony usable area (BRA-B) "],"uYwh2W":[["0"]," balcony view"]}');

});

parcelRegister("cXa8C", function(module, exports) {

$parcel$export(module.exports, "messages", () => $abbf07fbeab7739a$export$defe85febe8b728c);
/*eslint-disable*/ const $abbf07fbeab7739a$export$defe85febe8b728c = JSON.parse("{\"/pkNvF\":[\"Amenities\"],\"hwpQaF\":[\"Apartment\"],\"DB8zMK\":[\"Apply\"],\"XwoMlz\":[\"Available units\"],\"hwfc0K\":[\"Back to \",[\"0\"],\" details\"],\"F8iSVI\":[\"Balcony\"],\"/oFfmS\":[\"Bike parking\"],\"/f40S9\":[\"Boat parking\"],\"oZd08v\":[\"Building\"],\"NdocGG\":[\"By registering and expressing your interest, you will be contacted with information about the project.\"],\"QWMjOn\":[\"Caretaker\"],\"NGf84j\":[\"Central\"],\"hSN6Cn\":[\"Child friendly\"],\"yz7wBu\":[\"Close\"],\"PJR11c\":[\"Coming for sale\"],\"NBdIgR\":[\"Comment\"],\"gyjsV2\":[\"Commercial\"],\"VMRFQE\":[\"Commercial lot\"],\"PiH3UR\":[\"Copied!\"],\"he3ygx\":[\"Copy\"],\"g8peZ2\":[\"Custodian\"],\"URmyfc\":[\"Details\"],\"oZkx0m\":[\"EV charging\"],\"w52jYu\":[\"East\"],\"lpREU8\":[\"Elevator\"],\"O3oNi5\":[\"Email\"],\"Neb9s8\":[\"Ex: +47 123 45 678\"],\"8gV9/c\":[\"Ex: John Smith\"],\"sCDTOp\":[\"Ex: john.smith@example.com\"],\"cSev+j\":[\"Filters\"],\"dTn+sm\":[\"Fireplace\"],\"IiMldu\":[\"Fishing\"],\"WEXsZg\":[\"Level\"],\"ejVYRQ\":[\"From\"],\"vvnngZ\":[\"Garden\"],\"k8+Gnx\":[\"Ground terrace\"],\"z6a1pf\":[\"Gym\"],\"hG89Ed\":[\"Image\"],\"2UaC4G\":[\"Included parking space\"],\"OgACWb\":[\"Joint debt\"],\"GKlmeQ\":[\"Keyless entry\"],\"vifyyw\":[\"Legal\"],\"VRKd4g\":[\"Leisure\"],\"CChbRW\":[\"Leisure lot\"],\"yzF66j\":[\"Link\"],\"2BBAbc\":[\"List\"],\"G79EVt\":[\"Make offer\"],\"fj5byd\":[\"N/A\"],\"DXfKkE\":[\"No buildings found\"],\"qFBgMp\":[\"No residents\"],\"kUxKbX\":[\"No stages found\"],\"AAc6m8\":[\"No units found\"],\"qV2cO3\":[\"North\"],\"Vdegzk\":[\"North East\"],\"qy1mWq\":[\"North West\"],\"ow3fug\":[\"Nothing found\"],\"ora1Cm\":[\"Number of rooms\"],\"LLAa/9\":[\"Optional\"],\"7vJHGg\":[\"Optional parking \",[\"0\"]],\"/IX/7x\":[\"Other\"],\"yacEUu\":[\"Parking\"],\"/lAbub\":[\"Pets allowed\"],\"ou6PkF\":[\"Pool\"],\"a7u1N9\":[\"Price\"],\"7Bu2+f\":[\"Price range\"],\"r1MpXi\":[\"Quiet\"],\"wVyozX\":[\"Register interest\"],\"Uwsg2F\":[\"Reserved\"],\"OfhWJH\":[\"Reset\"],\"cwbbeN\":[\"Residential lot\"],\"OQo3/D\":[\"Roof terrace\"],\"5aP2OI\":[\"Room\"],\"Fglnvp\":[\"Rooms\"],\"TEERTx\":[\"SMS\"],\"GRqhSA\":[\"See other angle of building to see the location of this unit\"],\"zTbQzK\":[\"Semi detached\"],\"Z8lGw6\":[\"Share\"],\"hmd2Ji\":[\"Shared costs\"],\"1G7KS/\":[\"Show sold units\"],\"o2D1vi\":[\"Single family house\"],\"Cj2Gtd\":[\"Internal size\"],\"iVwd98\":[\"Size range\"],\"s9KGXU\":[\"Sold\"],\"CHWYig\":[\"South\"],\"WmT2An\":[\"South East\"],\"ax3q27\":[\"South West\"],\"3PRxO3\":[\"Stage\"],\"BrrIs8\":[\"Storage\"],\"nYbYac\":[\"Storage room\"],\"uHafbT\":[\"Swimming\"],\"kHNitE\":[\"Thank you for your interest.\"],\"/jQctM\":[\"To\"],\"suyLVm\":[\"Total costs\"],\"qqsfDU\":[\"Total price\"],\"LKiZeZ\":[\"Townhouse\"],\"5jH2KN\":[\"Trails\"],\"+zy2Nq\":[\"Type\"],\"4ZIbGc\":[\"Type of property\"],\"aSwfbR\":[\"Unit\"],\"RsG/0i\":[\"Unit entities\"],\"mG3RZE\":[\"Unit type\"],\"IodKQ0\":[\"Usable area\"],\"jpctdh\":[\"View\"],\"2Eoi/a\":[\"View details\"],\"RRlgIL\":[\"View \",[\"0\"],\" more\"],\"kZ3clk\":[\"West\"],\"r8qAvZ\":[\"Wheelchair accessible\"],\"99lkH1\":[\"You will be contacted with more information about the project shortly.\"],\"z8F4/3\":[\"Your email\"],\"q8yluz\":[\"Your name\"],\"19n8mj\":[\"Your phone\"],\"7aqkHl\":[\"room(s)\"],\"cBmLPZ\":[[\"0\"],\" balcony\"],\"FGOUAP\":[[\"0\"],\" of \",[\"1\"]],\"gPLAkr\":[[\"referencesLength\",\"plural\",{\"one\":[\"#\",\" building\"],\"other\":[\"#\",\" buildings\"]}]],\"632AMB\":[[\"referencesLength\",\"plural\",{\"one\":[\"#\",\" stage\"],\"other\":[\"#\",\" stages\"]}]],\"oLlfRg\":[[\"referencesLength\",\"plural\",{\"one\":[\"#\",\" unit\"],\"other\":[\"#\",\" units\"]}]],\"vcMa5w\":[\"View \",[\"filteredElementsCount\"],\" units\"],\"mMQSH4\":[\"Bedrooms\"],\"0SV2H4\":[[\"filteredElementsCount\",\"plural\",{\"one\":[\"View 1 unit\"],\"other\":[\"View \",[\"filteredElementsCount\"],\" units\"]}]],\"Z3FXyt\":[\"Loading...\"],\"HTgB23\":[\"Failed to load file.\"],\"qtWvA3\":[\"Balconies\"],\"qWfOMq\":[\"Number of bedrooms\"],\"FqEJnO\":[\"East facade\"],\"v+WL2j\":[\"North East facade\"],\"AuzRy6\":[\"North West facade\"],\"RxbC6J\":[\"North facade\"],\"2yZc/R\":[\"South East facade\"],\"wjJ1Xm\":[\"South West facade\"],\"QPfvuh\":[\"South facade\"],\"E16z5a\":[\"West facade\"],\"5FOB1h\":[\"Reset all\"],\"oyIs+l\":[\"Prices\"],\"kJ9iPL\":[\"Sizes\"],\"MHrjPM\":[\"Title\"],\"SIFrwC\":[\"Unit types\"],\"hs3P0F\":[\"Usable areas\"],\"+lY7Ar\":[\"Gross floor area\"],\"XfxfGf\":[\"Gross floor area range\"],\"idlK/+\":[\"Usable area range\"],\"Fq8AAY\":[\"East balcony\"],\"jtPORH\":[\"North balcony\"],\"bmO/4h\":[\"South balcony\"],\"djectt\":[\"West balcony\"],\"R1k4um\":[\"Apartmen\"],\"M/2JLO\":[\"Commercial farm\"],\"AbQxQE\":[\"Commercial homestead\"],\"CP/f3O\":[\"Commercial lo\"],\"taSY7H\":[\"Detached\"],\"tFDeqA\":[\"Duplex\"],\"8H7DUB\":[\"Leisure lo\"],\"RMYlfD\":[\"Recreational\"],\"/5MyP5\":[\"Recreational lo\"],\"fvj3Pv\":[\"Recreational other\"],\"sZE0ZO\":[\"Residential lo\"],\"CnSFS4\":[\"Recreational lot\"],\"zz/Pi8\":[\"East facing\"],\"4Xwqm8\":[\"North East facing\"],\"jK5kZi\":[\"North West facing\"],\"vyqaYx\":[\"North facing\"],\"g3Kx2K\":[\"South East facing\"],\"mknggx\":[\"South West facing\"],\"p6Hb+r\":[\"South facing\"],\"DR14bo\":[\"West facing\"],\"LF/DpI\":[\"units\"],\"1Z+s8a\":[[\"0\"],\"/\",[\"1\"],\" available\"],\"mzI/c+\":[\"Download\"],\"t45b0O\":[\"Bathrooms\"],\"IN0LBx\":[\"Bond\"],\"GkviEB\":[\"Cooperative\"],\"kj3M8S\":[\"Deposit\"],\"qEAgqe\":[\"Owned\"],\"PU+Y9x\":[\"Ownership type\"],\"blbbPS\":[\"Stock\"],\"BFN94d\":[\"For Sale\"],\"dke9GB\":[\"Microhouse\"],\"56vwJs\":[\"Monthly rent\"],\"oDAEQq\":[\"Ownership\"],\"UbX/QK\":[\"Partially owned\"],\"mEKLZL\":[\"Transaction costs\"],\"iH8pgl\":[\"Back\"],\"Xs+IX4\":[\"BRA-B\"],\"I9IEty\":[\"BRA-B range\"],\"b7Fian\":[\"BRA-E\"],\"kJYB2t\":[\"BRA-E range\"],\"M6Pl2B\":[\"BRA-I\"],\"ZDI6y4\":[\"BRA-I range\"],\"ij53KS\":[\"External usable area (BRA-E)\"],\"oB+XVA\":[\"Glazed balcony usable area (BRA-B)\"],\"JwqVXG\":[\"Internal usable area (BRA-I)\"],\"suo7tL\":[\"Lot size\"],\"EQQRc5\":[\"Lot Size\"],\"8g08eq\":[\"Lot size range\"],\"rWaJtl\":[\"Open area\"],\"DcooRM\":[\"Open area range\"],\"uIZ2tg\":[\"Share link\"],\"sRFr28\":[\"For sale\"],\"1Euao/\":[\"Purchase Price Part Ownership\"],\"RS0o7b\":[\"State\"],\"+XT9pd\":[[\"filteredElementsCount\",\"plural\",{\"one\":[\"View 1 unit\"],\"other\":[\"View \",\"#\",\" units\"]}]],\"wJijgU\":[\"Location\"],\"t6yDp0\":[\"Internal Size\"],\"oCHfGC\":[\"Level\"],\"K0UlbV\":[[\"filteredElementsCount\",\"plural\",{\"one\":[\"Show (1) unit\"],\"other\":[\"Show (\",\"#\",\") units\"]}]],\"LFeFvs\":[\"Adjacent scene preview\"],\"7zP2Sb\":[\"Close filters\"],\"Kz5xj/\":[\"Current scene preview\"],\"vCYnNv\":[\"location\"],\"CK1KXz\":[\"Max\"],\"eTUF28\":[\"Min\"],\"dIKut9\":[\"No units found with the active filters\"],\"s64RjX\":[\"Reset all filters\"],\"BowKyI\":[\"Show details\"],\"8XQ4MD\":[\"External usable areas (BRA-E)\"],\"BLlipz\":[\"Glazed balcony usable areas (BRA-B)\"],\"rAvVFz\":[\"Internal usable areas (BRA-I)\"],\"UUJ0y6\":[\"Angle card image preview\"],\"JlFcis\":[\"Send\"],\"E/muDO\":[\"Documents\"],\"TdfEV7\":[\"Archived\"],\"OxbACX\":[\"Partially Owned\"],\"OzDiZm\":[\"Entity preview\"],\"kryGs+\":[\"Card\"],\"lXzzVA\":[[\"filteredElementsCount\",\"plural\",{\"one\":[\"1 available unit\"],\"other\":[\"#\",\" available units\"]}]],\"KXbgIx\":[\"No \",[\"translatedDataType\"],\" found with the active filters\"],\"Re8hm5\":[\"references\"],\"c9bpF5\":[\"stages and buildings\"],\"VNCpBk\":[\"For rent\"],\"4Ri+A0\":[\"For Rent\"],\"MepnY2\":[\"Rental deposit\"],\"7aYzgc\":[\"Rental price\"],\"2eknBD\":[\"Rental service charge\"],\"vWP2Gj\":[\"Rented\"],\"PZtPFD\":[\"Download floorplan\"],\"dhu12h\":[\"Download image\"],\"2pOUCj\":[\"Download floorplan (PDF)\"],\"dcb95U\":[\"E\"],\"eKhYz9\":[\"N\"],\"C+dBfp\":[\"NE\"],\"K38WB7\":[\"NW\"],\"ZQA8ce\":[\"S\"],\"a9d3NA\":[\"SE\"],\"7Kfz4p\":[\"SW\"],\"QnXXNN\":[\"W\"],\"/QcZLG\":[\"Marketer\"],\"g2UNkE\":[\"Powered by\"],\"INHBKa\":[\"Skip video\"],\"KMgp2+\":[[\"0\"],\" available\"],\"Ig4phb\":[[\"countLabel\"],\" available\"],\"Nu4oKW\":[\"Description\"],\"H9a3W2\":[\"Energy Label\"],\"G2QGrk\":[\"<0>View in 3D</0>\"],\"qXjON+\":[\"Back to unit details\"],\"7cjMnD\":[\"Experience the home\"],\"1ODx06\":[\"Walk around the home in 3D and get to know the apartment in a whole new way!\"],\"9q90xa\":[\"See other angle of stage to see the location of this building\"],\"ScJ9fj\":[\"Privacy policy\"],\"tvnPhU\":[\"From-to price\"],\"0a7PDu\":[\"From-To Price\"],\"IS0D1W\":[\"3D Interior\"],\"U+kFad\":[\"Gallery\"],\"GEqWeF\":[\"Floorplans / Gallery\"],\"EIxe+B\":[\"Purchase price (from)\"],\"Ex5oXc\":[\"Purchase price (to)\"],\"9Qv28Z\":[\"Balcony View\"],\"lgFfeO\":[\"Sold out\"],\"BdyTPm\":[\"Download video\"],\"9U5DaL\":[\"Glazed balcony usable area (BRA-B) \"],\"uYwh2W\":[[\"0\"],\" balcony view\"]}");

});

parcelRegister("1bFbh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1b524f9a060363aa$export$defe85febe8b728c);
/*eslint-disable*/ const $1b524f9a060363aa$export$defe85febe8b728c = JSON.parse('{"/pkNvF":["Palvelut"],"hwpQaF":["Asunto"],"DB8zMK":["K\xe4yt\xe4"],"XwoMlz":["Saatavilla olevat asunnot"],"hwfc0K":["Takaisin kohteen ",["0"]," tietoihin"],"F8iSVI":["Parveke"],"/oFfmS":["Py\xf6r\xe4n pys\xe4k\xf6inti"],"/f40S9":["Venepys\xe4k\xf6inti"],"oZd08v":["Rakennus"],"NdocGG":["Kun kerrot kiinnostuksestasi, otamme sinuun yhteytt\xe4 ja kerromme lis\xe4\xe4 projektista."],"QWMjOn":["Talonmies"],"NGf84j":["Keskeinen"],"hSN6Cn":["Lapsiyst\xe4v\xe4llinen"],"yz7wBu":["Suljettu"],"PJR11c":["Tulossa myyntiin"],"NBdIgR":["Kommentti"],"gyjsV2":["Liiketila"],"VMRFQE":["Toimitilatontti"],"PiH3UR":["Kopioitu!"],"he3ygx":["Kopio"],"g8peZ2":["Huoltoyhti\xf6"],"URmyfc":["Yksityiskohdat"],"oZkx0m":["S\xe4hk\xf6auton lataus"],"w52jYu":["It\xe4"],"lpREU8":["Hissi"],"O3oNi5":["S\xe4hk\xf6posti"],"Neb9s8":["Esim. +358 123 45 678"],"8gV9/c":["Esimerkiksi: John Smith"],"sCDTOp":["Esimerkki: john.smith@example.com"],"cSev+j":["Suodattimet"],"dTn+sm":["Takka"],"IiMldu":["Kalastus"],"WEXsZg":["Lattia"],"ejVYRQ":["From"],"vvnngZ":["Puutarha"],"k8+Gnx":["Terassi"],"z6a1pf":["Kuntosali"],"hG89Ed":["Kuva"],"2UaC4G":["Mukana autopaikka"],"OgACWb":["Yhti\xf6laina"],"GKlmeQ":["Avaimeton sis\xe4\xe4nk\xe4ynti"],"vifyyw":["Kuvaus"],"VRKd4g":["Vapaa-ajan asunto"],"CChbRW":["Vapaa-ajan tontti"],"yzF66j":["Linkki"],"2BBAbc":["Lista"],"G79EVt":["Tee tarjous"],"fj5byd":["Ei k\xe4yt\xf6ss\xe4"],"DXfKkE":["Rakennuksia ei l\xf6ytynyt"],"qFBgMp":["Ei asukkaita"],"kUxKbX":["Vaiheita ei l\xf6ytynyt"],"AAc6m8":["Yksik\xf6it\xe4 ei l\xf6ytynyt"],"qV2cO3":["Pohjoinen"],"Vdegzk":["Koillinen"],"qy1mWq":["Luode"],"ow3fug":["Mit\xe4\xe4n ei l\xf6ytynyt"],"ora1Cm":["Huoneiden m\xe4\xe4r\xe4"],"LLAa/9":["Valinnainen"],"7vJHGg":["Valinnainen pys\xe4k\xf6inti ",["0"]],"/IX/7x":["Muut"],"yacEUu":["Pys\xe4k\xf6inti"],"/lAbub":["Lemmikit sallittu"],"ou6PkF":["Uima-allas"],"a7u1N9":["Hinta"],"7Bu2+f":["Hintaluokka"],"r1MpXi":["Hiljainen"],"wVyozX":["Olen kiinnostunut"],"Uwsg2F":["Varattu"],"OfhWJH":["Tyhjenn\xe4"],"cwbbeN":["Asuintontti"],"OQo3/D":["Kattoterassi"],"5aP2OI":["Huone"],"Fglnvp":["Huonetta"],"TEERTx":["Tekstiviesti"],"GRqhSA":["Katso muut kuvakulmat n\xe4hd\xe4ksesi t\xe4m\xe4n asunnon sijainnin"],"zTbQzK":["Puoliksi erillinen"],"Z8lGw6":["Jaa"],"hmd2Ji":["Jaetut kulut"],"1G7KS/":["N\xe4yt\xe4 myydyt asunnot"],"o2D1vi":["Omakotitalo"],"Cj2Gtd":["Koko"],"iVwd98":["Kokovalikoima"],"s9KGXU":["Myyty"],"CHWYig":["Etel\xe4"],"WmT2An":["Kaakko"],"ax3q27":["Lounas"],"3PRxO3":["Vaihe"],"BrrIs8":["Varastotilat"],"nYbYac":["Varasto"],"uHafbT":["Uiminen"],"kHNitE":["Kiitos mielenkiinnostasi."],"/jQctM":["Vastaanottaja"],"suyLVm":["Kokonaiskustannukset"],"qqsfDU":["Kokonaishinta"],"LKiZeZ":["Kaupunkipientalo"],"5jH2KN":["Polut"],"+zy2Nq":["Tyyppi"],"4ZIbGc":["Kiinteist\xf6n tyyppi"],"aSwfbR":["Asunto"],"RsG/0i":["Asunnon tyyppi"],"mG3RZE":["Asunnon tyyppi"],"IodKQ0":["Asumispinta-ala"],"jpctdh":["N\xe4yt\xe4"],"2Eoi/a":["Tarkemmat tiedot"],"RRlgIL":["N\xe4yt\xe4 ",["0"]," muuta"],"kZ3clk":["L\xe4nsi"],"r8qAvZ":["P\xe4\xe4sy py\xf6r\xe4tuolilla"],"99lkH1":["Otamme sinuun pian yhteytt\xe4 ja kerromme lis\xe4\xe4 projektista."],"z8F4/3":["S\xe4hk\xf6postisi"],"q8yluz":["Nimesi"],"19n8mj":["Puhelinnumerosi"],"7aqkHl":["Huonetta"],"cBmLPZ":[["0"]," parveke"],"FGOUAP":[["0"],"/",["1"]],"gPLAkr":["{referencesLength, plural, yksi {# building} muuta {# buildings}}"],"632AMB":["{referencesLength, plural, yksi {# stage} other {# stages}}"],"oLlfRg":["{referencesLength, plural, yksi {# unit} muuta {# units}}\\n"],"vcMa5w":["N\xe4yt\xe4 ",["filteredElementsCount"]," yksikk\xf6\xe4"],"mMQSH4":["Makuuhuonetta"],"0SV2H4":["{filteredElementsCount, plural, yksi {View 1 unit} muuta {View {filteredElementsCount} units}}"],"Z3FXyt":["Ladataan..."],"HTgB23":["Tiedoston lataaminen ep\xe4onnistui."],"qtWvA3":["Parvekkeet"],"qWfOMq":["Makuuhuoneiden lukum\xe4\xe4r\xe4"],"FqEJnO":["It\xe4inen julkisivu"],"v+WL2j":["Koillisjulkisivu"],"AuzRy6":["Luoteisjulkisivu"],"RxbC6J":["Pohjoisjulkisivu"],"2yZc/R":["Kaakkoisjulkisivu"],"wjJ1Xm":["Lounaisjulkisivu"],"QPfvuh":["Etel\xe4julkisivu"],"E16z5a":["L\xe4nsijulkisivu"],"5FOB1h":["Nollaa kaikki"],"oyIs+l":["hinnat"],"kJ9iPL":["Koot"],"MHrjPM":["Otsikko"],"SIFrwC":["Asuntotyypit"],"hs3P0F":["Asumispinta-ala"],"+lY7Ar":["Kokonaispinta-ala"],"XfxfGf":["Kokonaispinta-alan alueet"],"idlK/+":["Asumispinta-alan alueet"],"Fq8AAY":["It\xe4parveke"],"jtPORH":["Pohjoisparveke"],"bmO/4h":["Etel\xe4parveke"],"djectt":["L\xe4nsiparveke"],"R1k4um":["Asunto"],"M/2JLO":["Kaupallinen maatila"],"AbQxQE":["Kaupallinen omavaraistila"],"CP/f3O":["Kaupallinen tontti"],"taSY7H":["Erillinen"],"tFDeqA":["Paritalo"],"8H7DUB":["Vapaa-ajan tontti"],"RMYlfD":["Virkistysalue"],"/5MyP5":["Virkistysalueen tontti"],"fvj3Pv":["Muu virkistysalue"],"sZE0ZO":["Asuintontti"],"CnSFS4":["Virkistysalueen tontti"],"zz/Pi8":["It\xe4\xe4n p\xe4in"],"4Xwqm8":["Koilliseen p\xe4in"],"jK5kZi":["Luoteeseen p\xe4in"],"vyqaYx":["pohjoiseen p\xe4in"],"g3Kx2K":["Kaakkoon p\xe4in"],"mknggx":["Lounaaseen p\xe4in"],"p6Hb+r":["Etel\xe4\xe4n p\xe4in"],"DR14bo":["L\xe4nteen p\xe4in"],"LF/DpI":["asuntoa"],"1Z+s8a":[["0"],"/",["1"]," k\xe4ytett\xe4viss\xe4"],"mzI/c+":["Lataa"],"t45b0O":["Kylpyhuoneet"],"IN0LBx":["Kiinnitys"],"GkviEB":["Osuuskunta"],"kj3M8S":["Pantti"],"qEAgqe":["Omistettu"],"PU+Y9x":["Omistustyyppi"],"blbbPS":["Osakemuotoinen"],"BFN94d":["Myyt\xe4v\xe4n\xe4"],"dke9GB":["Mikrotalo"],"56vwJs":["Kuukausittainen vuokra"],"oDAEQq":["Omistajuus"],"UbX/QK":["Osittain omistettu"],"mEKLZL":["Transaktiokulut"],"iH8pgl":["Back"],"Xs+IX4":["BRA-B"],"I9IEty":["BRA-B range"],"b7Fian":["BRA-E"],"kJYB2t":["BRA-E range"],"M6Pl2B":["BRA-I"],"ZDI6y4":["BRA-I range"],"ij53KS":["External usable area (BRA-E)"],"oB+XVA":["Glazed balcony usable area (BRA-B)"],"JwqVXG":["Internal usable area (BRA-I)"],"suo7tL":["Lot size"],"EQQRc5":["Lot Size"],"8g08eq":["Lot size range"],"rWaJtl":["Open area"],"DcooRM":["Open area range"],"uIZ2tg":["Share link"],"sRFr28":["For sale"],"1Euao/":["Purchase Price Part Ownership"],"RS0o7b":["State"],"+XT9pd":[["filteredElementsCount","plural",{"one":["View 1 unit"],"other":["View ","#"," units"]}]],"wJijgU":["Location"],"t6yDp0":["Internal Size"],"oCHfGC":["Level"],"K0UlbV":[["filteredElementsCount","plural",{"one":["Show (1) unit"],"other":["Show (","#",") units"]}]],"LFeFvs":["Adjacent scene preview"],"7zP2Sb":["Close filters"],"Kz5xj/":["Current scene preview"],"vCYnNv":["location"],"CK1KXz":["Max"],"eTUF28":["Min"],"dIKut9":["No units found with the active filters"],"s64RjX":["Reset all filters"],"BowKyI":["Show details"],"8XQ4MD":["External usable areas (BRA-E)"],"BLlipz":["Glazed balcony usable areas (BRA-B)"],"rAvVFz":["Internal usable areas (BRA-I)"],"UUJ0y6":["Angle card image preview"],"JlFcis":["Send"],"E/muDO":["Documents"],"TdfEV7":["Archived"],"OxbACX":["Partially Owned"],"OzDiZm":["Entity preview"],"kryGs+":["Card"],"lXzzVA":[["filteredElementsCount","plural",{"one":["1 available unit"],"other":["#"," available units"]}]],"KXbgIx":["No ",["translatedDataType"]," found with the active filters"],"Re8hm5":["references"],"c9bpF5":["stages and buildings"],"VNCpBk":["For rent"],"4Ri+A0":["For Rent"],"MepnY2":["Rental deposit"],"7aYzgc":["Rental price"],"2eknBD":["Rental service charge"],"vWP2Gj":["Rented"],"PZtPFD":["Download floorplan"],"dhu12h":["Download image"],"2pOUCj":["Download floorplan (PDF)"],"dcb95U":["E"],"eKhYz9":["N"],"C+dBfp":["NE"],"K38WB7":["NW"],"ZQA8ce":["S"],"a9d3NA":["SE"],"7Kfz4p":["SW"],"QnXXNN":["W"],"/QcZLG":["Marketer"],"g2UNkE":["Powered by"],"INHBKa":["Skip video"],"KMgp2+":[["0"]," available"],"Ig4phb":[["countLabel"]," available"],"Nu4oKW":["Description"],"H9a3W2":["Energy Label"],"G2QGrk":["<0>View in 3D</0>"],"qXjON+":["Back to unit details"],"7cjMnD":["Experience the home"],"1ODx06":["Walk around the home in 3D and get to know the apartment in a whole new way!"],"9q90xa":["See other angle of stage to see the location of this building"],"ScJ9fj":["Privacy policy"],"tvnPhU":["From-to price"],"0a7PDu":["From-To Price"],"IS0D1W":["3D Interior"],"U+kFad":["Gallery"],"GEqWeF":["Floorplans / Gallery"],"EIxe+B":["Purchase price (from)"],"Ex5oXc":["Purchase price (to)"],"9Qv28Z":["Balcony View"],"lgFfeO":["Sold out"],"BdyTPm":["Download video"],"9U5DaL":["Glazed balcony usable area (BRA-B) "],"uYwh2W":[["0"]," balcony view"]}');

});

parcelRegister("5DRrY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5874984b9e2d43c3$export$defe85febe8b728c);
/*eslint-disable*/ const $5874984b9e2d43c3$export$defe85febe8b728c = JSON.parse('{"/pkNvF":["\xc9quipements"],"hwpQaF":["Appartement"],"DB8zMK":["Appliquer"],"XwoMlz":["Lots disponibles"],"hwfc0K":["Retour aux d\xe9tails de ",["0"]],"F8iSVI":["Balcon"],"/oFfmS":["Stationnement v\xe9lo"],"/f40S9":["Stationnement bateaux"],"oZd08v":["Immeuble"],"NdocGG":["En vous inscrivant et en manifestant votre int\xe9r\xeat, vous serez contact\xe9 avec des informations sur le projet."],"QWMjOn":["Le concierge"],"NGf84j":["Central"],"hSN6Cn":["Adapt\xe9 aux enfants"],"yz7wBu":["Fermer"],"PJR11c":["Vente en avant-premi\xe8re"],"NBdIgR":["Commenter"],"gyjsV2":["Commercial"],"VMRFQE":["Terrain commercial"],"PiH3UR":["Copi\xe9\xa0!"],"he3ygx":["Copie"],"g8peZ2":["Gardien"],"URmyfc":["D\xe9tails"],"oZkx0m":["Recharge de VE"],"w52jYu":["Est"],"lpREU8":["Ascenseur"],"O3oNi5":["E-mail"],"Neb9s8":["Ex : +47 123 45 678"],"8gV9/c":["Ex\xa0: Jean Smith"],"sCDTOp":["Ex\xa0: john.smith@example.com"],"cSev+j":["Filtres"],"dTn+sm":["Chemin\xe9e"],"IiMldu":["P\xeacher"],"WEXsZg":["\xc9tage"],"ejVYRQ":["\xc0 partir de"],"vvnngZ":["Jardin"],"k8+Gnx":["Rez-de-terrasse"],"z6a1pf":["Gym"],"hG89Ed":["Image"],"2UaC4G":["Place de parking incluse"],"OgACWb":["Dette commune"],"GKlmeQ":["Entr\xe9e sans cl\xe9"],"vifyyw":["Juridique"],"VRKd4g":["Loisirs"],"CChbRW":["Terrain de loisirs"],"yzF66j":["Lien"],"2BBAbc":["Liste"],"G79EVt":["Faire une offre"],"fj5byd":["N / A"],"DXfKkE":["Aucun immeuble trouv\xe9"],"qFBgMp":["Aucun r\xe9sident"],"kUxKbX":["Aucune \xe9tape trouv\xe9e"],"AAc6m8":["Aucun lot trouv\xe9"],"qV2cO3":["Nord"],"Vdegzk":["Nord-Est"],"qy1mWq":["Nord-Ouest"],"ow3fug":["Rien n\'a \xe9t\xe9 trouv\xe9"],"ora1Cm":["Nombre de chambres"],"LLAa/9":["Facultatif"],"7vJHGg":["Stationnement en option ",["0"]],"/IX/7x":["Autre"],"yacEUu":["Parking"],"/lAbub":["Animaux accept\xe9s"],"ou6PkF":["Piscine"],"a7u1N9":["Prix"],"7Bu2+f":["\xc9chelle des prix"],"r1MpXi":["Calme"],"wVyozX":["Enregistrer son int\xe9r\xeat"],"Uwsg2F":["R\xe9serv\xe9"],"OfhWJH":["R\xe9initialiser"],"cwbbeN":["Terrain r\xe9sidentiel"],"OQo3/D":["Terrasse sur le toit"],"5aP2OI":["Pi\xe8ces"],"Fglnvp":["Pi\xe8ces"],"TEERTx":["SMS"],"GRqhSA":["Choisir un autre angle de l\'immeuble pour voir l\'emplacement de ce lot"],"zTbQzK":["Jumel\xe9"],"Z8lGw6":["Partager"],"hmd2Ji":["Co\xfbts partag\xe9s"],"1G7KS/":["Afficher les lots vendus"],"o2D1vi":["Maison individuelle"],"Cj2Gtd":["Taille"],"iVwd98":["Gamme de taille"],"s9KGXU":["Vendu"],"CHWYig":["Sud"],"WmT2An":["Sud-Est"],"ax3q27":["Sud Ouest"],"3PRxO3":["\xc9tape"],"BrrIs8":["Stockage"],"nYbYac":["Pi\xe8ce de stockage"],"uHafbT":["Nager"],"kHNitE":["Merci pour votre int\xe9r\xeat."],"/jQctM":["Pour"],"suyLVm":["Co\xfbt total"],"qqsfDU":["Prix total"],"LKiZeZ":["Maison de ville"],"5jH2KN":["Chemins"],"+zy2Nq":["Type"],"4ZIbGc":["Type de propri\xe9t\xe9"],"aSwfbR":["Lot"],"RsG/0i":["Lots unitaires"],"mG3RZE":["Type de lot"],"IodKQ0":["Surface utilisable"],"jpctdh":["Voir"],"2Eoi/a":["Voir les d\xe9tails"],"RRlgIL":["Afficher ",["0"]," de plus"],"kZ3clk":["Ouest"],"r8qAvZ":["Accessible aux fauteuils roulants"],"99lkH1":["Vous serez contact\xe9 avec plus d\'informations sur le programme sous peu."],"z8F4/3":["Votre e-mail"],"q8yluz":["Votre nom"],"19n8mj":["Votre t\xe9l\xe9phone"],"7aqkHl":["pi\xe8ce(s)"],"cBmLPZ":[["0"]," balcon"],"FGOUAP":[["0"]," sur ",["1"]],"gPLAkr":[["referencesLength","plural",{"one":["#"," b\xe2timent"],"other":["#"," b\xe2timents"]}]],"632AMB":[["referencesLength","plural",{"one":["#"," stage"],"other":["#"," stages"]}]],"oLlfRg":[["referencesLength","plural",{"one":["#"," unit"],"other":["#"," units"]}]],"vcMa5w":["Voir les ",["filteredElementsCount"]," lots"],"mMQSH4":["Chambres"],"0SV2H4":[["filteredElementsCount","plural",{"one":["Voir 1 lot"],"other":["Voir les ",["filteredElementsCount"]," lots"]}]],"Z3FXyt":["Chargement..."],"HTgB23":["Erreur dans t\xe9l\xe9chargement"],"qtWvA3":["Balcon"],"qWfOMq":["Nombre de chambres"],"FqEJnO":["Fa\xe7ade Est"],"v+WL2j":["Fa\xe7ade Nord Est"],"AuzRy6":["Fa\xe7ade Nord Ouest"],"RxbC6J":["Fa\xe7ade Nord"],"2yZc/R":["Fa\xe7ade Sud Est"],"wjJ1Xm":["Fa\xe7ade Sud Ouest"],"QPfvuh":["Fa\xe7ade Sud"],"E16z5a":["Fa\xe7ade Ouest"],"5FOB1h":["Tout r\xe9initialiser"],"oyIs+l":["Prix"],"kJ9iPL":["Tailles"],"MHrjPM":["Titre"],"SIFrwC":["Type d\'unit\xe9"],"hs3P0F":["Surfaces utilisables"],"+lY7Ar":["Surface brute de plancher"],"XfxfGf":["Plage de surface de plancher brute"],"idlK/+":["Plage de surface utilisable"],"Fq8AAY":["Est balcon"],"jtPORH":["Nord balcon"],"bmO/4h":["Sud balcon"],"djectt":["Ouest balcon"],"R1k4um":["Appartements"],"M/2JLO":["Ferme commerciale"],"AbQxQE":["Ferme commerciale"],"CP/f3O":["Local commercial"],"taSY7H":["D\xe9tach\xe9"],"tFDeqA":["Duplex"],"8H7DUB":["Loisir"],"RMYlfD":["R\xe9cr\xe9atif"],"/5MyP5":["Loisir r\xe9cr\xe9atif"],"fvj3Pv":["R\xe9cr\xe9atif autre"],"sZE0ZO":["Lo r\xe9sidentiel"],"CnSFS4":["Terrain r\xe9cr\xe9atif"],"zz/Pi8":["Exposition Est"],"4Xwqm8":["Exposition Nord Est"],"jK5kZi":["Exposition Nord Ouest"],"vyqaYx":["Exposition Nord"],"g3Kx2K":["Exposition Sud-Est"],"mknggx":["Exposition Sud Ouest"],"p6Hb+r":["Exposition sud"],"DR14bo":["Exposition ouest"],"LF/DpI":["lots"],"1Z+s8a":[["0"],"/",["1"]," disponible"],"mzI/c+":["T\xe9l\xe9charger"],"t45b0O":["Salles de bains"],"IN0LBx":["Lier"],"GkviEB":["Coop\xe9rative"],"kj3M8S":["D\xe9p\xf4t"],"qEAgqe":["Disponible"],"PU+Y9x":["Statut de la propri\xe9t\xe9"],"blbbPS":["Action"],"BFN94d":["\xc0 vendre"],"dke9GB":["Micromaison"],"56vwJs":["Loyer mensuel"],"oDAEQq":["Statut"],"UbX/QK":["Propri\xe9t\xe9 partielle"],"mEKLZL":["Co\xfbt de transaction"],"iH8pgl":["Retour"],"Xs+IX4":["BRA-B"],"I9IEty":["BRA-B range"],"b7Fian":["BRA-E"],"kJYB2t":["BRA-E range"],"M6Pl2B":["BRA-I"],"ZDI6y4":["BRA-I range"],"ij53KS":["Surface utilisable externe (BRA-E)"],"oB+XVA":["Surface utile du balcon vitr\xe9 (BRA-B)"],"JwqVXG":["Surface utilis\xe9e interne (BRA-I)"],"suo7tL":["La superficie du lot"],"EQQRc5":["La superficie de la parcelle"],"8g08eq":["Gamme de superficie de la parcelle"],"rWaJtl":["Zone ouverte"],"DcooRM":["Superficie de l\'espace ouvert"],"uIZ2tg":["Partager le lien"],"sRFr28":["\xc0 vendre"],"1Euao/":["Prix d\'achat en propri\xe9t\xe9 divis\xe9e"],"RS0o7b":["\xc9tat"],"+XT9pd":["{filteredElementsCount, plural, one {View 1 unit} autre {View # units}}\\n"],"wJijgU":["Emplacement"],"t6yDp0":["Superficie int\xe9rieure"],"oCHfGC":["\xc9tage"],"K0UlbV":[["filteredElementsCount","plural",{"one":["Show (1) unit"],"other":["Show (","#",") units"]}]],"LFeFvs":["Aper\xe7u de la sc\xe8ne adjacente"],"7zP2Sb":["Fermer les filtres"],"Kz5xj/":["Aper\xe7u de la sc\xe8ne actuelle"],"vCYnNv":["Emplacement"],"CK1KXz":["Max"],"eTUF28":["Min"],"dIKut9":["Aucun lot trouv\xe9 avec les filtres actifs"],"s64RjX":["Retirer les filtres"],"BowKyI":["Afficher les d\xe9tails"],"8XQ4MD":["External usable areas (BRA-E)"],"BLlipz":["Glazed balcony usable areas (BRA-B)"],"rAvVFz":["Internal usable areas (BRA-I)"],"UUJ0y6":["Angle card image preview"],"JlFcis":["Envoyer"],"E/muDO":["Documents"],"TdfEV7":["Archiv\xe9"],"OxbACX":["Propri\xe9t\xe9 partielle"],"OzDiZm":["Entity preview"],"kryGs+":["Card"],"lXzzVA":[["filteredElementsCount","plural",{"one":["1 disponible lot"],"other":["#"," disponible lots"]}]],"KXbgIx":["No ",["translatedDataType"]," found with the active filters"],"Re8hm5":["references"],"c9bpF5":["stages and buildings"],"VNCpBk":["\xc0 louer"],"4Ri+A0":["\xc0 louer"],"MepnY2":["Caution de location"],"7aYzgc":["Prix de location"],"2eknBD":["Frais de service de location"],"vWP2Gj":["Lou\xe9"],"PZtPFD":["T\xe9l\xe9charger le plan d\'\xe9tage"],"dhu12h":["T\xe9l\xe9charger l\'image"],"2pOUCj":["T\xe9l\xe9charger le plan \xe9tage"],"dcb95U":["E"],"eKhYz9":["N"],"C+dBfp":["NE"],"K38WB7":["NO"],"ZQA8ce":["S"],"a9d3NA":["SE"],"7Kfz4p":["SO"],"QnXXNN":["O"],"/QcZLG":["Marketer"],"g2UNkE":["Powered by"],"INHBKa":["Passer la vid\xe9o"],"KMgp2+":[["0"]," disponible"],"Ig4phb":[["countLabel"]," disponible"],"Nu4oKW":["Description"],"H9a3W2":["Label Energie"],"G2QGrk":["<0>View in 3D</0>"],"qXjON+":["Back to unit details"],"7cjMnD":["Experience the home"],"1ODx06":["Walk around the home in 3D and get to know the apartment in a whole new way!"],"9q90xa":["See other angle of stage to see the location of this building"],"ScJ9fj":["Politique de confidentialit\xe9"],"tvnPhU":["From-to price"],"0a7PDu":["From-To Price"],"IS0D1W":["3D Interior"],"U+kFad":["Galerie"],"GEqWeF":["Plan d\'\xe9tage"],"EIxe+B":["Prix d\'achat"],"Ex5oXc":["Prix d\'achat"],"9Qv28Z":["Vue balcon"],"lgFfeO":["Vendu"],"BdyTPm":["t\xe9l\xe9charger la vid\xe9o"],"9U5DaL":["Glazed balcony usable area (BRA-B) "],"uYwh2W":[["0"]," balcony view"]}');

});

parcelRegister("aDutZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4944894caddcbb53$export$defe85febe8b728c);
/*eslint-disable*/ const $4944894caddcbb53$export$defe85febe8b728c = JSON.parse('{"/pkNvF":["Voorzieningen"],"hwpQaF":["Appartement"],"DB8zMK":["Toepassen"],"XwoMlz":["Beschikbare eenheden"],"hwfc0K":["Terug naar ",["0"]," details"],"F8iSVI":["Balkon"],"/oFfmS":["Fietsenstalling"],"/f40S9":["Aanlegplaats voor boten"],"oZd08v":["Gebouw"],"NdocGG":["Door u te registreren en uw interesse kenbaar te maken, wordt u op de hoogte gehouden van de voortgang."],"QWMjOn":["Conci\xebrge"],"NGf84j":["Centraal"],"hSN6Cn":["Kindvriendelijk"],"yz7wBu":["Sluiten"],"PJR11c":["Komt te koop"],"NBdIgR":["Opmerking"],"gyjsV2":["Bedrijfspand"],"VMRFQE":["Commercieel perceel"],"PiH3UR":["Gekopieerd!"],"he3ygx":["Kopi\xebren"],"g8peZ2":["Conci\xebrge"],"URmyfc":["Details"],"oZkx0m":["EV opladen"],"w52jYu":["Oosten"],"lpREU8":["Lift"],"O3oNi5":["E-mail"],"Neb9s8":["Bijv.: +316 12345678"],"8gV9/c":["Bijvoorbeeld: Jan Janssen"],"sCDTOp":["Bijv.: jan.janssen@voorbeeld.com"],"cSev+j":["Filters"],"dTn+sm":["Haard"],"IiMldu":["Vissen"],"WEXsZg":["Vloer"],"ejVYRQ":["Van"],"vvnngZ":["Tuin"],"k8+Gnx":["Begane grond terras"],"z6a1pf":["Sportschool"],"hG89Ed":["Afbeelding"],"2UaC4G":["Inclusief parkeerplaats"],"OgACWb":["Gezamenlijke schuld"],"GKlmeQ":["Sleutelloze toegang"],"vifyyw":["Voorwaarden"],"VRKd4g":["Recreatie"],"CChbRW":["Recreatief perceel"],"yzF66j":["Koppeling"],"2BBAbc":["Lijst"],"G79EVt":["Doe een bod"],"fj5byd":["NVT"],"DXfKkE":["Geen gebouwen gevonden"],"qFBgMp":["Geen bewoners"],"kUxKbX":["Geen fasen gevonden"],"AAc6m8":["Geen eenheden gevonden"],"qV2cO3":["Noorden"],"Vdegzk":["Noordoosten"],"qy1mWq":["Noordwesten"],"ow3fug":["Niets gevonden"],"ora1Cm":["Aantal kamers"],"LLAa/9":["Optioneel"],"7vJHGg":["Optionele parkeerplaats ",["0"]],"/IX/7x":["Anders"],"yacEUu":["Parkeerplaats"],"/lAbub":["Huisdieren toegestaan"],"ou6PkF":["Zwembad"],"a7u1N9":["Prijs"],"7Bu2+f":["Prijsbereik"],"r1MpXi":["Rustig"],"wVyozX":["Maak uw interesse kenbaar"],"Uwsg2F":["Gereserveerd"],"OfhWJH":["Resetten"],"cwbbeN":["Residenti\xeble kavel"],"OQo3/D":["Dakterras"],"5aP2OI":["Kamer"],"Fglnvp":["Kamers"],"TEERTx":["SMS"],"GRqhSA":["Zie ander aanzicht om de locatie van dit gebouw te zien"],"zTbQzK":["Twee-onder-een-kap"],"Z8lGw6":["Deel"],"hmd2Ji":["Gedeelde kosten"],"1G7KS/":["Toon verkochte eenheden"],"o2D1vi":["Eengezinswoning"],"Cj2Gtd":["Grootte"],"iVwd98":["Grootte bereik"],"s9KGXU":["Verkocht"],"CHWYig":["Zuiden"],"WmT2An":["Zuidoosten"],"ax3q27":["Zuidwesten"],"3PRxO3":["Fase"],"BrrIs8":["Opslag"],"nYbYac":["Opslagruimte"],"uHafbT":["Zwemmen"],"kHNitE":["Bedankt voor uw interesse."],"/jQctM":["Naar"],"suyLVm":["Totale kosten"],"qqsfDU":["Totale prijs"],"LKiZeZ":["Herenhuis"],"5jH2KN":["Paden"],"+zy2Nq":["Type"],"4ZIbGc":["Soort onroerend goed"],"aSwfbR":["Eenheid"],"RsG/0i":["Eenheidsentiteiten"],"mG3RZE":["Eenheidstype"],"IodKQ0":["Bruikbaar gebied"],"jpctdh":["Weergave"],"2Eoi/a":["Details bekijken"],"RRlgIL":["Bekijk nog ",["0"]," meer"],"kZ3clk":["Westen"],"r8qAvZ":["Rolstoeltoegankelijk"],"99lkH1":["Er wordt binnenkort contact met u opgenomen met meer informatie over het project."],"z8F4/3":["Uw e-mail"],"q8yluz":["Uw naam"],"19n8mj":["Uw telefoonnummer"],"7aqkHl":["kamer(s)"],"cBmLPZ":[["0"]," balkon(s)"],"FGOUAP":[["0"]," van ",["1"]],"gPLAkr":[["referencesLength","plural",{"one":["#"," gebouw"],"other":["#"," gebouwen"]}]],"632AMB":[["referencesLength","plural",{"one":["#"," stage"],"other":["#"," stages"]}]],"oLlfRg":[["referencesLength","plural",{"one":["#"," eenheid"],"other":["#"," eenheden"]}]],"vcMa5w":["Bekijk ",["filteredElementsCount"]," eenheden"],"mMQSH4":["Slaapkamers"],"0SV2H4":[["filteredElementsCount","plural",{"one":["Bekijk 1 eenheid"],"other":["Bekijk ",["filteredElementsCount"]," eenheden"]}]],"Z3FXyt":["Bezig met laden..."],"HTgB23":["Kan bestand niet laden"],"qtWvA3":["Balkon(s)"],"qWfOMq":["Aantal slaapkamers"],"FqEJnO":["Oost gevel"],"v+WL2j":["Noordoostelijke gevel"],"AuzRy6":["Noordwest gevel"],"RxbC6J":["Noordelijke gevel"],"2yZc/R":["Zuidoostelijke gevel"],"wjJ1Xm":["Zuidwestelijke gevel"],"QPfvuh":["Zuidelijke gevel"],"E16z5a":["Westelijke gevel"],"5FOB1h":["Alles resetten"],"oyIs+l":["Prijzen"],"kJ9iPL":["Maten"],"MHrjPM":["Titel"],"SIFrwC":["Soorten eenheden"],"hs3P0F":["Bruikbare gebieden"],"+lY7Ar":["Bruto vloeroppervlak"],"XfxfGf":["Bereik bruto vloeroppervlak"],"idlK/+":["Bruikbaar bereik"],"Fq8AAY":["Oostelijk balkon"],"jtPORH":["Noordelijk balkon"],"bmO/4h":["Zuidelijk balkon"],"djectt":["Westelijk balkon"],"R1k4um":["Appartementen"],"M/2JLO":["Commerci\xeble boerderij"],"AbQxQE":["Commerci\xeble hoeve"],"CP/f3O":["Commerci\xeble grond"],"taSY7H":["Losgemaakt"],"tFDeqA":["Duplexpand"],"8H7DUB":["Recreatief gebied"],"RMYlfD":["Recreatief"],"/5MyP5":["Recreatief gebied"],"fvj3Pv":["Recreatief anders"],"sZE0ZO":["Woongebied"],"CnSFS4":["Recreatief gebied"],"zz/Pi8":["Op het oosten"],"4Xwqm8":["Noordoostelijk"],"jK5kZi":["Noordwestelijk"],"vyqaYx":["Op het noorden"],"g3Kx2K":["Zuidoostelijk"],"mknggx":["Zuidwestelijk"],"p6Hb+r":["Op het zuiden"],"DR14bo":["Op het westen"],"LF/DpI":["eenheden"],"1Z+s8a":[["0"],"/",["1"]," beschikbaar"],"mzI/c+":["Downloaden"],"t45b0O":["Badkamers"],"IN0LBx":["Obligatie"],"GkviEB":["Co\xf6peratie"],"kj3M8S":["Borg"],"qEAgqe":["Eigendom"],"PU+Y9x":["Type eigendom"],"blbbPS":["Voorraad"],"BFN94d":["Te koop"],"dke9GB":["Tiny house"],"56vwJs":["Maandelijkse huur"],"oDAEQq":["Eigendom"],"UbX/QK":["Gedeeltelijk eigendom"],"mEKLZL":["Transactiekosten"],"iH8pgl":["Terug"],"Xs+IX4":["bruikbare vloeroppervlakte"],"I9IEty":["Bereik bruikbare vloeroppervlakte"],"b7Fian":["Bruikbare vloeroppervlakte (extern)"],"kJYB2t":["Bereik bruikbare vloeroppervlakte (extern)"],"M6Pl2B":["bruikbare vloeroppervlakte (intern)"],"ZDI6y4":["Bereik bruikbare vloeroppervlakte (intern)"],"ij53KS":["Bruikbare vloeroppervlakte buiten (extern)"],"oB+XVA":["Bruikbare vloeroppervlakte (balkon met beglazing)"],"JwqVXG":["Bruikbare vloeroppvervlakte (intern)"],"suo7tL":["Buitenruimte"],"EQQRc5":["Buitenruimte"],"8g08eq":["Bereik perceelgrootte"],"rWaJtl":["Open gebied"],"DcooRM":["Bereik van open gebied"],"uIZ2tg":["Deel link"],"sRFr28":["Te koop"],"1Euao/":["Aankoopprijs Deel Eigendom (Part Ownership)"],"RS0o7b":["Staat"],"+XT9pd":[["filteredElementsCount","plural",{"one":["Bekijk 1 unit"],"other":["Bekijk ","#"," units"]}]],"wJijgU":["Locatie"],"t6yDp0":["Woonoppervlakte"],"oCHfGC":["Verdieping"],"K0UlbV":[["filteredElementsCount","plural",{"one":["Toon (1) eenheid"],"other":["Toon (","#",") eenheden"]}]],"LFeFvs":["Voorbeeld van aangrenzende weergave"],"7zP2Sb":["Sluit filters"],"Kz5xj/":["Huidig weergavevoorbeeld"],"vCYnNv":["locatie"],"CK1KXz":["Max."],"eTUF28":["Min."],"dIKut9":["Geen units gevonden met de actieve filters"],"s64RjX":["Herstel alle filters"],"BowKyI":["Toon details"],"8XQ4MD":["Bruikbare vloeroppervlakte (extern)"],"BLlipz":["Bruikbare vloeroppervlakte (balkon met beglazing)"],"rAvVFz":["Bruikbare vloeroppervlakte (intern)"],"UUJ0y6":["Afbeeldingsvoorbeeld (angle card)"],"JlFcis":["Versturen"],"E/muDO":["Documenten"],"TdfEV7":["Gearchiveerd"],"OxbACX":["Gedeeltelijk eigendom"],"OzDiZm":["Preview van gebouw"],"kryGs+":["Kaart"],"lXzzVA":[["filteredElementsCount","plural",{"one":["1 beschikbare eenheid"],"other":["#"," beschikbare eenheden"]}]],"KXbgIx":["Geen ",["translatedDataType"]," gevonden met de actieve filters"],"Re8hm5":["referenties"],"c9bpF5":["Fases en gebouwen"],"VNCpBk":["Te huur"],"4Ri+A0":["Te huur"],"MepnY2":["Borgsom (huur)"],"7aYzgc":["Prijs"],"2eknBD":["Servicekosten (huur)"],"vWP2Gj":["Verhuurd"],"PZtPFD":["Download plattegrond"],"dhu12h":["Download afbeelding"],"2pOUCj":["Download plattegrond (PDF)"],"dcb95U":["O"],"eKhYz9":["N"],"C+dBfp":["NO"],"K38WB7":["NW"],"ZQA8ce":["Z"],"a9d3NA":["ZO"],"7Kfz4p":["ZW"],"QnXXNN":["W"],"/QcZLG":["Marketer"],"g2UNkE":["Powered by"],"INHBKa":["Sla video over"],"KMgp2+":[["0"]," beschikbaar"],"Ig4phb":[["countLabel"]," beschikbaar"],"Nu4oKW":["Beschrijving"],"H9a3W2":["Energielabel"],"G2QGrk":["<0>Bekijk in 3D</0>"],"qXjON+":["Terug naar unit details"],"7cjMnD":["Ervaar de woning"],"1ODx06":["Verkrijg een 3D-kijkje in de woning en ontdek het appartement op een nieuwe manier!"],"9q90xa":["Bekijk een andere hoek om de locatie van dit gebouw te zien."],"ScJ9fj":["Privacy beleid"],"tvnPhU":["Prijsindicatie"],"0a7PDu":["Prijsindicatie"],"IS0D1W":["3D interieur"],"U+kFad":["Galerij"],"GEqWeF":["Plattegronden/Gallerij"],"EIxe+B":["Aankoopprijs (van)"],"Ex5oXc":["Aankoopprijs (tot)"],"9Qv28Z":["Balcony View"],"lgFfeO":["Sold out"],"BdyTPm":["Download video"],"9U5DaL":["Glazed balcony usable area (BRA-B) "],"uYwh2W":[["0"]," balcony view"]}');

});

parcelRegister("8GmNf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8b8d10611ca96192$export$defe85febe8b728c);
/*eslint-disable*/ const $8b8d10611ca96192$export$defe85febe8b728c = JSON.parse('{"/pkNvF":["Fasiliteter"],"hwpQaF":["Leilighet"],"DB8zMK":["S\xf8ke om"],"XwoMlz":["Ledige enheter"],"hwfc0K":["Tilbake til detaljer"],"F8iSVI":["Balkong"],"/oFfmS":["Sykkelparkering"],"/f40S9":["B\xe5tparkering"],"oZd08v":["Bygning"],"NdocGG":["Ved \xe5 melde min interesse godtar jeg at opplysningene mine blir lagret og benyttet til \xe5 holde kontakt med meg p\xe5 e-post og mobil i forbindelse med dette prosjektet."],"QWMjOn":["Vaktmester"],"NGf84j":["Sentral"],"hSN6Cn":["Barnevennlig"],"yz7wBu":["Lukk"],"PJR11c":["Kommer for salg"],"NBdIgR":["Kommentar"],"gyjsV2":["N\xe6ring"],"VMRFQE":["N\xe6ringstomt"],"PiH3UR":["Kopiert!"],"he3ygx":["Kopiere"],"g8peZ2":["Depotmottaker"],"URmyfc":["Detaljer"],"oZkx0m":["EV-lading"],"w52jYu":["\xd8st"],"lpREU8":["Heis"],"O3oNi5":["E-post"],"Neb9s8":["Eks: +47 123 45 678"],"8gV9/c":["Eks: John Smith"],"sCDTOp":["Eks: john.smith@example.com"],"cSev+j":["Filtre"],"dTn+sm":["Peis"],"IiMldu":["Fiske"],"WEXsZg":["Etasje"],"ejVYRQ":["Fra"],"vvnngZ":["Hage"],"k8+Gnx":["Markterrasse"],"z6a1pf":["Gym"],"hG89Ed":["Bilde"],"2UaC4G":["Inkludert parkeringsplass"],"OgACWb":["Fellesgjeld"],"GKlmeQ":["N\xf8kkell\xf8s inngang"],"vifyyw":["Forbehold"],"VRKd4g":["Fritidsbolig"],"CChbRW":["Fritidstomt"],"yzF66j":["Link"],"2BBAbc":["Liste"],"G79EVt":["Kj\xf8p"],"fj5byd":["N/A"],"DXfKkE":["Ingen bygninger funnet"],"qFBgMp":["Ingen beboere"],"kUxKbX":["Ingen salgstrinn funnet"],"AAc6m8":["Ingen enheter funnet"],"qV2cO3":["Nord"],"Vdegzk":["Nord\xf8st"],"qy1mWq":["Nordvest"],"ow3fug":["Ingenting funnet"],"ora1Cm":["Antall rom"],"LLAa/9":["Valgfri"],"7vJHGg":["Valgfri parkering ",["0"]],"/IX/7x":["Annet"],"yacEUu":["Parkering"],"/lAbub":["Kj\xe6ledyr er tillatt"],"ou6PkF":["Basseng"],"a7u1N9":["Pris"],"7Bu2+f":["Prisklasse"],"r1MpXi":["Stille"],"wVyozX":["Meld interesse"],"Uwsg2F":["Reservert"],"OfhWJH":["Nullstill"],"cwbbeN":["Boligtomt"],"OQo3/D":["Takterrasse"],"5aP2OI":["Rom"],"Fglnvp":["Rom"],"TEERTx":["Tekstmelding"],"GRqhSA":["Se annen bygningsvinkel for \xe5 se plasseringen av denne enheten"],"zTbQzK":["Tomannsbolig"],"Z8lGw6":["Dele"],"hmd2Ji":["Felleskostnader"],"1G7KS/":["Vis solgte enheter"],"o2D1vi":["Enebolig"],"Cj2Gtd":["P-rom"],"iVwd98":["St\xf8rrelsesomr\xe5de"],"s9KGXU":["Solgt"],"CHWYig":["S\xf8r"],"WmT2An":["S\xf8r\xf8st"],"ax3q27":["S\xf8rvest"],"3PRxO3":["Salgstrinn"],"BrrIs8":["Lager"],"nYbYac":["Bod"],"uHafbT":["Sv\xf8mming"],"kHNitE":["Takk for din interesse."],"/jQctM":["Til"],"suyLVm":["Omkostninger"],"qqsfDU":["Totalpris"],"LKiZeZ":["Rekkehus"],"5jH2KN":["Stier"],"+zy2Nq":["Type"],"4ZIbGc":["Type eiendom"],"aSwfbR":["Enhet"],"RsG/0i":["Type enhet"],"mG3RZE":["Enhetstype"],"IodKQ0":["BRA"],"jpctdh":["Utsikt"],"2Eoi/a":["Vis detaljer"],"RRlgIL":["Se ",["0"]," til"],"kZ3clk":["Vest"],"r8qAvZ":["Tilgjengelig for rullestol"],"99lkH1":["Takk for din interesse! Vi vil holde deg oppdatert om prosjektet fremover."],"z8F4/3":["Din epost"],"q8yluz":["Ditt navn"],"19n8mj":["Din telefon"],"7aqkHl":["rom)"],"cBmLPZ":[["0"]," Balkong"],"FGOUAP":[["0"]," av ",["1"]],"gPLAkr":[["referencesLength","plural",{"one":["#"," building"],"other":["#"," buildings"]}]],"632AMB":[["referencesLength","plural",{"one":["#"," stage"],"other":["#"," stages"]}]],"oLlfRg":[["referencesLength","plural",{"one":["#"," enhet"],"other":["#"," enheter"]}]],"vcMa5w":["Se ",["filteredElementsCount"]," enheter"],"mMQSH4":["Soverom"],"0SV2H4":[["filteredElementsCount","plural",{"one":["Se 1 enhet"],"other":["Se ",["filteredElementsCount"]," enheter"]}]],"Z3FXyt":["Laster inn\u2026"],"HTgB23":["Kunne ikke laste inn denne siden"],"qtWvA3":["Balkonger"],"qWfOMq":["Antall soverom"],"FqEJnO":["\xd8stvendt fasade"],"v+WL2j":["Nord\xf8stvendt fasade"],"AuzRy6":["Nordvestvendt fasade"],"RxbC6J":["Nordvendt fasade"],"2yZc/R":["S\xf8r\xf8stvendt fasade"],"wjJ1Xm":["S\xf8rvestvendt fasade"],"QPfvuh":["S\xf8rvendt fasade"],"E16z5a":["Vestvendt fasade"],"5FOB1h":["Tilbakestill alt"],"oyIs+l":["Priser"],"kJ9iPL":["St\xf8rrelser"],"MHrjPM":["Navn"],"SIFrwC":["Enhetstyper"],"hs3P0F":["BRA"],"+lY7Ar":["Bruttoareal"],"XfxfGf":["Bruttoareal range"],"idlK/+":["Bruksareal"],"Fq8AAY":["\xd8stvendt balkong"],"jtPORH":["Nordvendt balkong"],"bmO/4h":["S\xf8rvendt balkong"],"djectt":["Vestvendt balkong"],"R1k4um":["Leilighet"],"M/2JLO":["G\xe5rd"],"AbQxQE":["Sm\xe5bruk"],"CP/f3O":["N\xe6ringstomt"],"taSY7H":["Enebolig"],"tFDeqA":["Duplex"],"8H7DUB":["Fritidstomt"],"RMYlfD":["Fritidsbolig"],"/5MyP5":["Fritidstomt"],"fvj3Pv":["Fritidseiendom (annet)"],"sZE0ZO":["Boligtomt"],"CnSFS4":["Fritidstomt"],"zz/Pi8":["\xd8stvendt"],"4Xwqm8":["Nord\xf8stvendt"],"jK5kZi":["Nordvestvendt"],"vyqaYx":["Nordvendt"],"g3Kx2K":["S\xf8r\xf8stvendt"],"mknggx":["S\xf8rvestvendt"],"p6Hb+r":["S\xf8rvendt"],"DR14bo":["Vestvendt"],"LF/DpI":["enheter"],"1Z+s8a":[["0"],"/",["1"]," ledige"],"mzI/c+":["Last ned"],"t45b0O":["Bad"],"IN0LBx":["Obligasjon"],"GkviEB":["Borettslag"],"kj3M8S":["Depositum"],"qEAgqe":["Selveier"],"PU+Y9x":["Eierform"],"blbbPS":["Aksje"],"BFN94d":["Til salgs"],"dke9GB":["Mikrohus"],"56vwJs":["M\xe5nedsleie"],"oDAEQq":["Eierform"],"UbX/QK":["Deleie"],"mEKLZL":["Omkostninger"],"iH8pgl":["Tilbake"],"Xs+IX4":["BRA-b"],"I9IEty":["BRA-b spennvidde"],"b7Fian":["BRA-e"],"kJYB2t":["BRA-e spennvidde"],"M6Pl2B":["BRA-i"],"ZDI6y4":["BRA-i"],"ij53KS":["BRA-e"],"oB+XVA":["BRA-b"],"JwqVXG":["BRA-i"],"suo7tL":["Tomtest\xf8rrelse"],"EQQRc5":["Tomtest\xf8rrelse"],"8g08eq":["Tomtest\xf8rrelse"],"rWaJtl":["TBA"],"DcooRM":["TBA"],"uIZ2tg":["Delingslenke"],"sRFr28":["Til salgs"],"1Euao/":["Prisantydning deleie"],"RS0o7b":["Status"],"+XT9pd":[["filteredElementsCount","plural",{"one":["Se 1 enhet"],"other":["Se ","#"," enheter"]}]],"wJijgU":["Plassering"],"t6yDp0":["Intern st\xf8rrelse"],"oCHfGC":["Etasje"],"K0UlbV":[["filteredElementsCount","plural",{"one":["Vis (1) enhet"],"other":["Vis (","#",") enheter"]}]],"LFeFvs":["Forh\xe5ndsvisning av vinkel ved siden av"],"7zP2Sb":["Lukk filter"],"Kz5xj/":["Forh\xe5ndsvisning av aktiv vinkel"],"vCYnNv":["plassering"],"CK1KXz":["Maks"],"eTUF28":["Min"],"dIKut9":["Ingen enheter funnet med det aktive filteret"],"s64RjX":["Tilbakestill filtere"],"BowKyI":["Vis detaljer"],"8XQ4MD":["BRA-e"],"BLlipz":["BRA-b"],"rAvVFz":["BRA-i"],"UUJ0y6":["Vinkelkort bilde forh\xe5ndsvisning"],"JlFcis":["Send"],"E/muDO":["Dokumenter"],"TdfEV7":["Arkivert"],"OxbACX":["Deleie"],"OzDiZm":["Forh\xe5ndsvisning"],"kryGs+":["Kort"],"lXzzVA":[["filteredElementsCount","plural",{"one":["1 ledig enhet"],"other":["#"," ledige enheter"]}]],"KXbgIx":["Ingen ",["translatedDataType"]," funnet med aktive filtere"],"Re8hm5":["referanser"],"c9bpF5":["trinn og bygg"],"VNCpBk":["Til leie"],"4Ri+A0":["Til leie"],"MepnY2":["Leiedepositum"],"7aYzgc":["Leiepris"],"2eknBD":["Leiegebyr"],"vWP2Gj":["Utleid"],"PZtPFD":["Last ned plantegning"],"dhu12h":["Last ned bilde"],"2pOUCj":["Last ned plantegning (PDF)"],"dcb95U":["\xd8"],"eKhYz9":["N"],"C+dBfp":["N\xd8"],"K38WB7":["NV"],"ZQA8ce":["S"],"a9d3NA":["S\xd8"],"7Kfz4p":["SV"],"QnXXNN":["V"],"/QcZLG":["Marketer"],"g2UNkE":["Levert av"],"INHBKa":["Hopp over"],"KMgp2+":[["0"]," ledige"],"Ig4phb":[["countLabel"]," ledige"],"Nu4oKW":["Beskrivelse"],"H9a3W2":["Energimerking"],"G2QGrk":["<0>Se i 3D</0>"],"qXjON+":["Tilbake til enhetsdetaljer"],"7cjMnD":["Opplev boligen"],"1ODx06":["G\xe5 rundt i boligen i 3D og bli kjent med leiligheten p\xe5 en helt ny m\xe5te!"],"9q90xa":["Se fra en annen vinkel for \xe5 se hvor bygningen ligger"],"ScJ9fj":["Personvernerkl\xe6ring"],"tvnPhU":["Pris fra\u2013til"],"0a7PDu":["Pris fra\u2013til"],"IS0D1W":["3D interi\xf8r"],"U+kFad":["Galleri"],"GEqWeF":["Plantegning / Galleri"],"EIxe+B":["Kj\xf8pspris (fra)"],"Ex5oXc":["Kj\xf8pspris (til)"],"9Qv28Z":["Balkongutsikt"],"lgFfeO":["Sluttsolgt"],"BdyTPm":["Last ned video"],"9U5DaL":["Bruksareal for innglasset balkong (BRA-B) "],"uYwh2W":[["0"]," balkongvisning"]}');

});

parcelRegister("9cyvU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7133f97b270744c3$export$defe85febe8b728c);
/*eslint-disable*/ const $7133f97b270744c3$export$defe85febe8b728c = JSON.parse("{\"/pkNvF\":[\"Amenities\"],\"hwpQaF\":[\"Apartment\"],\"DB8zMK\":[\"Apply\"],\"XwoMlz\":[\"Available units\"],\"hwfc0K\":[\"Back to \",[\"0\"],\" details\"],\"F8iSVI\":[\"Balcony\"],\"/oFfmS\":[\"Bike parking\"],\"/f40S9\":[\"Boat parking\"],\"oZd08v\":[\"Building\"],\"NdocGG\":[\"By registering and expressing your interest, you will be contacted with information about the project.\"],\"QWMjOn\":[\"Caretaker\"],\"NGf84j\":[\"Central\"],\"hSN6Cn\":[\"Child friendly\"],\"yz7wBu\":[\"Close\"],\"PJR11c\":[\"Coming for sale\"],\"NBdIgR\":[\"Comment\"],\"gyjsV2\":[\"Commercial\"],\"VMRFQE\":[\"Commercial lot\"],\"PiH3UR\":[\"Copied!\"],\"he3ygx\":[\"Copy\"],\"g8peZ2\":[\"Custodian\"],\"URmyfc\":[\"Details\"],\"oZkx0m\":[\"EV charging\"],\"w52jYu\":[\"East\"],\"lpREU8\":[\"Elevator\"],\"O3oNi5\":[\"Email\"],\"Neb9s8\":[\"Ex: +47 123 45 678\"],\"8gV9/c\":[\"Ex: John Smith\"],\"sCDTOp\":[\"Ex: john.smith@example.com\"],\"cSev+j\":[\"Filters\"],\"dTn+sm\":[\"Fireplace\"],\"IiMldu\":[\"Fishing\"],\"WEXsZg\":[\"Level\"],\"ejVYRQ\":[\"From\"],\"vvnngZ\":[\"Garden\"],\"k8+Gnx\":[\"Ground terrace\"],\"z6a1pf\":[\"Gym\"],\"hG89Ed\":[\"Image\"],\"2UaC4G\":[\"Included parking space\"],\"OgACWb\":[\"Joint debt\"],\"GKlmeQ\":[\"Keyless entry\"],\"vifyyw\":[\"Legal\"],\"VRKd4g\":[\"Leisure\"],\"CChbRW\":[\"Leisure lot\"],\"yzF66j\":[\"Link\"],\"2BBAbc\":[\"List\"],\"G79EVt\":[\"Make offer\"],\"fj5byd\":[\"N/A\"],\"DXfKkE\":[\"No buildings found\"],\"qFBgMp\":[\"No residents\"],\"kUxKbX\":[\"No stages found\"],\"AAc6m8\":[\"No units found\"],\"qV2cO3\":[\"North\"],\"Vdegzk\":[\"North East\"],\"qy1mWq\":[\"North West\"],\"ow3fug\":[\"Nothing found\"],\"ora1Cm\":[\"Number of rooms\"],\"LLAa/9\":[\"Optional\"],\"7vJHGg\":[\"Optional parking \",[\"0\"]],\"/IX/7x\":[\"Other\"],\"yacEUu\":[\"Parking\"],\"/lAbub\":[\"Pets allowed\"],\"ou6PkF\":[\"Pool\"],\"a7u1N9\":[\"Price\"],\"7Bu2+f\":[\"Price range\"],\"r1MpXi\":[\"Quiet\"],\"wVyozX\":[\"Register interest\"],\"Uwsg2F\":[\"Reserved\"],\"OfhWJH\":[\"Reset\"],\"cwbbeN\":[\"Residential lot\"],\"OQo3/D\":[\"Roof terrace\"],\"5aP2OI\":[\"Room\"],\"Fglnvp\":[\"Rooms\"],\"TEERTx\":[\"SMS\"],\"GRqhSA\":[\"See other angle of building to see the location of this unit\"],\"zTbQzK\":[\"Semi detached\"],\"Z8lGw6\":[\"Share\"],\"hmd2Ji\":[\"Shared costs\"],\"1G7KS/\":[\"Show sold units\"],\"o2D1vi\":[\"Single family house\"],\"Cj2Gtd\":[\"Internal size\"],\"iVwd98\":[\"Size range\"],\"s9KGXU\":[\"Sold\"],\"CHWYig\":[\"South\"],\"WmT2An\":[\"South East\"],\"ax3q27\":[\"South West\"],\"3PRxO3\":[\"Stage\"],\"BrrIs8\":[\"Storage\"],\"nYbYac\":[\"Storage room\"],\"uHafbT\":[\"Swimming\"],\"kHNitE\":[\"Thank you for your interest.\"],\"/jQctM\":[\"To\"],\"suyLVm\":[\"Total costs\"],\"qqsfDU\":[\"Total price\"],\"LKiZeZ\":[\"Townhouse\"],\"5jH2KN\":[\"Trails\"],\"+zy2Nq\":[\"Type\"],\"4ZIbGc\":[\"Type of property\"],\"aSwfbR\":[\"Unit\"],\"RsG/0i\":[\"Unit entities\"],\"mG3RZE\":[\"Unit type\"],\"IodKQ0\":[\"Usable area\"],\"jpctdh\":[\"View\"],\"2Eoi/a\":[\"View details\"],\"RRlgIL\":[\"View \",[\"0\"],\" more\"],\"kZ3clk\":[\"West\"],\"r8qAvZ\":[\"Wheelchair accessible\"],\"99lkH1\":[\"You will be contacted with more information about the project shortly.\"],\"z8F4/3\":[\"Your email\"],\"q8yluz\":[\"Your name\"],\"19n8mj\":[\"Your phone\"],\"7aqkHl\":[\"room(s)\"],\"cBmLPZ\":[[\"0\"],\" balcony\"],\"FGOUAP\":[[\"0\"],\" of \",[\"1\"]],\"gPLAkr\":[[\"referencesLength\",\"plural\",{\"one\":[\"#\",\" building\"],\"other\":[\"#\",\" buildings\"]}]],\"632AMB\":[[\"referencesLength\",\"plural\",{\"one\":[\"#\",\" stage\"],\"other\":[\"#\",\" stages\"]}]],\"oLlfRg\":[[\"referencesLength\",\"plural\",{\"one\":[\"#\",\" unit\"],\"other\":[\"#\",\" units\"]}]],\"vcMa5w\":[\"View \",[\"filteredElementsCount\"],\" units\"],\"mMQSH4\":[\"Bedrooms\"],\"0SV2H4\":[[\"filteredElementsCount\",\"plural\",{\"one\":[\"View 1 unit\"],\"other\":[\"View \",[\"filteredElementsCount\"],\" units\"]}]],\"Z3FXyt\":[\"Loading...\"],\"HTgB23\":[\"Failed to load file.\"],\"qtWvA3\":[\"Balconies\"],\"qWfOMq\":[\"Number of bedrooms\"],\"FqEJnO\":[\"East facade\"],\"v+WL2j\":[\"North East facade\"],\"AuzRy6\":[\"North West facade\"],\"RxbC6J\":[\"North facade\"],\"2yZc/R\":[\"South East facade\"],\"wjJ1Xm\":[\"South West facade\"],\"QPfvuh\":[\"South facade\"],\"E16z5a\":[\"West facade\"],\"5FOB1h\":[\"Reset all\"],\"oyIs+l\":[\"Prices\"],\"kJ9iPL\":[\"Sizes\"],\"MHrjPM\":[\"Title\"],\"SIFrwC\":[\"Unit types\"],\"hs3P0F\":[\"Usable areas\"],\"+lY7Ar\":[\"Gross floor area\"],\"XfxfGf\":[\"Gross floor area range\"],\"idlK/+\":[\"Usable area range\"],\"Fq8AAY\":[\"East balcony\"],\"jtPORH\":[\"North balcony\"],\"bmO/4h\":[\"South balcony\"],\"djectt\":[\"West balcony\"],\"R1k4um\":[\"Apartmen\"],\"M/2JLO\":[\"Commercial farm\"],\"AbQxQE\":[\"Commercial homestead\"],\"CP/f3O\":[\"Commercial lo\"],\"taSY7H\":[\"Detached\"],\"tFDeqA\":[\"Duplex\"],\"8H7DUB\":[\"Leisure lo\"],\"RMYlfD\":[\"Recreational\"],\"/5MyP5\":[\"Recreational lo\"],\"fvj3Pv\":[\"Recreational other\"],\"sZE0ZO\":[\"Residential lo\"],\"CnSFS4\":[\"Recreational lot\"],\"zz/Pi8\":[\"East facing\"],\"4Xwqm8\":[\"North East facing\"],\"jK5kZi\":[\"North West facing\"],\"vyqaYx\":[\"North facing\"],\"g3Kx2K\":[\"South East facing\"],\"mknggx\":[\"South West facing\"],\"p6Hb+r\":[\"South facing\"],\"DR14bo\":[\"West facing\"],\"LF/DpI\":[\"units\"],\"1Z+s8a\":[[\"0\"],\"/\",[\"1\"],\" available\"],\"mzI/c+\":[\"Download\"],\"t45b0O\":[\"Bathrooms\"],\"IN0LBx\":[\"Bond\"],\"GkviEB\":[\"Cooperative\"],\"kj3M8S\":[\"Deposit\"],\"qEAgqe\":[\"Owned\"],\"PU+Y9x\":[\"Ownership type\"],\"blbbPS\":[\"Stock\"],\"BFN94d\":[\"For Sale\"],\"dke9GB\":[\"Microhouse\"],\"56vwJs\":[\"Monthly rent\"],\"oDAEQq\":[\"Ownership\"],\"UbX/QK\":[\"Partially owned\"],\"mEKLZL\":[\"Transaction costs\"],\"iH8pgl\":[\"Back\"],\"Xs+IX4\":[\"BRA-B\"],\"I9IEty\":[\"BRA-B range\"],\"b7Fian\":[\"BRA-E\"],\"kJYB2t\":[\"BRA-E range\"],\"M6Pl2B\":[\"BRA-I\"],\"ZDI6y4\":[\"BRA-I range\"],\"ij53KS\":[\"External usable area (BRA-E)\"],\"oB+XVA\":[\"Glazed balcony usable area (BRA-B)\"],\"JwqVXG\":[\"Internal usable area (BRA-I)\"],\"suo7tL\":[\"Lot size\"],\"EQQRc5\":[\"Lot Size\"],\"8g08eq\":[\"Lot size range\"],\"rWaJtl\":[\"Open area\"],\"DcooRM\":[\"Open area range\"],\"uIZ2tg\":[\"Share link\"],\"sRFr28\":[\"For sale\"],\"1Euao/\":[\"Purchase Price Part Ownership\"],\"RS0o7b\":[\"State\"],\"+XT9pd\":[[\"filteredElementsCount\",\"plural\",{\"one\":[\"View 1 unit\"],\"other\":[\"View \",\"#\",\" units\"]}]],\"wJijgU\":[\"Location\"],\"t6yDp0\":[\"Internal Size\"],\"oCHfGC\":[\"Level\"],\"K0UlbV\":[[\"filteredElementsCount\",\"plural\",{\"one\":[\"Show (1) unit\"],\"other\":[\"Show (\",\"#\",\") units\"]}]],\"LFeFvs\":[\"Adjacent scene preview\"],\"7zP2Sb\":[\"Close filters\"],\"Kz5xj/\":[\"Current scene preview\"],\"vCYnNv\":[\"location\"],\"CK1KXz\":[\"Max\"],\"eTUF28\":[\"Min\"],\"dIKut9\":[\"No units found with the active filters\"],\"s64RjX\":[\"Reset all filters\"],\"BowKyI\":[\"Show details\"],\"8XQ4MD\":[\"External usable areas (BRA-E)\"],\"BLlipz\":[\"Glazed balcony usable areas (BRA-B)\"],\"rAvVFz\":[\"Internal usable areas (BRA-I)\"],\"UUJ0y6\":[\"Angle card image preview\"],\"JlFcis\":[\"Send\"],\"E/muDO\":[\"Documents\"],\"TdfEV7\":[\"Archived\"],\"OxbACX\":[\"Partially Owned\"],\"OzDiZm\":[\"Entity preview\"],\"kryGs+\":[\"Card\"],\"lXzzVA\":[[\"filteredElementsCount\",\"plural\",{\"one\":[\"1 available unit\"],\"other\":[\"#\",\" available units\"]}]],\"KXbgIx\":[\"No \",[\"translatedDataType\"],\" found with the active filters\"],\"Re8hm5\":[\"references\"],\"c9bpF5\":[\"stages and buildings\"],\"VNCpBk\":[\"For rent\"],\"4Ri+A0\":[\"For Rent\"],\"MepnY2\":[\"Rental deposit\"],\"7aYzgc\":[\"Rental price\"],\"2eknBD\":[\"Rental service charge\"],\"vWP2Gj\":[\"Rented\"],\"PZtPFD\":[\"Download floorplan\"],\"dhu12h\":[\"Download image\"],\"2pOUCj\":[\"Download floorplan (PDF)\"],\"dcb95U\":[\"E\"],\"eKhYz9\":[\"N\"],\"C+dBfp\":[\"NE\"],\"K38WB7\":[\"NW\"],\"ZQA8ce\":[\"S\"],\"a9d3NA\":[\"SE\"],\"7Kfz4p\":[\"SW\"],\"QnXXNN\":[\"W\"],\"/QcZLG\":[\"Marketer\"],\"g2UNkE\":[\"Powered by\"],\"INHBKa\":[\"Skip video\"],\"KMgp2+\":[[\"0\"],\" available\"],\"Ig4phb\":[[\"countLabel\"],\" available\"],\"Nu4oKW\":[\"Description\"],\"H9a3W2\":[\"Energy Label\"],\"G2QGrk\":[\"<0>View in 3D</0>\"],\"qXjON+\":[\"Back to unit details\"],\"7cjMnD\":[\"Experience the home\"],\"1ODx06\":[\"Walk around the home in 3D and get to know the apartment in a whole new way!\"],\"9q90xa\":[\"See other angle of stage to see the location of this building\"],\"ScJ9fj\":[\"Privacy policy\"],\"tvnPhU\":[\"From-to price\"],\"0a7PDu\":[\"From-To Price\"],\"IS0D1W\":[\"3D Interior\"],\"U+kFad\":[\"Gallery\"],\"GEqWeF\":[\"Floorplans / Gallery\"],\"EIxe+B\":[\"Purchase price (from)\"],\"Ex5oXc\":[\"Purchase price (to)\"],\"9Qv28Z\":[\"Balcony View\"],\"lgFfeO\":[\"Sold out\"],\"BdyTPm\":[\"Download video\"],\"9U5DaL\":[\"Glazed balcony usable area (BRA-B) \"],\"uYwh2W\":[[\"0\"],\" balcony view\"]}");

});


parcelRegister("3ZQmJ", function(module, exports) {

$parcel$export(module.exports, "setBrandingColors", () => $8dcfef1bd83a9bca$export$8333b2d6f1f17802);


const $8dcfef1bd83a9bca$var$textColor = (useLightTextColor = true)=>useLightTextColor ? '#FFFFFF' : '#000000';
const $8dcfef1bd83a9bca$export$4c318f5cf351aa = (backgroundColor, textColor)=>{
    if ((0, $kIarK$chromajs).valid(backgroundColor) && (0, $kIarK$chromajs)(backgroundColor).luminance() < 1) {
        document.documentElement.style.setProperty('--modal-background-custom-primary', backgroundColor);
        document.documentElement.style.setProperty('--modal-text-custom-primary', textColor);
    }
};
const $8dcfef1bd83a9bca$export$8333b2d6f1f17802 = (options)=>{
    const { backgroundColor: backgroundColor = '#FFFFFF', primaryColor: primaryColor = '#107A54', useLightTextColor: useLightTextColor = false, useLightTextColorForPrimaryButton: useLightTextColorForPrimaryButton = true } = options;
    (0, $kIarK$setCustomButtonColors)(primaryColor, $8dcfef1bd83a9bca$var$textColor(useLightTextColorForPrimaryButton));
    const customTextColor = $8dcfef1bd83a9bca$var$textColor(useLightTextColor);
    document.documentElement.style.setProperty('--text-custom-primary', customTextColor);
    document.documentElement.style.setProperty('--background-custom-primary', backgroundColor);
    $8dcfef1bd83a9bca$export$4c318f5cf351aa(backgroundColor, customTextColor);
};

});

parcelRegister("kE5BV", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $f34bfe15bc444429$export$164de7ab8df77ef0);
$parcel$export(module.exports, "useTheme", () => $f34bfe15bc444429$export$93d4e7f90805808f);
const $f34bfe15bc444429$export$b331e6a554bef080 = {
    ui: '#545454',
    background: '#FFFFFF',
    primary: '#22C980',
    secondary: '#E49733',
    ppPolygonBorder: '#FFFFFF',
    ppComingForSale: '#0084FF',
    ppForSale: '#21C980',
    ppReserved: '#E49734',
    ppSold: '#E8583B',
    ppPartiallyOwned: '#AE68BA'
};
const $f34bfe15bc444429$export$164de7ab8df77ef0 = {
    colors: $f34bfe15bc444429$export$b331e6a554bef080,
    scales: {
        text: 1,
        space: 1,
        rounded: 1,
        border: 1
    },
    fonts: {
        primary: 'Lato',
        secondary: 'Roboto'
    }
};
const $f34bfe15bc444429$export$93d4e7f90805808f = (theme)=>{
    Object.entries(theme).map(([prefix, properties])=>{
        document.documentElement.style.setProperty(`${prefix}`, String(properties));
    });
};

});










var $BO02E = parcelRequire("BO02E");

var $beILY = parcelRequire("beILY");
const $db9097cd98a91b4b$export$8abf45a3ec85474d = (currency)=>{
    return currency === 'NOK';
};



var $37CU7 = parcelRequire("37CU7");







parcelRequire("03tHb");
var $eYvp0 = parcelRequire("eYvp0");


const $678f6de840b27996$export$3427e80ee71d60ba = (str)=>{
    try {
        JSON.parse(str);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return false;
    }
    return true;
};


const $81c3430b034efb71$export$59c34a18e3d554a9 = (e)=>typeof e.data === 'string' && (0, $678f6de840b27996$export$3427e80ee71d60ba)(e.data) ? JSON.parse(e.data) : null;


const $3b9711ad06ff043a$export$e09ec91314b78d07 = ({ formRef: formRef })=>{
    (0, $kIarK$useEffect)(()=>{
        const handleFiltersChange = (e)=>{
            const data = (0, $81c3430b034efb71$export$59c34a18e3d554a9)(e);
            if (data?.type === 'change-filters') {
                const { values: values } = JSON.parse(e.data);
                const form = formRef.current;
                const formValues = form.getState().values;
                if ((0, $kIarK$isNil)(values)) {
                    form.reset();
                    return;
                }
                form.batch(()=>{
                    Object.entries(values.filters).forEach(([filter, value])=>{
                        const defaultValue = formValues[filter]?.default;
                        const sanitizedValue = Array.isArray(value) ? value.sort((a, b)=>a - b) : value;
                        form.change(filter, {
                            default: defaultValue,
                            value: sanitizedValue,
                            temporary: sanitizedValue
                        });
                    });
                });
            }
        };
        window.addEventListener('message', handleFiltersChange);
        return ()=>window.removeEventListener('message', handleFiltersChange);
    }, [
        formRef
    ]);
};




const $39e51ae0969551d7$export$26531d8e255edf16 = (0, $kIarK$createWithEqualityFn)(()=>({
        levels: {},
        currency: 'NOK',
        elements: [],
        scenes: [],
        rendererType: '2d'
    }), (0, $kIarK$shallow));


const $670000472aba54a3$export$2e3feefe77201a07 = /*#__PURE__*/ (0, $kIarK$createContext)(null);
const $670000472aba54a3$export$f8286b88eb1abde5 = (filter)=>(0, $eYvp0.rangeFilters).includes(filter);
const $670000472aba54a3$export$52821e78ce69267e = (filter)=>(0, $eYvp0.checkboxFilters).includes(filter);
const $670000472aba54a3$var$updatePriceRange = (baseRange, fromToPriceRange)=>{
    return [
        ...baseRange,
        ...fromToPriceRange
    ].flat();
};
const $670000472aba54a3$var$generateRangeValue = (range)=>{
    const min = Math.min(...range);
    const max = Math.max(...range);
    return [
        isFinite(min) ? min : 0,
        isFinite(max) ? max : 0
    ];
};
const $670000472aba54a3$export$905df3588d1d8c75 = ({ children: children })=>{
    const { elements: elements, settings: settings } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { showSoldUnitsByDefault: showSoldUnitsByDefault } = settings ?? {};
    const formRef = (0, $kIarK$useRef)(null);
    const showSoldUnits = (0, $kIarK$useMemo)(()=>{
        const formValue = formRef.current?.getState().values.showSoldUnits;
        if ((0, $kIarK$isNil)(formValue?.value)) return {
            default: showSoldUnitsByDefault,
            temporary: showSoldUnitsByDefault,
            value: showSoldUnitsByDefault
        };
        return formValue;
    }, [
        showSoldUnitsByDefault
    ]);
    const getUnitsPropertyRange = (0, $kIarK$useCallback)((key)=>(0, $kIarK$uniq)(elements.filter(({ type: type })=>type === 'unit').filter((unit)=>{
            if (unit.soldOut && !showSoldUnits.value) return false;
            return true;
        }).map(({ properties: properties })=>properties[key]).filter((property)=>Boolean(property)).map(({ rawValue: rawValue })=>rawValue)), [
        elements,
        showSoldUnits.value
    ]);
    const initialValues = (0, $kIarK$useMemo)(()=>{
        const initialRangeFilters = (0, $eYvp0.rangeFilters).reduce((acc, filterId)=>{
            let range = getUnitsPropertyRange((0, $eYvp0.FilterToPropertyMap)[filterId] ?? filterId);
            // From-To Pricing is included in purchasePrice filter
            if (filterId === 'purchasePrice') range = $670000472aba54a3$var$updatePriceRange(range, getUnitsPropertyRange('fromToPrice'));
            const value = $670000472aba54a3$var$generateRangeValue(range);
            return {
                ...acc,
                [filterId]: {
                    default: value,
                    temporary: value
                }
            };
        }, {});
        const initialCheckboxFilters = (0, $eYvp0.checkboxFilters).reduce((acc, filterId)=>{
            const values = getUnitsPropertyRange('type');
            const value = values.filter((value, index, self)=>self.indexOf(value) === index);
            return {
                ...acc,
                [filterId]: {
                    default: value,
                    temporary: value
                }
            };
        }, {});
        return {
            ...initialRangeFilters,
            ...initialCheckboxFilters,
            showSoldUnits: showSoldUnits
        };
    }, [
        getUnitsPropertyRange,
        showSoldUnits
    ]);
    (0, $3b9711ad06ff043a$export$e09ec91314b78d07)({
        formRef: formRef
    });
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Form), {
        initialValuesEqual: (0, $kIarK$equals),
        initialValues: initialValues,
        onSubmit: ()=>{},
        children: ({ form: form, values: values })=>{
            formRef.current = form;
            return /*#__PURE__*/ (0, $kIarK$jsx)($670000472aba54a3$export$2e3feefe77201a07.Provider, {
                value: values,
                children: children
            });
        }
    });
};


parcelRequire("03tHb");
var $eYvp0 = parcelRequire("eYvp0");

const $d6bae723e3580231$var$isBetween = (value, filter)=>value >= filter[0] && value <= filter[1];
const $d6bae723e3580231$export$aee332ce1e8697e7 = ({ element: element, filters: filters, mode: mode = 'value', showPolygons: showPolygons = false })=>{
    if (element.type !== 'unit') return true;
    // Force show sold polygons if setting is activated
    if (showPolygons && element.soldOut) return true;
    const hasFromToPrice = Boolean(element.properties.fromToPrice) && element.rangedPurchasePrice && Array.isArray(element.properties.fromToPrice.rawValue);
    const availableRangeFilters = (0, $eYvp0.rangeFilters).filter((id)=>filters[id]?.[mode]);
    const doesNotPassRangeFilters = availableRangeFilters.some((id)=>{
        const propertyKey = (0, $eYvp0.FilterToPropertyMap)[id] ?? id;
        if (propertyKey === 'purchasePrice' && hasFromToPrice) {
            const [priceMin, priceMax] = filters[id][mode];
            const [min, max] = element.properties.fromToPrice.rawValue;
            const isWithinRange = min >= priceMin && max <= priceMax;
            return !isWithinRange;
        }
        const range = filters[id]?.default;
        if (range[0] === 0 && range[0] === range[1]) return false;
        const value = element.properties[propertyKey]?.rawValue;
        return !$d6bae723e3580231$var$isBetween(value, filters[id]?.[mode]);
    });
    if (doesNotPassRangeFilters) return false;
    if (filters.type?.[mode]) {
        if (!filters.type?.[mode].includes(element.properties.type?.rawValue)) return false;
    }
    if (element.soldOut && !filters.showSoldUnits?.[mode]) return false;
    return true;
};
const $d6bae723e3580231$export$a7fc736c99fb8c72 = (elements, mode, options)=>{
    const baseFilters = (0, $kIarK$useContext)((0, $670000472aba54a3$export$2e3feefe77201a07));
    const { dirtyFields: dirtyFields } = (0, $kIarK$useForm)().getState();
    const filters = mode === 'temporary' ? (0, $kIarK$pick)([
        ...Object.keys(dirtyFields),
        'showSoldUnits'
    ], baseFilters) : baseFilters;
    const filter = (element)=>$d6bae723e3580231$export$aee332ce1e8697e7({
            element: element,
            filters: filters,
            mode: mode
        });
    if (options?.softDelete) return elements.map((element)=>filter(element) ? element : {
            ...element,
            softDeleted: true
        });
    else return elements.filter(filter);
};
const $d6bae723e3580231$export$22132c7d12dc1e4c = (elements, filters, mode)=>elements.filter((element)=>$d6bae723e3580231$export$aee332ce1e8697e7({
            element: element,
            filters: filters,
            mode: mode
        }));
const $d6bae723e3580231$export$ebce7778ea73786e = (references)=>{
    const elements = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.elements);
    const filters = (0, $kIarK$useContext)((0, $670000472aba54a3$export$2e3feefe77201a07));
    return (0, $kIarK$useMemo)(()=>$d6bae723e3580231$export$bf6953c147a3aa6f({
            references: references,
            elements: elements,
            filters: filters
        }), [
        filters,
        references,
        elements
    ]);
};
const $d6bae723e3580231$var$searchParams = new URLSearchParams(window.location.search);
const $d6bae723e3580231$var$environment = $d6bae723e3580231$var$searchParams.get('environment');
const $d6bae723e3580231$export$bf6953c147a3aa6f = ({ references: references, elements: elements, filters: filters, showPolygons: showPolygons })=>references.filter((reference)=>{
        const element = elements.find((element)=>element.uuid === reference.parent);
        return element && $d6bae723e3580231$export$aee332ce1e8697e7({
            element: element,
            filters: filters,
            showPolygons: showPolygons
        }) && reference.points.length > 2 && (!reference.draft || $d6bae723e3580231$var$environment === 'preview');
    });





var $BO02E = parcelRequire("BO02E");

const $d671d4feb12106e5$export$21ad8b48cbcbbf1 = (uuidList, elements)=>uuidList.filter((value, index, arr)=>arr.indexOf(value) === index).map((uuid)=>elements.find((unit)=>unit.uuid === uuid)).filter(Boolean);


const $4a2330ccd45e58ac$var$searchParams = new URLSearchParams(window.location.search);
const $4a2330ccd45e58ac$var$environment = $4a2330ccd45e58ac$var$searchParams.get('environment');
const $4a2330ccd45e58ac$export$8ea3b606477de083 = (reference)=>{
    if (reference.draft && $4a2330ccd45e58ac$var$environment === 'preview') return true;
    return !reference.draft;
};
const $4a2330ccd45e58ac$export$c0e506a8d7518b9c = ({ uuid: uuid, type: type, scenes: scenes, elements: elements })=>{
    if (type === 'project') {
        const allReferences = (0, $kIarK$uniqBy)((0, $kIarK$prop)('parent'), scenes.flatMap(({ references: references })=>references)).filter(({ target: target })=>target.type === 'unit');
        return (0, $d671d4feb12106e5$export$21ad8b48cbcbbf1)(allReferences.filter($4a2330ccd45e58ac$export$8ea3b606477de083).map(({ target: target })=>target.id), elements);
    } else if (type === 'stage') {
        let results = [];
        const stageScenes = scenes.filter((scene)=>scene.element === uuid);
        const allReferences = (0, $kIarK$uniqBy)((0, $kIarK$prop)('parent'), stageScenes.flatMap(({ references: references })=>references)).filter($4a2330ccd45e58ac$export$8ea3b606477de083);
        allReferences.forEach((reference)=>{
            if (reference.target.type === 'view') {
                const targetScene = scenes.find(({ uuid: uuid })=>uuid === reference.target.id);
                if (!targetScene) return;
                const targetSceneReferences = [
                    ...targetScene.references,
                    ...targetScene.relatedReferences
                ];
                results = [
                    ...results,
                    ...targetSceneReferences
                ];
            } else if (reference.target.type === 'unit') results.push(reference);
        });
        return (0, $d671d4feb12106e5$export$21ad8b48cbcbbf1)(results.map(({ target: target })=>target.id), elements);
    }
    if (type === 'building') {
        const buildingScenes = (0, $kIarK$uniqBy)((0, $kIarK$path)([
            'target',
            'id'
        ]), scenes.filter(({ promotable: promotable })=>promotable.uuid === uuid).flatMap(({ references: references, relatedReferences: relatedReferences })=>[
                ...references,
                ...relatedReferences
            ]).filter($4a2330ccd45e58ac$export$8ea3b606477de083));
        return (0, $d671d4feb12106e5$export$21ad8b48cbcbbf1)(buildingScenes.map(({ target: target })=>target.id), elements);
    }
    return [];
};



const $f493c6d50f18ed2f$var$getUnitsUuidFromReferences = (scenes, references, visitedScenes = new Set())=>{
    const result = [];
    for (const reference of references){
        const { target: target } = reference;
        if (!(0, $4a2330ccd45e58ac$export$8ea3b606477de083)(reference)) continue;
        if (target.type === 'unit') {
            result.push(target.id);
            continue;
        }
        if (target.type === 'view') {
            if (visitedScenes.has(target.id)) continue;
            const targetScene = scenes.find(({ uuid: uuid })=>uuid === target.id);
            if (!targetScene) continue;
            visitedScenes.add(target.id);
            result.push(...$f493c6d50f18ed2f$var$getUnitsUuidFromReferences(scenes, [
                ...targetScene.references,
                ...targetScene.relatedReferences
            ], visitedScenes));
        }
    }
    return result;
};
const $f493c6d50f18ed2f$export$3a0a5ff75750cc2c = ()=>{
    const { elements: elements, scenes: scenes } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { view: scene } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    if (!scene) return [];
    const unitsUuidList = (0, $kIarK$uniq)($f493c6d50f18ed2f$var$getUnitsUuidFromReferences(scenes, [
        ...scene.references,
        ...scene.relatedReferences
    ]));
    return elements.filter(({ uuid: uuid })=>unitsUuidList.includes(uuid));
};




var $BO02E = parcelRequire("BO02E");

const $164070db97899be6$export$66b4faa78018d04a = ()=>{
    const { setActiveUnit: setActiveUnit } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const { settings: settings } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    return (element)=>{
        if (settings.unitsUrlType === 'custom') window.open(new URL(element.customUrl).toString(), '_blank');
        else setActiveUnit(element.uuid);
    };
};












const $a214f925853e97a5$var$useDataType = (dataType)=>{
    (0, $kIarK$useLingui)();
    const dataTypeTranslations = {
        units: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "LF/DpI"
        }),
        stagesAndBuildings: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "c9bpF5"
        }),
        references: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "Re8hm5"
        })
    };
    return dataTypeTranslations[dataType];
};
const $a214f925853e97a5$export$f3f2e7ed2b6256b1 = ({ dataType: dataType })=>{
    (0, $kIarK$useLingui)();
    const translatedDataType = $a214f925853e97a5$var$useDataType(dataType);
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "bg-custom-ui-90 flex h-12 items-center justify-center gap-2 text-base leading-[1.42] font-normal",
        "data-testid": `no-${dataType}-for-filters-message`,
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Info), {
                color: "var(--color-ui-90-text-primary)",
                size: 16
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                id: "KXbgIx",
                values: {
                    translatedDataType: translatedDataType
                }
            })
        ]
    });
};


parcelRequire("03tHb");
var $hGnqz = parcelRequire("hGnqz");
const $985f763c135152f7$export$7e4aa119212bc614 = (value)=>typeof value === 'number' && !isNaN(value);
const $985f763c135152f7$export$bbf2f88383591790 = (value)=>!isNaN(Number(value));



var $d27623cf10e57dbf$exports = {};

$parcel$export($d27623cf10e57dbf$exports, "table", () => $d27623cf10e57dbf$export$9852986a3ec5f6a0, (v) => $d27623cf10e57dbf$export$9852986a3ec5f6a0 = v);
var $d27623cf10e57dbf$export$9852986a3ec5f6a0;
$d27623cf10e57dbf$export$9852986a3ec5f6a0 = `_2Damna_table`;



const $174525dc3c3a0c47$export$35652c12e6caefdf = (a, b)=>String(a).localeCompare(String(b), (0, $kIarK$i18n).locale || 'en', {
        numeric: true,
        sensitivity: 'base'
    });
const $174525dc3c3a0c47$export$d40c4ae552b5068b = (a, b)=>a - b;


const $9a1b7b0e80919901$var$initialPinning = {
    left: [
        'unitId',
        'title'
    ]
};
const $9a1b7b0e80919901$var$getRowState = (row)=>row.original.properties?.state?.rawValue ?? row.original?.state;
const $9a1b7b0e80919901$export$54ec01a60f47d33d = (props)=>{
    const { data: data, columns: columns, hovered: hovered, focusedElement: focusedElement, onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave, onRowClick: onRowClick, className: className, isLoading: isLoading } = props;
    const settings = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.settings);
    const columnAccessors = columns.map((column)=>column.accessorKey);
    const [columnPinning] = (0, $kIarK$useState)($9a1b7b0e80919901$var$initialPinning);
    const [sorting, handleSortingChange] = (0, $kIarK$useState)([
        {
            id: settings.settings?.defaultUnitSortingProperty,
            desc: settings.settings?.defaultUnitSortingOrder === 'desc'
        },
        {
            id: 'unitId',
            desc: false
        }
    ].filter((column)=>columnAccessors.includes(column.id)));
    const [pagination, handlePaginationChange] = (0, $kIarK$useState)({
        pageIndex: 0,
        pageSize: 15
    });
    const dataType = columnAccessors[0] == 'unitId' ? 'units' : 'stagesAndBuildings';
    if (data.length === 0 && !isLoading) return /*#__PURE__*/ (0, $kIarK$jsx)((0, $a214f925853e97a5$export$f3f2e7ed2b6256b1), {
        dataType: dataType
    });
    return(// @ts-ignore
    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Table), {
        data: data,
        columns: columns,
        isLoading: isLoading,
        enableColumnPinning: true,
        pageCount: Math.ceil(data.length / pagination.pageSize),
        pageSize: pagination.pageSize,
        className: (0, $kIarK$classnames)('relative z-0', className, (0, (/*@__PURE__*/$parcel$interopDefault($d27623cf10e57dbf$exports))).table),
        onRowClick: isLoading ? undefined : onRowClick,
        state: {
            columnPinning: columnPinning,
            pagination: pagination,
            sorting: sorting
        },
        onRowMouseEnter: onRowMouseEnter,
        onRowMouseLeave: onRowMouseLeave,
        onPaginationChange: handlePaginationChange,
        onSortingChange: handleSortingChange,
        getRowClassName: (row, rowState)=>{
            const element = row.original;
            if (isLoading) return 'cursor-pointer p-2!';
            return (0, $kIarK$classnames)('cursor-pointer p-2', element.notAvailable ? 'cursor-default' : '', rowState.hovered || element?.uuid === hovered || element?.uuid === focusedElement ? element.notAvailable ? 'bg-[#fce9e5]' : 'bg-[#edf9f0]' : '', {
                'hover:bg-[#edf9f0]': !element.notAvailable,
                'hover:bg-[#fce9e5]': element.notAvailable
            });
        },
        sortingFns: {
            alphanumeric: (rowA, rowB, columnId)=>{
                const rowAValue = rowA.getValue(columnId);
                const rowBValue = rowB.getValue(columnId);
                const valueA = rowAValue?.rawValue ?? rowAValue?.value;
                const valueB = rowBValue?.rawValue ?? rowBValue?.value;
                const currentSortDirection = rowA._getAllCellsByColumnId()[columnId].column.getIsSorted();
                const desc = currentSortDirection === 'desc';
                if ((0, $kIarK$isNil)(valueA) && (0, $kIarK$isNil)(valueB)) return 0;
                if ((0, $kIarK$isNil)(valueA)) return desc ? -1 : 1;
                if ((0, $kIarK$isNil)(valueB)) return desc ? 1 : -1;
                if ((0, $985f763c135152f7$export$bbf2f88383591790)(valueA) && (0, $985f763c135152f7$export$bbf2f88383591790)(valueB)) return (0, $174525dc3c3a0c47$export$d40c4ae552b5068b)(valueA, valueB);
                return (0, $174525dc3c3a0c47$export$35652c12e6caefdf)(String(valueA), String(valueB));
            },
            saleState: (rowA, rowB)=>{
                const rowAValue = $9a1b7b0e80919901$var$getRowState(rowA);
                const rowBValue = $9a1b7b0e80919901$var$getRowState(rowB);
                const first = (0, $hGnqz.unitStates).findIndex((saleState)=>saleState === rowAValue);
                const second = (0, $hGnqz.unitStates).findIndex((saleState)=>saleState === rowBValue);
                return first - second;
            }
        }
    }));
};






var $bWmJ8 = parcelRequire("bWmJ8");

var $beILY = parcelRequire("beILY");

var $4l8zw = parcelRequire("4l8zw");
const $c51c90d781bf4c08$var$fallbackValue = '-';
const $c51c90d781bf4c08$export$1728f626374c87c6 = (args)=>{
    (0, $kIarK$useLingui)();
    const { columns: columns, labels: labels = (0, $beILY.canonicalUnitProperties) } = args;
    const canonicalUnitStates = (0, $beILY.getCanonicalUnitStates)();
    return columns.map((column)=>{
        if (column === 'state') return {
            accessorKey: 'state',
            header: labels[column],
            cell: (cell)=>{
                const propertyValue = cell.row.original.properties[column];
                const columnValue = cell.row.original.state;
                const state = propertyValue ?? {
                    value: (0, $kIarK$camelize)(columnValue),
                    displayValue: canonicalUnitStates[columnValue]
                };
                if (!state || !(0, $4l8zw.isBadgeType)(state.value)) return $c51c90d781bf4c08$var$fallbackValue;
                return /*#__PURE__*/ (0, $kIarK$jsx)((0, $bWmJ8.Badge), {
                    type: state.value,
                    value: state.displayValue
                });
            },
            sortingFn: 'saleState',
            sortUndefined: false,
            meta: {
                disableTruncate: true
            }
        };
        return {
            accessorKey: column,
            header: labels[column],
            cell: (cell)=>{
                const row = cell.row.original.properties[column];
                return row?.displayValue || $c51c90d781bf4c08$var$fallbackValue;
            },
            meta: $c51c90d781bf4c08$var$metaByColumns[column] ?? {
                disableTruncate: true
            },
            sortUndefined: false,
            sortingFn: 'alphanumeric'
        };
    });
};
const $c51c90d781bf4c08$var$metaByColumns = {
    unitId: {
        grow: true,
        disableTruncate: true
    },
    description: {
        disableTruncate: false
    }
};


const $e50315c32b80c5ce$var$List = ()=>{
    const { project: project, elements: elements, settings: settings } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { event: event } = (0, $37CU7.useAnalytics)(project.uuid);
    const { hovered: hovered, focusedElement: focusedElement, isLoading: isLoading } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const navigationRef = (0, $kIarK$useRef)();
    const data = (0, $d6bae723e3580231$export$a7fc736c99fb8c72)((0, $f493c6d50f18ed2f$export$3a0a5ff75750cc2c)()).map((element)=>({
            ...element,
            ...element.properties
        }));
    const filterOutNorwegianProperties = (key)=>{
        if ((0, $db9097cd98a91b4b$export$8abf45a3ec85474d)(project.currency)) return true;
        return (0, $beILY.canonicalNorwegianUnitProperties)[key] === undefined;
    };
    const newEvent = (type, unitUuid, element)=>event({
            type: type,
            unitUuid: unitUuid,
            additionalParameters: {
                buildingId: element.building,
                stageId: element.stage,
                targetType: 'row'
            }
        });
    const unitClickHandler = (0, $164070db97899be6$export$66b4faa78018d04a)();
    const onRowClick = (row)=>{
        const unitUuid = row.original.uuid;
        const element = elements.find(({ uuid: uuid })=>uuid === unitUuid);
        if (!element || element.notAvailable && !settings.allowNotAvailableInteraction) return;
        newEvent('property_selector_click', unitUuid, element);
        unitClickHandler(element);
    };
    const onRowMouseEnter = (row)=>{
        const unitUuid = row.original.uuid;
        const element = elements.find(({ uuid: uuid })=>uuid === unitUuid);
        if (!element) return;
        newEvent('hover_property', unitUuid, element);
    };
    const columns = (0, $c51c90d781bf4c08$export$1728f626374c87c6)({
        columns: settings.properties.unit.list.filter((key)=>filterOutNorwegianProperties(key))
    });
    return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        ref: navigationRef,
        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $9a1b7b0e80919901$export$54ec01a60f47d33d), {
            hovered: hovered,
            focusedElement: focusedElement,
            data: data,
            columns: columns,
            onRowClick: onRowClick,
            onRowMouseEnter: onRowMouseEnter,
            isLoading: isLoading || elements.length === 0
        })
    });
};
var $e50315c32b80c5ce$export$2e2bcd8739ae039 = $e50315c32b80c5ce$var$List;




const $7f2ddd8f5333af3c$var$LazyUnitModal = /*#__PURE__*/ (0, $kIarK$lazy)(()=>(parcelRequire("68z5m")));
var $7f2ddd8f5333af3c$export$2e2bcd8739ae039 = $7f2ddd8f5333af3c$var$LazyUnitModal;











var $BO02E = parcelRequire("BO02E");

var $beILY = parcelRequire("beILY");

var $dqNEo = parcelRequire("dqNEo");
const $001b9397325ba22b$export$a904af9c1628c179 = (args)=>{
    const { container: container, element: element, options: options } = args;
    const containerWidth = container.clientWidth;
    const elementWidth = element.clientWidth ?? 0;
    const elementLeft = element.offsetLeft ?? 0;
    const newScrollPosition = elementLeft - (containerWidth - elementWidth) / 2;
    container.scrollTo({
        left: newScrollPosition,
        ...options
    });
};




parcelRequire("03tHb");
var $hGnqz = parcelRequire("hGnqz");

const $c340dfa5f259f79b$export$da79a14b96965666 = (0, $kIarK$defaultTo)([]);


const $cccd4ab284f0e6e2$export$b7584c18dfc5ae3d = (balconies)=>(0, $c340dfa5f259f79b$export$da79a14b96965666)(balconies).map((balcony)=>({
            ...balcony,
            sizeString: `${balcony.size} m\xb2`
        }));



const $50df32bd4cf831d5$export$ed5dca9942183cd9 = (parent)=>{
    // unit
    if ('state' in parent && parent.state) return parent.state === 'coming_for_sale';
    // building
    if ('units' in parent) return ((0, $kIarK$countBy)((0, $kIarK$prop)('state'), parent.units).coming_for_sale || 0) === parent.units.length;
    return false;
};



var $beILY = parcelRequire("beILY");
const $94e177b579c99d23$export$3edecb93ccf80642 = ({ parent: parent })=>{
    const facilitiesKey = 'facilities' in parent ? parent.facilities : [];
    const canonicalFacilities = (0, $beILY.getCanonicalFacilities)();
    return facilitiesKey.map((facility)=>({
            label: canonicalFacilities[facility],
            value: facility
        }));
};








const $35a902cbeadd28dc$var$buildFormatter = ({ style: style, notation: notation, currency: currency })=>new Intl.NumberFormat((0, $kIarK$i18n).locale, {
        style: style,
        notation: notation,
        currency: currency,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    });
const $35a902cbeadd28dc$var$formatters = {};
const $35a902cbeadd28dc$export$c86caf1be068fb8d = (props)=>{
    const { price: price, style: style, notation: notation } = props;
    const currency = (0, $39e51ae0969551d7$export$26531d8e255edf16).getState().currency;
    const formatterKey = `${currency}${style}${notation}`;
    if (!(formatterKey in $35a902cbeadd28dc$var$formatters)) $35a902cbeadd28dc$var$formatters[formatterKey] = $35a902cbeadd28dc$var$buildFormatter({
        style: style,
        notation: notation,
        currency: currency
    });
    return $35a902cbeadd28dc$var$formatters[formatterKey].format(price);
};


const $63fee1c4e96e1f42$export$eea52e9fa63cb0a9 = (parkings)=>(0, $c340dfa5f259f79b$export$da79a14b96965666)(parkings).filter((parking)=>parking.state === 'for_sale' || parking.state === 'included').map((parking)=>({
            ...parking,
            priceString: (0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
                price: parking.price,
                style: 'currency'
            })
        }));





var $beILY = parcelRequire("beILY");






const $842b3ee272b1ea80$export$f46e5275aed7a8f3 = (parent)=>{
    // unit
    if ('state' in parent && parent.state) return parent.state === 'reserved';
    // building
    if ('units' in parent) return ((0, $kIarK$countBy)((0, $kIarK$prop)('state'), parent.units).reserved || 0) === parent.units.length;
    return false;
};


const $bc04f8fff6c9178c$export$55e919ea7786b9ab = ({ parent: parent, type: type })=>{
    if (type === 'unit') return [
        'sold',
        'archived'
    ].includes(parent.state);
    return false;
};


const $89fb6d2e82e80ec7$var$getUnavailableProperty = (label)=>({
        label: label,
        value: '-',
        rawValue: null,
        displayValue: '-'
    });
const $89fb6d2e82e80ec7$export$98e0fbaf541e55f4 = ({ unit: unit, key: key, label: label })=>{
    const isSoldOut = (0, $bc04f8fff6c9178c$export$55e919ea7786b9ab)({
        parent: unit,
        type: 'unit'
    });
    const isReserved = (0, $842b3ee272b1ea80$export$f46e5275aed7a8f3)(unit);
    const isComingForSale = (0, $50df32bd4cf831d5$export$ed5dca9942183cd9)(unit);
    const rawValue = unit[key];
    const price = parseFloat(rawValue);
    if (isSoldOut || isReserved || isComingForSale || price === parseFloat('0')) return $89fb6d2e82e80ec7$var$getUnavailableProperty(label);
    const value = (0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
        price: price,
        style: 'currency'
    });
    return {
        label: label,
        rawValue: rawValue,
        value: value,
        displayValue: value
    };
};





const $801f687d23b03d6d$export$e58177e1af27498d = (parent)=>{
    // unit
    if ('state' in parent && parent.state) return parent.state === 'for_rent';
    // building
    if ('units' in parent) return ((0, $kIarK$countBy)((0, $kIarK$prop)('state'), parent.units).for_rent || 0) === parent.units.length;
    return false;
};



const $76b6d0da1f77de52$export$c1bf01bb8dbc06d4 = (parent)=>{
    // unit
    if ('state' in parent && parent.state) return parent.state === 'rented';
    // building
    if ('units' in parent) return ((0, $kIarK$countBy)((0, $kIarK$prop)('state'), parent.units).rented || 0) === parent.units.length;
    return false;
};




const $34729559e53ad1b5$export$687d1429abbaf154 = (unit)=>{
    const isSoldOut = (0, $bc04f8fff6c9178c$export$55e919ea7786b9ab)({
        parent: unit,
        type: 'unit'
    });
    const isReserved = (0, $842b3ee272b1ea80$export$f46e5275aed7a8f3)(unit);
    const isComingForSale = (0, $50df32bd4cf831d5$export$ed5dca9942183cd9)(unit);
    const isRented = (0, $76b6d0da1f77de52$export$c1bf01bb8dbc06d4)(unit);
    const isForRent = (0, $801f687d23b03d6d$export$e58177e1af27498d)(unit);
    if (isSoldOut) return {
        value: 'sold',
        rawValue: 'sold',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "s9KGXU"
        })
    };
    if (isReserved) return {
        value: 'reserved',
        rawValue: 'reserved',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "Uwsg2F"
        })
    };
    if (isComingForSale) return {
        value: 'comingForSale',
        rawValue: 'comingForSale',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "PJR11c"
        })
    };
    if (isRented) return {
        value: 'rented',
        rawValue: 'rented',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "vWP2Gj"
        })
    };
    if (isForRent) return {
        value: 'forRent',
        rawValue: 'forRent',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "VNCpBk"
        })
    };
    return {
        value: 'forSale',
        rawValue: 'forSale',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "sRFr28"
        })
    };
};


const $f837f54d4cda52d9$export$2f9b8ee79476a739 = (args)=>{
    const { unit: unit, stages: stages, buildings: buildings, currency: currency, hideUnitPrices: hideUnitPrices } = args;
    const properties = {};
    const unitStageName = stages.find((stage)=>String(stage.uuid) === String(unit.stageId))?.name;
    const buildingName = buildings.find(({ uuid: uuid })=>uuid === unit.buildingUuid)?.name;
    const state = (0, $34729559e53ad1b5$export$687d1429abbaf154)(unit);
    const canonicalOwnershipTypes = (0, $beILY.getCanonicalOwnershipTypes)();
    const canonicalUnitTypes = (0, $beILY.getCanonicalUnitTypes)();
    const canonicalUnitStates = (0, $beILY.getCanonicalUnitStates)();
    if (unit.partiallyOwned) {
        unit.purchasePrice = unit.purchasePricePartOwnership;
        unit.totalPrice = unit.totalPricePartOwnership;
        unit.jointDebt = unit.jointDebtPartOwnership;
        unit.totalCosts = unit.totalCostsPartOwnership;
    }
    const addProperty = ({ key: key, label: label, value: value, suffix: suffix, displayValue: displayValue })=>{
        properties[key] = {
            label: label,
            value: `${value}${suffix ? ` ${suffix}` : ''}`,
            rawValue: value,
            displayValue: `${displayValue ?? value}${suffix ? ` ${suffix}` : ''}`
        };
    };
    const addPriceProperty = (key, label, asKey = key)=>{
        if (unit[key] && !hideUnitPrices) properties[asKey] = (0, $89fb6d2e82e80ec7$export$98e0fbaf541e55f4)({
            unit: unit,
            key: key,
            label: label
        });
    };
    const addNumericProperty = (key, label, suffix)=>{
        if ((0, $985f763c135152f7$export$7e4aa119212bc614)(unit[key])) addProperty({
            key: key,
            label: label,
            value: unit[key],
            suffix: suffix
        });
    };
    addProperty({
        key: 'unitId',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "aSwfbR"
        }),
        value: unit.unitId
    });
    const ownershipType = canonicalOwnershipTypes[unit.ownershipType] ?? '-';
    const ownershipTypeValue = unit.partiallyOwned ? `${ownershipType} ${parseInt(unit.ownershipPercentage)}%` : ownershipType;
    addProperty({
        key: 'ownershipType',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "oDAEQq"
        }),
        value: ownershipTypeValue
    });
    if (unit.description) addProperty({
        key: 'description',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "Nu4oKW"
        }),
        value: unit.description
    });
    if (unit.energyLabel) addProperty({
        key: 'energyLabel',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "H9a3W2"
        }),
        value: unit.energyLabel
    });
    addProperty({
        key: 'type',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "+zy2Nq"
        }),
        value: unit.type,
        displayValue: canonicalUnitTypes[unit.type]
    });
    const useFromToPricing = unit.rangedPurchasePrice && !hideUnitPrices;
    if (useFromToPricing) {
        const purchasePriceFrom = (0, $89fb6d2e82e80ec7$export$98e0fbaf541e55f4)({
            unit: unit,
            key: 'purchasePriceFrom',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "EIxe+B"
            })
        });
        const purchasePriceTo = (0, $89fb6d2e82e80ec7$export$98e0fbaf541e55f4)({
            unit: unit,
            key: 'purchasePriceTo',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "Ex5oXc"
            })
        });
        let rawValue = [
            parseFloat(unit.purchasePriceFrom),
            parseFloat(unit.purchasePriceTo)
        ];
        let displayValue = `${(0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
            price: parseFloat(unit.purchasePriceFrom),
            style: 'currency'
        })} - ${(0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
            price: parseFloat(unit.purchasePriceTo),
            style: 'currency'
        })}`;
        if (!purchasePriceFrom.rawValue || !purchasePriceTo.rawValue) {
            rawValue = null;
            displayValue = '-';
        }
        properties.fromToPrice = {
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "tvnPhU"
            }),
            rawValue: rawValue,
            displayValue: displayValue
        };
    }
    addPriceProperty('purchasePrice', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "a7u1N9"
    }));
    addPriceProperty('totalPrice', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "qqsfDU"
    }));
    addPriceProperty('jointDebt', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "OgACWb"
    }));
    addPriceProperty('totalCosts', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "mEKLZL"
    }));
    addPriceProperty('sharedPrice', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "hmd2Ji"
    }));
    addPriceProperty('monthlyRentalAmount', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "56vwJs"
    }));
    addPriceProperty('deposit', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "kj3M8S"
    }));
    if ([
        'forRent',
        'rented'
    ].includes(state.value)) {
        addPriceProperty('rentalPrice', (0, $kIarK$i18n)._(/*i18n*/ {
            id: "7aYzgc"
        }));
        addPriceProperty('rentalDeposit', (0, $kIarK$i18n)._(/*i18n*/ {
            id: "MepnY2"
        }));
        addPriceProperty('rentalServiceCharge', (0, $kIarK$i18n)._(/*i18n*/ {
            id: "2eknBD"
        }));
    }
    addNumericProperty('roomCount', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "Fglnvp"
    }));
    addNumericProperty('bedroomCount', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "mMQSH4"
    }));
    addNumericProperty('bathroomCount', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "t45b0O"
    }));
    addNumericProperty('floorNumber', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "oCHfGC"
    }));
    addNumericProperty('sizeM2', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "t6yDp0"
    }), "m\xb2");
    addNumericProperty('usableAreaM2', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "IodKQ0"
    }), "m\xb2");
    addNumericProperty('grossFloorAreaM2', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "+lY7Ar"
    }), "m\xb2");
    if (unit.state) addProperty({
        key: 'state',
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "RS0o7b"
        }),
        displayValue: canonicalUnitStates[unit.state],
        value: (0, $kIarK$camelize)(unit.state)
    });
    if ((0, $db9097cd98a91b4b$export$8abf45a3ec85474d)(currency)) {
        addNumericProperty('usableAreaI', (0, $kIarK$i18n)._(/*i18n*/ {
            id: "JwqVXG"
        }), "m\xb2");
        addNumericProperty('usableAreaE', (0, $kIarK$i18n)._(/*i18n*/ {
            id: "ij53KS"
        }), "m\xb2");
        addNumericProperty('usableAreaB', (0, $kIarK$i18n)._(/*i18n*/ {
            id: "oB+XVA"
        }), "m\xb2");
        addNumericProperty('openArea', (0, $kIarK$i18n)._(/*i18n*/ {
            id: "rWaJtl"
        }), "m\xb2");
    }
    addNumericProperty('lotSizeM2', (0, $kIarK$i18n)._(/*i18n*/ {
        id: "suo7tL"
    }), "m\xb2");
    if (unitStageName) properties.stageName = {
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "3PRxO3"
        }),
        value: unitStageName,
        displayValue: unitStageName
    };
    if (buildingName) properties.buildingName = {
        label: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "oZd08v"
        }),
        value: buildingName,
        displayValue: buildingName
    };
    return properties;
};


const $6b09ef2001c9662c$export$28195c1f3490f3f1 = (args)=>{
    const { parent: parent, stages: stages, buildings: buildings, type: type, currency: currency, hideUnitPrices: hideUnitPrices } = args;
    switch(type){
        case 'unit':
            return (0, $f837f54d4cda52d9$export$2f9b8ee79476a739)({
                unit: parent,
                stages: stages,
                buildings: buildings,
                currency: currency,
                hideUnitPrices: hideUnitPrices
            });
        default:
            return {};
    }
};




const $e36e3043be2b1d31$var$getStatus = (groups)=>{
    const keys = Object.keys(groups);
    const priorityStatuses = [
        'for_sale',
        'coming_for_sale',
        'reserved',
        'for_rent',
        'rented'
    ];
    return priorityStatuses.find((status)=>keys.includes(status)) || 'sold';
};
const $e36e3043be2b1d31$export$dc52bf3d902cd9c7 = ({ parent: parent, type: type, units: units })=>{
    if (type === 'stage') {
        const stage = parent;
        return stage.saleState;
    }
    if (type === 'building') {
        const buildingUnits = units.filter(({ buildingUuid: buildingUuid })=>buildingUuid === parent.uuid);
        const groups = (0, $kIarK$groupBy)((0, $kIarK$prop)('state'), buildingUnits);
        return $e36e3043be2b1d31$var$getStatus(groups);
    }
    return 'archived';
};



const $217f5b1b65076e9c$export$93e1eeb063c4c3f5 = (args)=>{
    const { stages: stages, buildings: buildings, units: units, currency: currency, hideUnitPrices: hideUnitPrices } = args;
    const elements = [];
    // stages
    for (const stage of stages)elements.push({
        uuid: stage.uuid,
        configured: false,
        title: stage.name,
        type: 'stage',
        properties: (0, $6b09ef2001c9662c$export$28195c1f3490f3f1)({
            parent: stage,
            stages: stages,
            buildings: buildings,
            type: 'stage',
            currency: currency,
            hideUnitPrices: hideUnitPrices
        }),
        facilities: (0, $94e177b579c99d23$export$3edecb93ccf80642)({
            parent: stage
        }),
        state: (0, $e36e3043be2b1d31$export$dc52bf3d902cd9c7)({
            parent: stage,
            type: 'stage',
            units: units
        })
    });
    // buildings
    for (const building of buildings)elements.push({
        uuid: building.uuid,
        configured: false,
        title: building.name,
        type: 'building',
        properties: (0, $6b09ef2001c9662c$export$28195c1f3490f3f1)({
            parent: building,
            stages: stages,
            buildings: buildings,
            type: 'building',
            currency: currency,
            hideUnitPrices: hideUnitPrices
        }),
        facilities: (0, $94e177b579c99d23$export$3edecb93ccf80642)({
            parent: building
        }),
        state: (0, $e36e3043be2b1d31$export$dc52bf3d902cd9c7)({
            parent: building,
            type: 'building',
            units: units
        })
    });
    // units
    for (const unit of units){
        if (!unit) continue;
        const index = elements.findIndex((element)=>element.uuid === unit.uuid);
        const parentBuildingUuid = unit.buildingUuid;
        if (index !== -1) continue;
        const unitElement = {
            uuid: unit.uuid,
            configured: false,
            title: unit.unitId,
            type: 'unit',
            disclaimer: unit.disclaimer,
            parkingSlots: unit.parkingSlotsAmount,
            balconies: (0, $cccd4ab284f0e6e2$export$b7584c18dfc5ae3d)(unit.balconies),
            parkings: (0, $63fee1c4e96e1f42$export$eea52e9fa63cb0a9)(unit.parkings),
            partiallyOwned: unit.partiallyOwned,
            properties: (0, $6b09ef2001c9662c$export$28195c1f3490f3f1)({
                parent: unit,
                stages: stages,
                buildings: buildings,
                type: 'unit',
                currency: currency,
                hideUnitPrices: hideUnitPrices
            }),
            gallery: unit.gallery || [],
            floorplans: unit.floorplans,
            soldOut: (0, $bc04f8fff6c9178c$export$55e919ea7786b9ab)({
                parent: unit,
                type: 'unit'
            }),
            facilities: (0, $94e177b579c99d23$export$3edecb93ccf80642)({
                parent: unit
            }),
            reserved: (0, $842b3ee272b1ea80$export$f46e5275aed7a8f3)(unit),
            comingForSale: (0, $50df32bd4cf831d5$export$ed5dca9942183cd9)(unit),
            notAvailable: (0, $842b3ee272b1ea80$export$f46e5275aed7a8f3)(unit) || (0, $bc04f8fff6c9178c$export$55e919ea7786b9ab)({
                parent: unit,
                type: 'unit'
            }) || (0, $50df32bd4cf831d5$export$ed5dca9942183cd9)(unit),
            building: parentBuildingUuid,
            state: unit.state,
            stage: stages.find(({ uuid: uuid })=>uuid === unit.stageId)?.uuid
        };
        elements.push(unitElement);
    }
    return elements;
};


const $36b627c59aa1ba74$export$80a4a465fb11c8af = ({ uuid: uuid, project: project })=>{
    const findItemByUuid = (items, type)=>{
        const item = items.find((item)=>item.uuid === uuid);
        return item ? {
            type: type,
            parent: item
        } : {};
    };
    if (uuid === project.uuid) return {
        type: 'project',
        parent: project
    };
    const stageResult = findItemByUuid(project.stages, 'stage');
    if (stageResult.parent) return stageResult;
    const buildingResult = findItemByUuid(project.buildings, 'building');
    if (buildingResult.parent) return buildingResult;
    const unitResult = findItemByUuid(project.units, 'unit');
    if (unitResult.parent) return unitResult;
    return {};
};







const $4bd134a5c27c9e53$export$73eac51a39d6b0eb = ({ project: project, settings: settings })=>{
    const elements = (0, $217f5b1b65076e9c$export$93e1eeb063c4c3f5)({
        stages: project.stages,
        buildings: project.buildings,
        units: project.units,
        currency: project.currency,
        hideUnitPrices: settings.hideUnitPrices
    });
    return elements.map((element)=>{
        const { type: type, parent: parent } = (0, $36b627c59aa1ba74$export$80a4a465fb11c8af)({
            uuid: element.uuid,
            project: project
        });
        if (!parent) return element;
        const newElement = {
            ...element,
            uuid: parent.uuid,
            configured: true,
            type: type,
            properties: (0, $6b09ef2001c9662c$export$28195c1f3490f3f1)({
                parent: parent,
                stages: project.stages,
                buildings: project.buildings,
                type: type,
                currency: project.currency,
                hideUnitPrices: settings.hideUnitPrices
            }),
            soldOut: (0, $bc04f8fff6c9178c$export$55e919ea7786b9ab)({
                parent: parent,
                type: type
            }),
            reserved: (0, $842b3ee272b1ea80$export$f46e5275aed7a8f3)(parent),
            comingForSale: (0, $50df32bd4cf831d5$export$ed5dca9942183cd9)(parent)
        };
        if (type === 'unit') {
            const parentUnit = parent;
            const parentBuildingUuid = parentUnit.buildingUuid;
            newElement.interiorUrl = parentUnit.interiorUrl;
            newElement.floorplans = parentUnit.floorplans;
            newElement.gallery = parentUnit.gallery || [];
            newElement.title = parentUnit.unitId || '';
            newElement.building = parentBuildingUuid;
            newElement.partiallyOwned = parentUnit.partiallyOwned;
            newElement.facilities = (0, $94e177b579c99d23$export$3edecb93ccf80642)({
                parent: parentUnit
            });
            newElement.checkoutUrl = parentUnit.checkoutUrl;
            newElement.parkingSlots = parentUnit.parkingSlotsAmount;
            newElement.disclaimer = parentUnit.disclaimer;
            newElement.balconies = (0, $cccd4ab284f0e6e2$export$b7584c18dfc5ae3d)(parentUnit.balconies);
            newElement.parkings = (0, $63fee1c4e96e1f42$export$eea52e9fa63cb0a9)(parentUnit.parkings);
            newElement.stage = parentUnit.stageId;
            newElement.state = parentUnit.state;
            newElement.customUrl = parentUnit.customUrl;
        } else {
            newElement.title = parent.name || '';
            newElement.state = (0, $e36e3043be2b1d31$export$dc52bf3d902cd9c7)({
                parent: parent,
                type: type,
                units: project.units
            });
            if (Object.prototype.hasOwnProperty.call(parent, 'mainSceneAsset')) newElement.asset = parent.mainSceneAsset;
        }
        newElement.notAvailable = (0, $hGnqz.unavailableUnitStates).includes(newElement.state);
        return newElement;
    });
};














const $c1bb177e572c26d8$export$7542a52ad8289565 = ({ uuid: uuid, scenes: scenes })=>{
    // Find the main view with the specified UUID if it exists
    const mainView = scenes.find((view)=>view.main && view.promotable.uuid === uuid);
    // If there is a main view with the specified UUID, return it
    if (mainView) return mainView;
    // If not, find the first view with the specified UUID
    const firstView = scenes.find((view)=>view.promotable.uuid === uuid);
    // Return the first view if found, otherwise return null
    return firstView ?? null;
};


const $e6fe67a25e431570$export$fd004ce6bcba12e3 = ({ startView: startView, scenes: scenes, elements: elements, project: project })=>{
    const uuid = project?.uuid ?? null;
    // Use root UUID provided by plugin startView prop
    if (startView) {
        const isView = scenes.some(({ uuid: uuid })=>uuid === startView);
        const isEntity = elements.some(({ uuid: uuid })=>uuid === startView);
        if (isView) return startView;
        else if (isEntity) return (0, $c1bb177e572c26d8$export$7542a52ad8289565)({
            uuid: startView,
            scenes: scenes
        })?.uuid;
    }
    return (0, $c1bb177e572c26d8$export$7542a52ad8289565)({
        uuid: uuid,
        scenes: scenes
    })?.uuid;
};






const $7e80c8905f947009$var$compassPoints = [
    'N',
    'NW',
    'W',
    'SW',
    'S',
    'SE',
    'E',
    'NE'
];
const $7e80c8905f947009$export$2dfde3f1d1c9e8ac = (scenes)=>{
    if (!scenes?.length) return [];
    let mainScene = scenes.find((scene)=>scene.main);
    if (!mainScene) mainScene = scenes[0];
    const availableDirections = scenes.map((scene)=>scene.direction);
    const availablePoints = $7e80c8905f947009$var$compassPoints.filter((point)=>availableDirections.includes(point));
    const mainIndex = availablePoints.indexOf(mainScene.direction);
    return [
        ...availablePoints.slice(mainIndex),
        ...availablePoints.slice(0, mainIndex)
    ].map((direction)=>scenes.find((scene)=>scene.direction === direction));
};





var $f9meZ = parcelRequire("f9meZ");




const $1b189b8190126d45$export$3415f3b823095a56 = (scene, cardinalDirections)=>scene.label ?? cardinalDirections[scene.direction];


const $6684c96130c0c59b$export$b23207294f708114 = (props)=>{
    const { scene: scene, cardinalDirections: cardinalDirections, isActive: isActive, isMobile: isMobile, onClick: onClick, sceneKey: sceneKey } = props;
    const activeImgClassName = 'shadow-sm';
    const inactiveImgClassName = (0, $kIarK$classnames)('opacity-45 transition-opacity', isMobile ? '' : 'hover:opacity-100');
    const viewportClass = isMobile ? 'w-20' : 'w-24';
    const tid = (0, $kIarK$useTestId)('scene');
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: (0, $kIarK$classnames)('flex cursor-pointer flex-col gap-0.5 pt-1', viewportClass),
        onClick: ()=>onClick(scene.uuid),
        "data-testid": `${sceneKey}-scene-card${isActive ? '-active' : ''}`,
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                className: "inline-block w-full overflow-hidden text-ellipsis whitespace-nowrap capitalize",
                testId: "scene-label",
                variant: "badge",
                style: {
                    color: 'var(--text-custom-primary)'
                },
                children: (0, $1b189b8190126d45$export$3415f3b823095a56)(scene, cardinalDirections)
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("img", {
                ...tid('preview-img'),
                src: scene.asset?.thumbnail ?? scene.asset?.url,
                className: (0, $kIarK$classnames)('rounded-sm border object-cover', isActive ? activeImgClassName : inactiveImgClassName, isMobile ? 'h-12' : 'h-[60px]')
            })
        ]
    });
};


const $712f560112679da6$export$810cc735c73f5876 = ()=>{
    const scenes = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.scenes);
    const { setActiveScene: setActiveScene, view: activeScene, setAppHistory: setAppHistory, appHistory: appHistory } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const isMobile = (0, $f9meZ.useIsMobile)();
    const containerRef = (0, $kIarK$useRef)(null);
    const cardRefs = (0, $kIarK$useRef)({});
    (0, $kIarK$useEffect)(()=>{
        if (activeScene && containerRef.current && cardRefs.current[activeScene.uuid]) {
            const activeCard = cardRefs.current[activeScene.uuid];
            (0, $001b9397325ba22b$export$a904af9c1628c179)({
                container: containerRef.current,
                element: activeCard,
                options: {
                    behavior: 'smooth'
                }
            });
        }
    }, [
        activeScene
    ]);
    const handleDirectionChange = (newView)=>{
        const history = appHistory.slice(0, appHistory.length - 1);
        (0, $dqNEo.default)('View change', newView);
        setActiveScene(newView);
        setAppHistory(history.concat([
            newView
        ]));
    };
    const relatedScenes = (0, $kIarK$useMemo)(()=>{
        return scenes.filter((scene)=>activeScene.relatedScenes.includes(scene.uuid));
    }, [
        scenes,
        activeScene
    ]);
    if (!activeScene || !relatedScenes.length) return null;
    const orderedScenes = (0, $7e80c8905f947009$export$2dfde3f1d1c9e8ac)([
        ...relatedScenes,
        activeScene
    ]);
    const containerClassName = (0, $kIarK$classnames)('flex flex-row overflow-x-auto hide-scrollbar gap-1 px-1 shrink-0 empty:h-auto empty:m-0', isMobile ? 'my-1 h-20' : 'my-4 bg-white bottom-6 left-6 h-[90px] rounded-sm');
    return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        className: containerClassName,
        ref: containerRef,
        style: {
            backgroundColor: 'var(--background-custom-primary)'
        },
        children: orderedScenes.map((scene, index)=>{
            const isActiveScene = scene.uuid === activeScene.uuid;
            return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                ref: (el)=>cardRefs.current[scene.uuid] = el,
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $6684c96130c0c59b$export$b23207294f708114), {
                    scene: scene,
                    isActive: isActiveScene,
                    onClick: handleDirectionChange,
                    sceneKey: index,
                    cardinalDirections: (0, $beILY.canonicalFacingDirections),
                    isMobile: isMobile
                })
            }, scene.uuid);
        })
    });
};







var $BO02E = parcelRequire("BO02E");

var $beILY = parcelRequire("beILY");


const $1a238eb2115705a2$export$68f4fb67dfa813b0 = ()=>{
    const { view: activeScene } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const scenes = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.scenes);
    const tid = (0, $kIarK$useTestId)('single-scene');
    const relatedScenes = (0, $kIarK$useMemo)(()=>{
        return scenes.filter((scene)=>activeScene.relatedScenes.includes(scene.uuid));
    }, [
        scenes,
        activeScene
    ]);
    if (relatedScenes?.length) return null;
    return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        className: "fex-row pointer-events-none absolute flex h-full w-full items-end justify-center pb-4",
        children: /*#__PURE__*/ (0, $kIarK$jsx)("div", {
            className: "flex max-w-40 items-center rounded-sm bg-white px-2 shadow-xs",
            ...tid('label'),
            children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                variant: "bodyXS",
                className: "inline-block w-full overflow-hidden text-ellipsis whitespace-nowrap",
                children: (0, $1b189b8190126d45$export$3415f3b823095a56)(activeScene, (0, $beILY.canonicalFacingDirections))
            })
        })
    });
};





var $BO02E = parcelRequire("BO02E");
const $cc583b72b9237f95$export$5dbb582fe83b74d2 = (id, references)=>{
    const reference = references.find((ref)=>ref.parent === id);
    if (!reference) return false;
    return reference.points.length > 0;
};


const $59fbae12ab3bb0e2$export$f07629d55b1eb618 = (references)=>{
    const seen = new Set();
    return references.filter((value)=>{
        if (seen.has(value.target.id)) return false;
        seen.add(value.target.id);
        return true;
    });
};











var $1LB4H = parcelRequire("1LB4H");

var $BO02E = parcelRequire("BO02E");
parcelRequire("03tHb");
var $eYvp0 = parcelRequire("eYvp0");


var $f9meZ = parcelRequire("f9meZ");







var $8TOsp = parcelRequire("8TOsp");


const $683ebc2a28bb5490$export$b52183d5cfb26dc9 = ({ onReset: onReset, onApply: onApply })=>{
    (0, $kIarK$useLingui)();
    const filteredElementsCount = (0, $d6bae723e3580231$export$a7fc736c99fb8c72)((0, $f493c6d50f18ed2f$export$3a0a5ff75750cc2c)(), 'temporary').length;
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "align-center border-ui-80 sticky -bottom-px flex w-full justify-between border-t bg-white py-4",
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                underline: true,
                theme: "transparentDark",
                onClick: onReset,
                testId: "reset-filters-button",
                className: "p-0",
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                    id: "s64RjX"
                })
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $8TOsp.PrimaryButton), {
                onClick: onApply,
                testId: "apply-filters-button",
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                    id: "K0UlbV",
                    values: {
                        filteredElementsCount: filteredElementsCount
                    }
                })
            })
        ]
    });
};









var $beILY = parcelRequire("beILY");

const $21c11425d7fa5c50$export$9e438b3ea21520b1 = (text)=>{
    if (!text) return '';
    return (0, $kIarK$dashify)(text, {
        condense: true
    });
};






var $beILY = parcelRequire("beILY");

const $36356707e2e9e2e0$export$dd948f91abc3a1c4 = (props)=>{
    const { id: id, label: label, value: value, dispatch: dispatch, testId: testId = 'checkbox-filter' } = props;
    if (!value) return null;
    const canonicalUnitTypes = (0, $beILY.getCanonicalUnitTypes)();
    const handleCheckboxClick = (type)=>{
        const temporaryValueClone = [
            ...value.temporary
        ];
        const index = temporaryValueClone.indexOf(type);
        if (index === -1) temporaryValueClone.push(type);
        else temporaryValueClone.splice(index, 1);
        dispatch(id, {
            ...value,
            temporary: temporaryValueClone.sort()
        });
    };
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "grid w-full gap-2",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)("label", {
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                    variant: "heading6",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: "grid gap-2",
                children: value.default.map((type)=>{
                    const active = value.temporary.includes(type);
                    const Icon = active ? (0, $kIarK$CheckSquare) : (0, $kIarK$Square);
                    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                        "data-testid": `${(0, $21c11425d7fa5c50$export$9e438b3ea21520b1)(type)}-filter-checkbox-${active ? 'enabled' : 'disabled'}`,
                        className: "border-ui-70 hover:bg-ui-90 flex cursor-pointer items-center justify-start gap-2 rounded-sm border bg-white p-3 px-4 text-black",
                        onClick: ()=>handleCheckboxClick(type),
                        children: [
                            /*#__PURE__*/ (0, $kIarK$jsx)(Icon, {
                                size: 22,
                                weight: active ? 'fill' : 'thin',
                                color: active ? '#44403C' : '#888888'
                            }),
                            /*#__PURE__*/ (0, $kIarK$jsx)("span", {
                                children: canonicalUnitTypes[type]
                            })
                        ]
                    }, type);
                })
            })
        ]
    });
};












const $fa83b323abf43fa1$export$4f7b2ae0c2141b10 = ()=>0..toLocaleString((0, $kIarK$i18n).locale, {
        style: 'currency',
        currency: (0, $39e51ae0969551d7$export$26531d8e255edf16).getState().currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).replace(/\d/g, '').trim();



const $98a836f29d2e7a14$export$1bb19cba5ab9d4aa = (options = {})=>new Intl.NumberFormat((0, $kIarK$i18n).locale || 'en', options);


const $3d7b6639ff2c1ab6$var$filtersWithNumberFormat = [
    'purchasePrice',
    'rentalPrice',
    'size',
    'usableArea',
    'grossFloorArea',
    'lotSizeM2',
    'openArea',
    'usableAreaB',
    'usableAreaE',
    'usableAreaI'
];
const $3d7b6639ff2c1ab6$var$RangeInput = ({ id: id, value: value, valueIndex: valueIndex, handleChange: handleChange, testId: testId })=>{
    const numberFormat = (0, $98a836f29d2e7a14$export$1bb19cba5ab9d4aa)();
    const prefixesAndSuffixes = {
        purchasePrice: ()=>(0, $fa83b323abf43fa1$export$4f7b2ae0c2141b10)(),
        rentalPrice: ()=>(0, $fa83b323abf43fa1$export$4f7b2ae0c2141b10)(),
        bedroomCount: ()=>(0, $kIarK$i18n)._(/*i18n*/ {
                id: "mMQSH4"
            }),
        roomCount: ()=>(0, $kIarK$i18n)._(/*i18n*/ {
                id: "Fglnvp"
            }),
        size: ()=>"m\xb2",
        usableArea: ()=>"m\xb2",
        grossFloorArea: ()=>"m\xb2",
        lotSizeM2: ()=>"m\xb2",
        openArea: ()=>"m\xb2",
        usableAreaB: ()=>"m\xb2",
        usableAreaE: ()=>"m\xb2",
        usableAreaI: ()=>"m\xb2"
    };
    const isSizeFilter = [
        'size',
        'usableArea',
        'usableAreaI',
        'usableAreaE',
        'usableAreaB',
        'openArea',
        'lotSizeM2',
        'grossFloorArea'
    ].includes(id);
    const apply = (newValue)=>handleChange(valueIndex === 0 ? newValue : newValue.reverse());
    const handleInputChange = ({ target: target })=>apply([
            parseInt(target.value),
            value.temporary[Number(!valueIndex)]
        ]);
    const commonProps = {
        value: value.temporary[valueIndex].toString(),
        onChange: handleInputChange,
        testId: testId,
        prefixElement: prefixesAndSuffixes[id] && !isSizeFilter ? prefixesAndSuffixes[id]() : null,
        variant: 'small'
    };
    return $3d7b6639ff2c1ab6$var$filtersWithNumberFormat.includes(id) ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Input), {
        ...commonProps,
        type: "number",
        numberFormat: numberFormat,
        suffixElement: prefixesAndSuffixes[id] && isSizeFilter ? prefixesAndSuffixes[id]() : null
    }) : /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Input), {
        ...commonProps
    });
};
const $3d7b6639ff2c1ab6$export$e0d834a0ad870cda = (props)=>{
    const { id: id, label: label, value: value, dispatch: dispatch, showInputs: showInputs = true, testId: testId = 'range-filter' } = props;
    const tid = (0, $kIarK$useTestId)(testId);
    const [localValue, setLocalValue] = (0, $kIarK$useState)(value);
    (0, $kIarK$useEffect)(()=>{
        setLocalValue(value);
    }, [
        value
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleInputChange = (0, $kIarK$useCallback)((0, $kIarK$lodashdebounce)((change)=>{
        const [min, max] = value.default;
        const shouldClampToMin = String(min).length === 1;
        const temporary = change.map((0, $kIarK$clamp)(shouldClampToMin ? min : 0, max));
        dispatch(id, {
            ...value,
            temporary: temporary
        });
    }, 300, {
        trailing: true
    }), [
        value
    ]);
    if (!localValue) return null;
    const [min, max] = value.default;
    const shouldClampToMin = String(min).length === 1;
    const rangeValue = localValue.temporary.map((0, $kIarK$clamp)(min, max));
    const sliderClassName = 'z-0 m-auto w-[calc(100%-20px)]';
    const sliderRailClassName = '[&>.slider>.rc-slider-rail]:w-[calc(100%+20px)] [&>.slider>.rc-slider-rail]:-translate-x-[10px]';
    const hiddenDotsClassName = '[&_.rc-slider-dot]:hidden';
    const valueMarksClassName = '[&>.slider>.rc-slider-mark]:-top-[22px] [&>.slider>.rc-slider-mark]:font-bold';
    const equalRangeClassName = '[&>.slider>.rc-slider-handle-2]:-right-[20px]';
    const sliderClassList = (0, $kIarK$classnames)(sliderClassName, sliderRailClassName, valueMarksClassName, hiddenDotsClassName, {
        [equalRangeClassName]: min === max && !showInputs
    });
    const handleChange = (change)=>{
        const temporary = change.map((0, $kIarK$clamp)(shouldClampToMin ? min : 0, max));
        setLocalValue({
            ...localValue,
            temporary: temporary
        });
        handleInputChange(change);
    };
    const hideSlider = min === max && showInputs || !isFinite(min) || !isFinite(max);
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "grid w-full gap-4",
        ...tid(),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                        variant: "heading6",
                        children: label
                    }),
                    showInputs ? /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                        className: "grid auto-cols-fr grid-flow-col gap-4",
                        children: [
                            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $kIarK$jsx)("label", {
                                        className: "bg-white text-xs font-medium tracking-[0.04em] text-black uppercase select-none",
                                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                                            id: "eTUF28"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                                        className: "mt-[2px]",
                                        children: /*#__PURE__*/ (0, $kIarK$jsx)($3d7b6639ff2c1ab6$var$RangeInput, {
                                            id: id,
                                            value: localValue,
                                            valueIndex: 0,
                                            handleChange: handleChange,
                                            testId: "from-filter-field"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $kIarK$jsx)("label", {
                                        className: "bg-white text-xs font-medium tracking-[0.04em] text-black uppercase select-none",
                                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                                            id: "CK1KXz"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                                        className: "mt-[2px]",
                                        children: /*#__PURE__*/ (0, $kIarK$jsx)($3d7b6639ff2c1ab6$var$RangeInput, {
                                            id: id,
                                            value: localValue,
                                            valueIndex: 1,
                                            handleChange: handleChange,
                                            testId: "to-filter-field"
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            hideSlider ? null : /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$RangeSlider), {
                step: 1,
                range: [
                    min,
                    max
                ],
                disabled: min === max,
                value: rangeValue,
                className: sliderClassList,
                onChange: handleChange,
                marks: showInputs ? {} : {
                    [min]: rangeValue[0],
                    [max]: rangeValue[1]
                }
            })
        ]
    });
};


const $a8613a4f4c32bb11$export$b36199eb679cf8aa = ({ id: id })=>{
    const testId = `filter-drawer-segment-${(0, $21c11425d7fa5c50$export$9e438b3ea21520b1)(id)}`;
    const form = (0, $kIarK$useForm)();
    const { showSoldUnits: showSoldUnits } = (0, $kIarK$useContext)((0, $670000472aba54a3$export$2e3feefe77201a07));
    const label = (0, $beILY.canonicalFilterLabels)[id];
    const showRangeInputs = id !== 'bedroomCount' && id !== 'roomCount';
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Field), {
        name: id,
        children: ({ input: input })=>/*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Fragment), {
                children: [
                    (0, $670000472aba54a3$export$f8286b88eb1abde5)(id) && /*#__PURE__*/ (0, $kIarK$jsx)((0, $3d7b6639ff2c1ab6$export$e0d834a0ad870cda), {
                        showInputs: showRangeInputs,
                        label: label,
                        id: id,
                        dispatch: form.change,
                        value: input.value,
                        testId: testId
                    }),
                    (0, $670000472aba54a3$export$52821e78ce69267e)(id) && /*#__PURE__*/ (0, $kIarK$jsx)((0, $36356707e2e9e2e0$export$dd948f91abc3a1c4), {
                        id: id,
                        dispatch: form.change,
                        label: label,
                        value: input.value,
                        testId: testId
                    }),
                    id === 'showSoldUnits' && /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                        className: "flex flex-row justify-between py-3",
                        children: [
                            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                                variant: "heading6",
                                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                                    id: "1G7KS/"
                                })
                            }),
                            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Toggle), {
                                checked: showSoldUnits.temporary,
                                onChange: ()=>form.change('showSoldUnits', {
                                        ...showSoldUnits,
                                        temporary: !showSoldUnits.temporary
                                    }),
                                testId: "show-sold-units-switch"
                            })
                        ]
                    })
                ]
            })
    });
};


const $2383c929dbfdb836$export$c25b94e67810bce3 = ({ filters: filters, onReset: onReset, onApply: onApply })=>{
    const tid = (0, $kIarK$useTestId)('filters-component');
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "relative grid h-full gap-4 p-4 lg:h-auto lg:p-0",
        ...tid(),
        children: [
            filters.map((id, index)=>/*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                    className: "grid gap-4",
                    children: [
                        /*#__PURE__*/ (0, $kIarK$jsx)((0, $a8613a4f4c32bb11$export$b36199eb679cf8aa), {
                            id: id
                        }),
                        filters.length > index + 1 && /*#__PURE__*/ (0, $kIarK$jsx)("hr", {
                            className: "bg-ui-90 h-px"
                        })
                    ]
                }, id)),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $683ebc2a28bb5490$export$b52183d5cfb26dc9), {
                onReset: onReset,
                onApply: onApply
            })
        ]
    });
};









parcelRequire("03tHb");
var $eYvp0 = parcelRequire("eYvp0");


const $9c24e90ddb1082ed$var$FiltersButtonComponent = ({ visible: visible, showCaret: showCaret, ...rest })=>{
    const { initialValues: initialValues, values: values } = (0, $kIarK$useFormState)();
    const { settings: settings, project: project } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { currency: currency } = project;
    const hiddenFilters = settings?.hiddenFilters ?? [];
    const tid = (0, $kIarK$useTestId)('applied-filters-counter');
    const filters = (0, $eYvp0.filterTypes).filter((filter)=>{
        if (hiddenFilters.includes(filter)) return false;
        if (!(0, $db9097cd98a91b4b$export$8abf45a3ec85474d)(currency) && (0, $eYvp0.isNorwegianFilter)(filter)) return false;
        return true;
    });
    if (!filters.length) return null;
    const filtersCount = Object.entries(values).map(([key, value])=>!(0, $kIarK$isNil)(value.value) && !(0, $kIarK$equals)(value.value, initialValues[key]?.temporary)).filter((0, $kIarK$identity)).length;
    const Icon = showCaret && visible ? (0, $kIarK$CaretUp) : (0, $kIarK$FadersHorizontal);
    return /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Button), {
        ...rest,
        icon: /*#__PURE__*/ (0, $kIarK$jsx)(Icon, {
            size: 16,
            weight: "bold"
        }),
        type: "button",
        testId: "filters-button",
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                id: "cSev+j"
            }),
            filtersCount > 0 && /*#__PURE__*/ (0, $kIarK$jsx)("span", {
                className: "text-ui-text-primary ml-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-gray-500",
                ...tid(),
                children: filtersCount
            })
        ]
    });
};
const $9c24e90ddb1082ed$export$16bac73b44412208 = /*#__PURE__*/ (0, $kIarK$memo)($9c24e90ddb1082ed$var$FiltersButtonComponent);


const $856529f8aa3dc483$export$92a576f896a9bf72 = ()=>{
    const form = (0, $kIarK$useForm)();
    const isMobile = (0, $f9meZ.useIsMobile)();
    const { settings: settings, project: project } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { showFilters: showFilters, setShowFilters: setShowFilters } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const hiddenFilters = settings?.hiddenFilters ?? [];
    const { currency: currency } = project;
    const filters = (0, $eYvp0.filterTypes).filter((filter)=>{
        if (hiddenFilters.includes(filter)) return false;
        if (!(0, $db9097cd98a91b4b$export$8abf45a3ec85474d)(currency) && (0, $eYvp0.isNorwegianFilter)(filter)) return false;
        return true;
    });
    const onReset = ()=>{
        form.reset();
        setShowFilters(false);
    };
    const handleClose = ()=>{
        const { values: values, dirtyFields: dirtyFields } = form.getState();
        Object.keys(dirtyFields).forEach((id)=>{
            form.change(id, {
                ...values[id],
                temporary: values[id].value ?? values[id].default
            });
        });
        setShowFilters(false);
    };
    const onApply = ()=>{
        form.batch(()=>{
            const { values: values, dirtyFields: dirtyFields } = form.getState();
            Object.keys(dirtyFields).forEach((id)=>{
                form.change(id, {
                    ...values[id],
                    value: values[id].temporary
                });
            });
        });
        setShowFilters(false);
    };
    return isMobile ? /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $9c24e90ddb1082ed$export$16bac73b44412208), {
                onClick: ()=>setShowFilters(true)
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $1LB4H.ModalSkeleton), {
                show: showFilters,
                onClose: handleClose,
                backLabel: (0, $kIarK$i18n)._(/*i18n*/ {
                    id: "7zP2Sb"
                }),
                testId: "share-modal",
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $2383c929dbfdb836$export$c25b94e67810bce3), {
                    filters: filters,
                    onReset: onReset,
                    onApply: onApply
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $kIarK$jsx)((0, $2383c929dbfdb836$export$c25b94e67810bce3), {
        filters: filters,
        onReset: onReset,
        onApply: onApply
    });
};









const $5e6a5f5a8f05c258$export$b5d5cf8927ab7262 = (props)=>{
    const { value: value, onChange: onChange, options: options, showLabels: showLabels, layout: layout } = props;
    if (layout === 'vertical') return null;
    return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        className: "flex min-h-8 flex-row gap-1 p-0",
        children: options.map((option)=>{
            const isSelected = value === option.value;
            return /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                "aria-label": option['aria-label'],
                disabled: isSelected,
                onClick: ()=>onChange(option.value),
                testId: option.testId,
                icon: /*#__PURE__*/ (0, $kIarK$jsx)(option.Icon, {
                    className: "h-4 w-4"
                }),
                children: showLabels ? option.label : null
            }, option.value);
        })
    });
};


const $b18a7f581367de9b$var$useOptions = ()=>{
    (0, $kIarK$useLingui)();
    return [
        {
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "kryGs+"
            }),
            value: 'cards',
            Icon: (0, $kIarK$SquaresFour),
            testId: 'details-cards-switch',
            'aria-label': 'cards view'
        },
        {
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "2BBAbc"
            }),
            value: 'list',
            Icon: (0, $kIarK$Rows),
            testId: 'details-list-switch',
            'aria-label': 'list view'
        }
    ];
};
const $b18a7f581367de9b$export$4670b59520058599 = ({ value: value, onChange: onChange })=>{
    const settings = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.settings);
    const options = $b18a7f581367de9b$var$useOptions();
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $5e6a5f5a8f05c258$export$b5d5cf8927ab7262), {
        value: value,
        onChange: onChange,
        options: options,
        layout: settings.layout
    });
};



var $BO02E = parcelRequire("BO02E");








var $BO02E = parcelRequire("BO02E");





const $e6c5f8b2a10349be$export$53f9dc393b4c2cec = (0, $kIarK$pipe)((0, $kIarK$map)((element)=>element.uuid), (0, $kIarK$uniq));


const $13a15ab8aff721fc$export$65a660940c71277b = (args)=>{
    const { uuid: uuid, type: type, elements: elements, project: project } = args;
    const units = project.units;
    let filteredUnits = [];
    if (type === 'project') filteredUnits = units;
    else if (type === 'stage') filteredUnits = units.filter(({ stageId: stageId })=>stageId === uuid);
    else if (type === 'building') filteredUnits = units.filter(({ buildingUuid: buildingUuid })=>buildingUuid === uuid);
    return (0, $d671d4feb12106e5$export$21ad8b48cbcbbf1)((0, $e6c5f8b2a10349be$export$53f9dc393b4c2cec)(filteredUnits), elements);
};





const $40efffd9ab7b5f46$export$e573c0dff4290170 = ({ elements: elements, key: key, label: label, isMobile: isMobile })=>{
    const list = elements.map(({ properties: properties })=>properties[key]?.rawValue).filter(Boolean);
    const min = parseFloat(Math.min(...list).toString());
    const max = parseFloat(Math.max(...list).toString());
    const notation = isMobile ? 'compact' : undefined;
    if (min === max && isFinite(min) && min > 0) {
        const style = 'currency';
        return {
            label: label,
            value: (0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
                price: min,
                style: style,
                notation: notation
            }),
            displayValue: (0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
                price: min,
                style: style,
                notation: notation
            })
        };
    } else if (min !== max && isFinite(min) && isFinite(max) && min > 0 && max > 0) return {
        label: label,
        value: `${(0, $fa83b323abf43fa1$export$4f7b2ae0c2141b10)()} ${(0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
            price: min,
            notation: notation
        })} \u{2013} ${(0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
            price: max,
            notation: notation
        })}`,
        displayValue: `${(0, $fa83b323abf43fa1$export$4f7b2ae0c2141b10)()} ${(0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
            price: min,
            notation: notation
        })} \u{2013} ${(0, $35a902cbeadd28dc$export$c86caf1be068fb8d)({
            price: max,
            notation: notation
        })}`
    };
    return null;
};


const $edaf31519add6ea0$export$f34b130535b7136e = ({ elements: elements, key: key, label: label })=>{
    const list = elements.map(({ properties: properties })=>properties[key]?.rawValue).filter(Boolean);
    const min = Math.min(...list);
    const max = Math.max(...list);
    if (min === max && isFinite(min) && min > 0) return {
        label: label,
        value: `${min} m\xb2`,
        displayValue: `${min} m\xb2`
    };
    else if (min !== max && isFinite(min) && isFinite(max) && min > 0 && max > 0) return {
        label: label,
        value: `${min} \u{2013} ${max} m\xb2`,
        displayValue: `${min} \u{2013} ${max} m\xb2`
    };
    return null;
};


const $7b24a01339a4f667$var$availableProperties = {
    availableUnits: (filteredElements, allElements)=>{
        const availableCount = filteredElements.filter(({ state: state })=>[
                'for_sale',
                'for_rent'
            ].includes(state)).length;
        const allCount = allElements.length;
        return {
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "XwoMlz"
            }),
            value: `${availableCount}/${allCount}`,
            displayValue: `${availableCount}/${allCount}`
        };
    },
    unitTypes: (filteredElements)=>{
        const types = (0, $kIarK$uniq)(filteredElements.map(({ properties: properties })=>properties?.type?.displayValue).filter(Boolean));
        return types.length ? {
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "RsG/0i"
            }),
            value: types.join(', '),
            displayValue: types.join(', ')
        } : null;
    },
    purchasePrice: (filteredElements, allElements, element, isMobile)=>{
        return (0, $40efffd9ab7b5f46$export$e573c0dff4290170)({
            elements: filteredElements,
            key: 'purchasePrice',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "a7u1N9"
            }),
            isMobile: isMobile
        });
    },
    totalPrice: (filteredElements, allElements, element, isMobile)=>{
        return (0, $40efffd9ab7b5f46$export$e573c0dff4290170)({
            elements: filteredElements,
            key: 'totalPrice',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "qqsfDU"
            }),
            isMobile: isMobile
        });
    },
    rentalPrice: (filteredElements)=>{
        return (0, $40efffd9ab7b5f46$export$e573c0dff4290170)({
            elements: filteredElements,
            key: 'rentalPrice',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "7aYzgc"
            })
        });
    },
    rentalDeposit: (filteredElements)=>{
        return (0, $40efffd9ab7b5f46$export$e573c0dff4290170)({
            elements: filteredElements,
            key: 'rentalDeposit',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "MepnY2"
            })
        });
    },
    rentalServiceCharge: (filteredElements)=>{
        return (0, $40efffd9ab7b5f46$export$e573c0dff4290170)({
            elements: filteredElements,
            key: 'rentalServiceCharge',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "2eknBD"
            })
        });
    },
    sizeM2: (filteredElements)=>{
        return (0, $edaf31519add6ea0$export$f34b130535b7136e)({
            elements: filteredElements,
            key: 'sizeM2',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "t6yDp0"
            })
        });
    },
    grossFloorAreaM2: (filteredElements)=>{
        return (0, $edaf31519add6ea0$export$f34b130535b7136e)({
            elements: filteredElements,
            key: 'grossFloorAreaM2',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "+lY7Ar"
            })
        });
    },
    usableAreaM2: (filteredElements)=>{
        return (0, $edaf31519add6ea0$export$f34b130535b7136e)({
            elements: filteredElements,
            key: 'usableAreaM2',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "IodKQ0"
            })
        });
    },
    usableAreaI: (filteredElements)=>{
        return (0, $edaf31519add6ea0$export$f34b130535b7136e)({
            elements: filteredElements,
            key: 'usableAreaI',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "JwqVXG"
            })
        });
    },
    usableAreaE: (filteredElements)=>{
        return (0, $edaf31519add6ea0$export$f34b130535b7136e)({
            elements: filteredElements,
            key: 'usableAreaE',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "ij53KS"
            })
        });
    },
    usableAreaB: (filteredElements)=>{
        return (0, $edaf31519add6ea0$export$f34b130535b7136e)({
            elements: filteredElements,
            key: 'usableAreaB',
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "oB+XVA"
            })
        });
    }
};
const $7b24a01339a4f667$export$a9bf3957f10f87e8 = (args)=>{
    const { element: element, elements: elements, scenes: scenes, filters: filters, project: project, isMobile: isMobile, propertiesList: propertiesList = [] } = args;
    if (![
        'stage',
        'building'
    ].includes(element.type)) return {};
    const properties = {
        title: {
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "MHrjPM"
            }),
            value: element.title,
            displayValue: element.title
        }
    };
    const filteredElements = (0, $4a2330ccd45e58ac$export$c0e506a8d7518b9c)({
        uuid: element?.uuid,
        type: element?.type,
        scenes: scenes,
        elements: elements
    }).filter((element)=>(0, $d6bae723e3580231$export$aee332ce1e8697e7)({
            element: element,
            filters: filters
        }));
    const allElements = (0, $13a15ab8aff721fc$export$65a660940c71277b)({
        uuid: element?.uuid,
        type: element?.type,
        elements: elements,
        project: project
    });
    propertiesList.forEach((id)=>{
        const fn = $7b24a01339a4f667$var$availableProperties[id];
        if (typeof fn === 'function') properties[id] = fn(filteredElements, allElements, element, isMobile);
    });
    return properties;
};




var $f9meZ = parcelRequire("f9meZ");







var $bWmJ8 = parcelRequire("bWmJ8");


var $beILY = parcelRequire("beILY");
const $18a648d6bb4eaa53$export$fd7536b60e189c38 = (props)=>{
    const { showPartiallyOwnedStatus: showPartiallyOwnedStatus, partiallyOwnedLabel: partiallyOwnedLabel, element: element } = props;
    const isPartiallyOwnedLabelValid = partiallyOwnedLabel && partiallyOwnedLabel.trim() !== '';
    const partiallyOwnedBadge = showPartiallyOwnedStatus && element.partiallyOwned ? {
        type: 'partiallyOwned',
        value: isPartiallyOwnedLabelValid ? partiallyOwnedLabel : (0, $beILY.canonicalUnitStates)['partially_owned']
    } : undefined;
    const badge = {
        type: (0, $kIarK$camelize)(element.properties.state.value),
        value: (0, $beILY.canonicalUnitStates)[(0, $kIarK$decamelize)(element.properties.state.value)]
    };
    return [
        badge,
        partiallyOwnedBadge
    ].filter(Boolean);
};


const $d4ce7bb6d849e910$export$28195c1f3490f3f1 = (properties, availableProperties)=>{
    return availableProperties.map((key)=>({
            key: key,
            prop: properties[key]
        })).filter(({ prop: prop })=>prop !== undefined);
};



var $f9meZ = parcelRequire("f9meZ");


const $d7b1772ef09ab040$var$UnitCardProperty = (props)=>{
    const { label: label, value: value, propertyKey: propertyKey } = props;
    if ([
        'unitId',
        'state'
    ].includes(propertyKey) || value === '-' || value === '') return null;
    const isDescription = propertyKey === 'description';
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                variant: "captionSmall",
                testId: `${propertyKey}-prop-label`,
                children: label
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                variant: "bodyXSMedium",
                testId: `${propertyKey}-prop-value`,
                className: isDescription ? 'line-clamp-2' : '',
                title: isDescription ? String(value) : undefined,
                children: value
            })
        ]
    });
};
const $d7b1772ef09ab040$export$a53f96d9aa53ca75 = (props)=>{
    const { unit: unit, floorplan: floorplan, handleMouseLeave: handleMouseLeave, handleMouseEnter: handleMouseEnter, handleClick: handleClick } = props;
    const clickHandler = (0, $164070db97899be6$export$66b4faa78018d04a)();
    const tid = (0, $kIarK$useTestId)('card');
    const isMobile = (0, $f9meZ.useIsMobile)();
    const settings = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.settings);
    const { allowNotAvailableInteraction: allowNotAvailableInteraction, settings: { showPartiallyOwnedStatus: showPartiallyOwnedStatus, partiallyOwnedLabel: partiallyOwnedLabel } } = settings;
    const isUnitAvailable = !unit.notAvailable;
    const badges = (0, $18a648d6bb4eaa53$export$fd7536b60e189c38)({
        showPartiallyOwnedStatus: showPartiallyOwnedStatus,
        partiallyOwnedLabel: partiallyOwnedLabel,
        element: unit
    });
    const imageClassName = 'max-w-[40%]';
    const isUnavailable = unit.notAvailable && !settings.allowNotAvailableInteraction;
    const onClick = ()=>{
        if (!isUnitAvailable && !allowNotAvailableInteraction) return;
        clickHandler(unit);
        if (handleClick) handleClick(unit);
    };
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: (0, $kIarK$classnames)('flex max-w-full flex-col rounded-sm border bg-white p-4', isUnavailable ? 'cursor-default' : 'cursor-pointer', isMobile ? '' : 'hover:shadow-card', 'h-inherit'),
        onMouseEnter: (e)=>isMobile ? {} : handleMouseEnter(e),
        onMouseLeave: (e)=>isMobile ? {} : handleMouseLeave(e),
        onClick: onClick,
        "data-uuid": unit.uuid,
        ...tid('root'),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                className: "flex flex-row justify-between pb-3",
                ...tid('header'),
                children: [
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                        variant: "heading5",
                        className: "overflow-hidden text-ellipsis whitespace-nowrap",
                        children: unit.title
                    }),
                    /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: "flex flex-row gap-1",
                        children: badges.map((badge, index)=>{
                            return /*#__PURE__*/ (0, $kIarK$jsx)((0, $bWmJ8.Badge), {
                                ...badge
                            }, `${badge.type}-${index}`);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                className: "flex flex-row items-start justify-between",
                children: [
                    /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: (0, $d4ce7bb6d849e910$export$28195c1f3490f3f1)(unit.properties, settings.properties.unit.default).map(({ key: key, prop: prop })=>/*#__PURE__*/ (0, $kIarK$jsx)($d7b1772ef09ab040$var$UnitCardProperty, {
                                propertyKey: key,
                                label: prop.label,
                                value: prop.displayValue
                            }, key))
                    }),
                    floorplan ? /*#__PURE__*/ (0, $kIarK$jsx)("img", {
                        src: floorplan,
                        alt: "Unit floorplan preview",
                        className: imageClassName,
                        ...tid('floorplan-preview')
                    }) : null
                ]
            })
        ]
    });
};



var $BO02E = parcelRequire("BO02E");


var $37CU7 = parcelRequire("37CU7");



var $1KlOg = parcelRequire("1KlOg");

var $BO02E = parcelRequire("BO02E");
const $82cb673ceac8e05a$export$812f044f0b2222f0 = ({ levels: levels, scene: scene, elementUuid: elementUuid })=>{
    const angles = levels?.[scene.parentPath]?.favorable_angles;
    return angles?.[elementUuid];
};


const $3b5a7021b32608a8$export$911b2062fde21350 = ({ activeScene: activeScene, scenes: scenes })=>{
    const rootScene = scenes.find((scene)=>scene.uuid === activeScene);
    const renderScenes = [
        activeScene,
        ...rootScene?.relatedScenes ?? []
    ];
    return scenes.filter((scene)=>renderScenes.includes(scene.uuid));
};



const $6fe00b3b64d7d526$export$d65dbc6ebb5cc0a6 = ({ scenes: scenes, target: target })=>{
    const targetScene = scenes.find(({ uuid: uuid })=>uuid === target.id);
    const allTargetParentReferences = scenes.filter(({ parent: parent })=>parent === targetScene?.parent).flatMap(({ references: references })=>references).filter(({ target: target })=>target.type !== 'draft');
    return target.type !== 'unit' && allTargetParentReferences.length === 0;
};




var $37CU7 = parcelRequire("37CU7");


var $BO02E = parcelRequire("BO02E");
const $2b57a4c4152b7bad$export$619f35420068fb0b = ({ currentFrame: currentFrame, currentMaxFrames: currentMaxFrames, newMaxFrames: newMaxFrames })=>{
    return Math.round(newMaxFrames * currentFrame / currentMaxFrames);
};




const $8b95f79125558536$export$62db9b55c29b62ed = ({ targetUuid: targetUuid, scenes: scenes })=>{
    const targetLevelScenes = (0, $3b5a7021b32608a8$export$911b2062fde21350)({
        activeScene: targetUuid,
        scenes: scenes
    });
    const newMaxFrames = targetLevelScenes.length;
    return {
        targetLevelScenes: targetLevelScenes,
        newMaxFrames: newMaxFrames
    };
};



const $7386f75f7d719bee$export$1bd83ba0476307b = ()=>{
    const { activeScene: activeScene, setActiveScene: setActiveScene, activeAngle: activeAngle } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const { scenes: scenes, rendererType: rendererType } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { setAppHistory: setAppHistory } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const currentLevelScenes = (0, $kIarK$useMemo)(()=>(0, $3b5a7021b32608a8$export$911b2062fde21350)({
            activeScene: activeScene,
            scenes: scenes
        }), [
        activeScene,
        scenes
    ]);
    const setActiveSceneDetails = (targetUuid)=>{
        const currentMaxFrames = currentLevelScenes.length;
        const { targetLevelScenes: targetLevelScenes, newMaxFrames: newMaxFrames } = (0, $8b95f79125558536$export$62db9b55c29b62ed)({
            targetUuid: targetUuid,
            scenes: scenes
        });
        if (!targetLevelScenes.length) return;
        let finalTargetUuid = targetUuid;
        if (newMaxFrames !== currentMaxFrames) {
            const currentFrame = activeAngle.current;
            const newActiveAngle = (0, $2b57a4c4152b7bad$export$619f35420068fb0b)({
                currentFrame: currentFrame,
                currentMaxFrames: currentMaxFrames,
                newMaxFrames: newMaxFrames
            });
            activeAngle.current = newActiveAngle;
            finalTargetUuid = targetLevelScenes[newActiveAngle].uuid;
        }
        if (rendererType === '2d') {
            const targetScene = targetLevelScenes.find((scene)=>scene.uuid === finalTargetUuid);
            // If current scene is not main, find next available main scene
            if (!targetScene.main) {
                const nextMainTargetScene = targetLevelScenes.find((scene)=>scene.promotable.uuid === targetScene.promotable.uuid && scene.main);
                if (nextMainTargetScene) finalTargetUuid = nextMainTargetScene.uuid;
            }
        }
        setActiveScene(finalTargetUuid);
        setAppHistory((current)=>[
                ...current,
                finalTargetUuid
            ]);
    };
    return {
        setActiveSceneDetails: setActiveSceneDetails
    };
};


const $60d0736a98071155$export$ade9e90985697ad1 = (event, type, element)=>event({
        type: type,
        unitUuid: element.uuid,
        additionalParameters: {
            buildingId: element.building,
            stageId: element.stage,
            targetType: 'card'
        }
    });
const $60d0736a98071155$var$dispatchPolygonEvent = (uuid, eventType)=>document.querySelector(`.${(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).scene}.${(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).active} [data-uuid="${uuid}"] > path`)?.dispatchEvent(new Event(eventType, {
        bubbles: true
    }));
const $60d0736a98071155$export$12ccb3912416d32f = (args)=>{
    const { scenes: scenes, navigationRef: navigationRef } = args;
    const { settings: settings, project: project, rendererType: rendererType, levels: levels } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { view: view, setShowUnconfiguredOverlay: setShowUnconfiguredOverlay, rotateInstanceRef: rotateInstanceRef, activeAngle: activeAngle, activeScene: activeScene } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const { event: event } = (0, $37CU7.useAnalytics)(project.uuid);
    const rotateTimeoutRef = (0, $kIarK$useRef)();
    const { setActiveSceneDetails: setActiveSceneDetails } = (0, $7386f75f7d719bee$export$1bd83ba0476307b)();
    const currentLevelScenes = (0, $kIarK$useMemo)(()=>(0, $3b5a7021b32608a8$export$911b2062fde21350)({
            activeScene: activeScene,
            scenes: scenes
        }), [
        activeScene,
        scenes
    ]);
    const handleMouseEnter = (element, nativeEvent)=>{
        if (navigationRef.current?.dataset.disableHover) return;
        const is3D = rendererType === '3d';
        const currentView = is3D ? currentLevelScenes[activeAngle.current] : view;
        const isInView = (0, $cc583b72b9237f95$export$5dbb582fe83b74d2)(element.uuid, currentView.references);
        if (element.type === 'unit') $60d0736a98071155$export$ade9e90985697ad1(event, 'hover_property', element);
        const favorableAngle = (0, $82cb673ceac8e05a$export$812f044f0b2222f0)({
            levels: levels,
            scene: currentView,
            elementUuid: element.uuid
        });
        if (!isInView && !is3D) setShowUnconfiguredOverlay(true);
        else if (is3D && !(0, $kIarK$isNil)(favorableAngle) && (settings.autoRotateToFavorableAngle || !isInView)) rotateTimeoutRef.current = setTimeout(()=>{
            handleMouseLeave(element);
            const domNode = nativeEvent?.target;
            const parentNode = domNode?.closest(`[data-uuid="${element.uuid}"]`);
            rotateInstanceRef.current.rotateTo({
                newIndex: favorableAngle,
                duration: 200,
                onEnd: ()=>{
                    requestAnimationFrame(()=>{
                        if (parentNode && !parentNode.matches(':hover')) return;
                        $60d0736a98071155$var$dispatchPolygonEvent(element.uuid, 'pointerover');
                    });
                }
            });
        }, 500);
        else $60d0736a98071155$var$dispatchPolygonEvent(element.uuid, 'pointerover');
    };
    const handleMouseLeave = (element)=>{
        clearTimeout(rotateTimeoutRef.current);
        $60d0736a98071155$var$dispatchPolygonEvent(element.uuid, 'pointerout');
        setShowUnconfiguredOverlay(false);
    };
    const handleClick = (element, reference)=>{
        if (element.type === 'unit') $60d0736a98071155$export$ade9e90985697ad1(event, 'property_selector_click', element);
        if (!reference.target.id || element.notAvailable && !settings.allowNotAvailableInteraction) return;
        $60d0736a98071155$var$dispatchPolygonEvent(element.uuid, 'pointerout');
        const goToTarget = ()=>{
            setActiveSceneDetails(reference.target.id);
            setTimeout(()=>navigationRef.current?.scrollTo(0, 0));
        };
        if (!(0, $6fe00b3b64d7d526$export$d65dbc6ebb5cc0a6)({
            scenes: scenes,
            target: reference.target
        })) goToTarget();
    };
    return {
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave,
        handleClick: handleClick
    };
};
var $60d0736a98071155$export$2e2bcd8739ae039 = $60d0736a98071155$export$12ccb3912416d32f;











var $bWmJ8 = parcelRequire("bWmJ8");

var $8TOsp = parcelRequire("8TOsp");

var $BO02E = parcelRequire("BO02E");

var $beILY = parcelRequire("beILY");


var $f9meZ = parcelRequire("f9meZ");

const $63cf043e1da5d8cf$var$StageOrBuildingCardProperty = (props)=>{
    (0, $kIarK$useLingui)();
    const { label: label, value: value, propertyKey: propertyKey } = props;
    if ([
        'title'
    ].includes(propertyKey) || value === '-' || value === '') return null;
    return /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: "pr-px",
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                    variant: "bodyXS",
                    className: "white-space:nowrap",
                    testId: `${propertyKey}-prop-label`,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                    variant: "bodyXSMedium",
                    className: "white-space:nowrap",
                    testId: `${propertyKey}-prop-value`,
                    children: value
                })
            })
        ]
    });
};
const $63cf043e1da5d8cf$export$e0562c458dc46c05 = (props)=>{
    const { entity: entity, imageURL: imageURL, properties: properties, handleMouseLeave: handleMouseLeave, handleMouseEnter: handleMouseEnter, handleOnClick: handleOnClick } = props;
    const isMobile = (0, $f9meZ.useIsMobile)();
    const { settings: settings } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { showSplashScreen: showSplashScreen, isLoading: isFullLoading } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const tid = (0, $kIarK$useTestId)('card');
    const isLoading = showSplashScreen || isFullLoading;
    const badge = {
        type: (0, $kIarK$camelize)(entity.state),
        value: (0, $beILY.canonicalUnitStates)[(0, $kIarK$decamelize)(entity.state)]
    };
    const isUnavailable = entity.notAvailable && !settings.allowNotAvailableInteraction;
    const propertiesClassName = isMobile ? 'grid-cols-2' : 'grid-cols-[40%_60%]';
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: (0, $kIarK$classnames)('flex max-w-full flex-col rounded-sm border bg-white p-4', isUnavailable ? 'cursor-default opacity-60' : 'cursor-pointer', isMobile ? '' : 'hover:shadow-card', 'h-inherit'),
        onMouseEnter: (e)=>isMobile ? {} : handleMouseEnter(e),
        onMouseLeave: (e)=>isMobile ? {} : handleMouseLeave(e),
        onClick: (e)=>{
            e.stopPropagation();
            handleOnClick(entity);
        },
        "data-uuid": entity.uuid,
        ...tid('root'),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                className: "flex flex-row justify-between pb-1.5",
                ...tid('header'),
                children: [
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                        variant: "heading5",
                        className: "overflow-hidden text-ellipsis whitespace-nowrap",
                        children: entity.title
                    }),
                    isLoading ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Skeleton), {
                        className: "h-4",
                        containerClassName: "w-20"
                    }) : /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: "flex flex-row gap-1",
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $bWmJ8.Badge), {
                            ...badge
                        }, badge.type)
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                className: "mb-3 grid gap-1",
                children: [
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Skeleton), {
                        className: "h-4",
                        containerClassName: "w-full"
                    }),
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Skeleton), {
                        className: "h-4",
                        containerClassName: "w-full"
                    })
                ]
            }) : /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: (0, $kIarK$classnames)('mb-3 grid', propertiesClassName),
                children: (0, $d4ce7bb6d849e910$export$28195c1f3490f3f1)(properties, settings.properties[entity.type].default).map(({ key: key, prop: prop })=>{
                    return /*#__PURE__*/ (0, $kIarK$jsx)($63cf043e1da5d8cf$var$StageOrBuildingCardProperty, {
                        propertyKey: key,
                        label: prop?.label,
                        value: prop?.displayValue
                    }, key);
                })
            }),
            imageURL ? /*#__PURE__*/ (0, $kIarK$jsx)("img", {
                src: imageURL,
                className: "mb-3 max-h-[120px] w-full rounded-sm object-cover",
                alt: (0, $kIarK$i18n)._(/*i18n*/ {
                    id: "OzDiZm"
                }),
                ...tid('image-preview')
            }) : null,
            handleOnClick && !isUnavailable ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $8TOsp.PrimaryButton), {
                testId: "card-button",
                size: "small",
                className: "mt-auto",
                disabled: isLoading,
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                    id: "BowKyI"
                })
            }) : null
        ]
    });
};


const $5e6295162888ecb5$export$77ef6ca21af9f8b1 = (props)=>{
    const { element: element, reference: reference, properties: properties, imageURL: imageURL, navigationRef: navigationRef } = props;
    const { scenes: scenes, project: project, settings: settings } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { view: view, floorplans: floorplans } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const { event: event } = (0, $37CU7.useAnalytics)(project.uuid);
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleClick: handleClick } = (0, $60d0736a98071155$export$2e2bcd8739ae039)({
        scenes: scenes,
        navigationRef: navigationRef
    });
    const isFromThisView = (0, $cc583b72b9237f95$export$5dbb582fe83b74d2)(element.uuid, view.references);
    if (settings.hideUnitsFromOtherDirections && !isFromThisView) return null;
    if (element.type === 'unit') return /*#__PURE__*/ (0, $kIarK$jsx)((0, $d7b1772ef09ab040$export$a53f96d9aa53ca75), {
        unit: element,
        floorplan: floorplans?.[element.uuid]?.url,
        handleMouseEnter: (e)=>handleMouseEnter(element, e),
        handleMouseLeave: ()=>handleMouseLeave(element),
        handleClick: ()=>(0, $60d0736a98071155$export$ade9e90985697ad1)(event, 'property_selector_click', element)
    }, element.uuid);
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $63cf043e1da5d8cf$export$e0562c458dc46c05), {
        entity: element,
        properties: properties,
        imageURL: imageURL,
        handleOnClick: ()=>handleClick(element, reference),
        handleMouseEnter: (e)=>handleMouseEnter(element, e),
        handleMouseLeave: ()=>handleMouseLeave(element)
    }, element.uuid);
};


const $54345d33970143f3$export$8e547173d545e862 = ({ references: references, navigationRef: navigationRef })=>{
    const { elements: elements, scenes: scenes, project: project, settings: settings } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const filters = (0, $kIarK$useContext)((0, $670000472aba54a3$export$2e3feefe77201a07));
    const { view: view, setFocusedElement: setFocusedElement, focusedElement: focusedElement } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const isMobile = (0, $f9meZ.useIsMobile)();
    const sortingOrder = settings.settings?.defaultUnitSortingOrder ?? 'asc';
    const sortingProperty = settings.settings?.defaultUnitSortingProperty ?? 'state';
    const swiperRef = (0, $kIarK$useRef)(null);
    const entities = (0, $kIarK$useMemo)(()=>{
        const data = references.map((reference)=>{
            const element = elements.find(({ uuid: uuid })=>reference.parent === uuid);
            return {
                reference: reference,
                element: element
            };
        }).filter(({ element: element })=>{
            const isFromThisView = (0, $cc583b72b9237f95$export$5dbb582fe83b74d2)(element.uuid, view.references);
            return isFromThisView || !settings.hideUnitsFromOtherDirections;
        }).map(({ element: element, reference: reference })=>{
            if (element.type === 'unit') return {
                element: element,
                reference: reference,
                navigationRef: navigationRef
            };
            const properties = (0, $7b24a01339a4f667$export$a9bf3957f10f87e8)({
                element: element,
                elements: elements,
                scenes: scenes,
                filters: filters,
                project: project,
                propertiesList: settings.properties[element.type].default,
                isMobile: isMobile
            });
            const mainAssetImageURL = element.asset?.thumbnail ?? element.asset?.optimizedUrl ?? element.asset?.url;
            const scene = scenes.find((scene)=>scene.uuid === reference.target.id);
            const fallbackImageURL = scene?.asset.thumbnail ?? scene?.asset.optimizedUrl ?? scene?.asset.url;
            return {
                reference: reference,
                element: element,
                properties: properties,
                imageURL: mainAssetImageURL ?? fallbackImageURL,
                navigationRef: navigationRef
            };
        });
        const adjustState = (state)=>state === 'archived' ? 'sold' : state;
        return (0, $kIarK$sortWith)([
            (sortingOrder === 'asc' ? (0, $kIarK$ascend) : (0, $kIarK$descend))((0, $kIarK$compose)(adjustState, (0, $kIarK$path)([
                'element',
                sortingProperty
            ])))
        ])(data);
    }, [
        references,
        elements,
        filters,
        isMobile,
        project,
        scenes,
        view,
        settings,
        navigationRef,
        sortingOrder,
        sortingProperty
    ]);
    (0, $kIarK$useEffect)(()=>{
        if (!swiperRef.current) return;
        const entityIndex = entities.findIndex((entity)=>entity.element.uuid === focusedElement);
        if (entityIndex === -1) return;
        swiperRef.current.slideTo(entityIndex);
    }, [
        focusedElement,
        entities
    ]);
    if (!entities.length) return null;
    const hasOneSlide = entities.length === 1;
    const centeredSlides = entities.length > 2;
    const breakpoints = {
        0: {
            slidesPerView: 1
        },
        410: {
            slidesPerView: hasOneSlide ? 1 : 1.5
        },
        600: {
            slidesPerView: 2
        },
        800: {
            slidesPerView: 2.5
        }
    };
    return isMobile ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Swiper), {
        onInit: (swiper)=>swiperRef.current = swiper,
        onSlideChangeTransitionEnd: (e)=>{
            const slides = e.slides;
            const index = e.activeIndex;
            const element = slides[index];
            if (!element) return;
            setFocusedElement(element.dataset.uuid);
        },
        autoHeight: true,
        freeMode: {
            enabled: true,
            sticky: true,
            momentumRatio: 0.6,
            momentumVelocityRatio: 0.6
        },
        spaceBetween: 8,
        slidesPerView: 1.25,
        breakpoints: breakpoints,
        centeredSlides: centeredSlides,
        modules: [
            (0, $kIarK$Navigation),
            (0, $kIarK$FreeMode)
        ],
        direction: "horizontal",
        className: "min-h-[200px] w-full p-1!",
        children: entities.map((entity)=>/*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$SwiperSlide), {
                "data-uuid": entity.element.uuid,
                className: "!flex flex-col!",
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $5e6295162888ecb5$export$77ef6ca21af9f8b1), {
                    ...entity
                })
            }, entity.reference.id))
    }) : /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        className: "flex flex-col gap-y-2 overflow-auto pb-2",
        children: entities.map((entity)=>/*#__PURE__*/ (0, $kIarK$jsx)((0, $5e6295162888ecb5$export$77ef6ca21af9f8b1), {
                ...entity
            }, entity.reference.id))
    });
};









var $BO02E = parcelRequire("BO02E");

var $beILY = parcelRequire("beILY");




var $f9meZ = parcelRequire("f9meZ");

const $218a35cba4795310$export$845be608a469a62a = ({ navigationRef: navigationRef, references: references })=>{
    const { project: project, elements: elements, settings: settings, scenes: scenes } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { hovered: hovered, focusedElement: focusedElement } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const isMobile = (0, $f9meZ.useIsMobile)();
    const filters = (0, $kIarK$useContext)((0, $670000472aba54a3$export$2e3feefe77201a07));
    const { view: view } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const data = (0, $kIarK$useMemo)(()=>references.map(({ parent: parent })=>elements.find(({ uuid: uuid })=>parent === uuid)).map((element)=>{
            const properties = (0, $7b24a01339a4f667$export$a9bf3957f10f87e8)({
                element: element,
                elements: elements,
                scenes: scenes,
                filters: filters,
                project: project,
                propertiesList: settings.properties[element.type].default
            });
            return {
                ...element,
                ...properties,
                properties: properties
            };
        }).filter(({ uuid: uuid })=>{
            const isFromThisView = (0, $cc583b72b9237f95$export$5dbb582fe83b74d2)(uuid, view.references);
            return isFromThisView || !settings.hideUnitsFromOtherDirections;
        }), [
        elements,
        filters,
        project,
        references,
        scenes,
        settings.hideUnitsFromOtherDirections,
        settings.properties,
        view.references
    ]);
    const sceneType = data[0]?.type ?? 'building';
    const columns = (0, $c51c90d781bf4c08$export$1728f626374c87c6)({
        columns: settings.properties[sceneType].default,
        labels: (0, $beILY.canonicalStageAndBuildingProperties)
    });
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleClick: handleClick } = (0, $60d0736a98071155$export$12ccb3912416d32f)({
        scenes: scenes,
        navigationRef: navigationRef
    });
    const handleRowClick = (row)=>{
        const element = row.original;
        const reference = references.find(({ parent: parent })=>element.uuid === parent);
        handleClick(element, reference);
    };
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $9a1b7b0e80919901$export$54ec01a60f47d33d), {
        onRowClick: handleRowClick,
        data: data,
        columns: columns,
        navigationRef: navigationRef,
        hovered: hovered,
        focusedElement: focusedElement,
        ...isMobile ? {} : {
            onRowMouseEnter: (row)=>handleMouseEnter(row.original),
            onRowMouseLeave: (row)=>handleMouseLeave(row.original)
        }
    });
};







var $BO02E = parcelRequire("BO02E");


var $37CU7 = parcelRequire("37CU7");


var $f9meZ = parcelRequire("f9meZ");


const $4b3fa87308307da1$export$4a3431560adad3a1 = (props)=>{
    const { references: references, navigationRef: navigationRef } = props;
    const { view: view, hovered: hovered, focusedElement: focusedElement } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const isMobile = (0, $f9meZ.useIsMobile)();
    const { settings: settings, elements: elements, project: project, scenes: scenes } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { event: event } = (0, $37CU7.useAnalytics)(project.uuid);
    const columns = (0, $c51c90d781bf4c08$export$1728f626374c87c6)({
        columns: settings.properties.unit.default
    });
    const unitClickHandler = (0, $164070db97899be6$export$66b4faa78018d04a)();
    const onRowClick = (row)=>{
        const elementUuid = row.original.uuid;
        const reference = references.find(({ parent: parent })=>parent === elementUuid);
        const element = elements.find(({ uuid: uuid })=>uuid === elementUuid);
        if (!reference.target.id || element?.notAvailable && !settings.allowNotAvailableInteraction) return;
        event({
            type: 'property_selector_click',
            unitUuid: element.uuid,
            additionalParameters: {
                buildingId: element.building,
                stageId: element.stage,
                targetType: 'card'
            }
        });
        unitClickHandler(element);
    };
    const data = (0, $kIarK$useMemo)(()=>references.map(({ parent: parent })=>elements.find(({ uuid: uuid })=>parent === uuid)).filter(({ uuid: uuid })=>{
            const isFromThisView = (0, $cc583b72b9237f95$export$5dbb582fe83b74d2)(uuid, view.references);
            return isFromThisView || !settings.hideUnitsFromOtherDirections;
        }).map((element)=>({
                ...element,
                ...element.properties
            })), [
        elements,
        settings.hideUnitsFromOtherDirections,
        references,
        view.references
    ]);
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave } = (0, $60d0736a98071155$export$2e2bcd8739ae039)({
        scenes: scenes,
        navigationRef: navigationRef
    });
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $9a1b7b0e80919901$export$54ec01a60f47d33d), {
        data: data,
        columns: columns,
        onRowClick: onRowClick,
        hovered: hovered,
        focusedElement: focusedElement,
        ...isMobile ? {} : {
            onRowMouseEnter: (row)=>handleMouseEnter(row.original),
            onRowMouseLeave: (row)=>handleMouseLeave(row.original)
        }
    });
};


const $498c087e90fe35fd$export$88ee64ed0ab124b = (props)=>{
    const { navigationRef: navigationRef, unitReferences: unitReferences, references: references, stagesAndBuildingsReferences: stagesAndBuildingsReferences } = props;
    const { view: view, isMobile: isMobile, detailsView: detailsView, setDetailsView: setDetailsView, showSplashScreen: showSplashScreen } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const noReferences = !references.length && !showSplashScreen;
    const renderCards = (refs)=>{
        return /*#__PURE__*/ (0, $kIarK$jsx)((0, $54345d33970143f3$export$8e547173d545e862), {
            references: refs,
            navigationRef: navigationRef
        });
    };
    const renderTable = (refs, type)=>{
        if (!refs.length) return null;
        return type === 'units' ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $4b3fa87308307da1$export$4a3431560adad3a1), {
            references: refs,
            navigationRef: navigationRef
        }) : /*#__PURE__*/ (0, $kIarK$jsx)((0, $218a35cba4795310$export$845be608a469a62a), {
            navigationRef: navigationRef,
            references: refs
        });
    };
    const renderView = (refs, type)=>{
        return detailsView === 'cards' ? renderCards(refs) : renderTable(refs, type);
    };
    const sortedReferences = stagesAndBuildingsReferences.concat(unitReferences);
    return /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Fragment), {
        children: [
            isMobile ? /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                className: "my-4 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $b18a7f581367de9b$export$4670b59520058599), {
                        onChange: setDetailsView,
                        value: detailsView
                    }),
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $856529f8aa3dc483$export$92a576f896a9bf72), {})
                ]
            }) : null,
            noReferences ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $a214f925853e97a5$export$f3f2e7ed2b6256b1), {
                dataType: view.type === 'building' ? 'units' : 'references'
            }) : null,
            view.type === 'building' ? renderView(unitReferences, 'units') : null,
            [
                'project',
                'stage'
            ].includes(view.type) ? /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: "flex flex-col gap-3",
                children: detailsView === 'cards' ? renderView(sortedReferences, 'stagesAndBuildings') : /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Fragment), {
                    children: [
                        renderView(stagesAndBuildingsReferences, 'stagesAndBuildings'),
                        renderView(unitReferences, 'units')
                    ]
                })
            }) : null
        ]
    });
};














const $eb2a989ee30ad66a$export$abc56b62a44579d3 = ({ onClose: onClose, className: className })=>/*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: (0, $kIarK$twMerge)('absolute top-0 right-0 z-10 max-h-full max-w-[400px] translate-x-full transform overflow-y-auto bg-white px-4 shadow-lg transition-transform duration-200 ease-in-out', className),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: "sticky top-0 left-0 z-2 w-full bg-white py-4",
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                    theme: "transparentDark",
                    icon: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$CaretLeft), {
                        size: 16
                    }),
                    onClick: onClose,
                    className: "p-0",
                    children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                        id: "7zP2Sb"
                    })
                })
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $856529f8aa3dc483$export$92a576f896a9bf72), {})
        ]
    });








var $f9meZ = parcelRequire("f9meZ");


const $6e56d3a37b98cf3f$var$useOptions = ()=>{
    (0, $kIarK$useLingui)();
    return [
        {
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "hG89Ed"
            }),
            value: 'images',
            Icon: (0, $kIarK$Buildings),
            testId: 'view-images-switch',
            'aria-label': 'image view'
        },
        {
            label: (0, $kIarK$i18n)._(/*i18n*/ {
                id: "2BBAbc"
            }),
            value: 'list',
            Icon: (0, $kIarK$Rows),
            testId: 'view-list-switch',
            'aria-label': 'list view'
        }
    ];
};
const $6e56d3a37b98cf3f$export$a87b9398fba7039f = ({ value: value, onChange: onChange })=>{
    const settings = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.settings);
    const isMobile = (0, $f9meZ.useIsMobile)();
    const options = $6e56d3a37b98cf3f$var$useOptions();
    const showViewSwitcher = settings.showHeaderViewSwitcher;
    if (!showViewSwitcher) return null;
    const showLabels = settings.showHeaderViewSwitchLabels && !isMobile;
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $5e6a5f5a8f05c258$export$b5d5cf8927ab7262), {
        value: value,
        onChange: onChange,
        options: options,
        showLabels: showLabels,
        layout: settings.layout
    });
};



var $BO02E = parcelRequire("BO02E");







var $BO02E = parcelRequire("BO02E");


const $5e1721c22e0362b0$export$6e977ee002f5c8c = ({ className: className })=>{
    const { view: scene, showSplashScreen: showSplashScreen, isLoading: isLoading } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const filteredElementsCount = (0, $d6bae723e3580231$export$a7fc736c99fb8c72)((0, $f493c6d50f18ed2f$export$3a0a5ff75750cc2c)(), 'value').filter((unit)=>[
            'for_sale',
            'for_rent'
        ].includes(unit.state)).length;
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: (0, $kIarK$classnames)('flex flex-col truncate', className),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                variant: "heading4",
                className: "truncate",
                title: scene?.title,
                testId: "header-scene-title-label",
                style: {
                    color: 'var(--text-custom-primary)'
                },
                children: scene?.title ?? ''
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                variant: "bodyXS",
                testId: "header-available-units-label",
                style: {
                    color: 'var(--text-custom-primary)'
                },
                className: "opacity-60",
                children: showSplashScreen || isLoading ? null : /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                    id: "lXzzVA",
                    values: {
                        filteredElementsCount: filteredElementsCount
                    }
                })
            })
        ]
    });
};


const $f3ebaacb498d1c64$var$PanelHeader = ({ children: children })=>{
    const { activeTab: activeTab, setActiveTab: setActiveTab, showFilters: showFilters, setShowFilters: setShowFilters, detailsView: detailsView, setDetailsView: setDetailsView } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const settings = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.settings);
    const isListViewActive = activeTab === 'list';
    const isVerticalLayout = settings.layout === 'vertical';
    const overflowRef = (0, $kIarK$useRef)(null);
    (0, $kIarK$useEffect)(()=>{
        if (!overflowRef.current) return;
        overflowRef.current.style.overflow = 'hidden';
    }, [
        showFilters
    ]);
    const isGridTwoColumns = isListViewActive || isVerticalLayout;
    return /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: "sticky top-0 z-10 bg-(--background-custom-primary) py-4",
                children: /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                    className: (0, $kIarK$twMerge)('grid', isGridTwoColumns ? 'grid-cols-2 items-center' : 'grid-rows-1 gap-1'),
                    children: [
                        /*#__PURE__*/ (0, $kIarK$jsx)((0, $5e1721c22e0362b0$export$6e977ee002f5c8c), {}),
                        children,
                        /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                            className: (0, $kIarK$classnames)('flex', {
                                'justify-end space-x-4': isGridTwoColumns,
                                'justify-between': !isGridTwoColumns
                            }),
                            children: [
                                isListViewActive ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $6e56d3a37b98cf3f$export$a87b9398fba7039f), {
                                    value: activeTab,
                                    onChange: setActiveTab
                                }) : /*#__PURE__*/ (0, $kIarK$jsx)((0, $b18a7f581367de9b$export$4670b59520058599), {
                                    value: detailsView,
                                    onChange: setDetailsView
                                }),
                                /*#__PURE__*/ (0, $kIarK$jsx)((0, $9c24e90ddb1082ed$export$16bac73b44412208), {
                                    showCaret: !isListViewActive,
                                    visible: showFilters,
                                    onClick: ()=>setShowFilters((value)=>!value)
                                })
                            ]
                        })
                    ]
                })
            }),
            isVerticalLayout || isListViewActive ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $eb2a989ee30ad66a$export$abc56b62a44579d3), {
                className: (0, $kIarK$twMerge)('rounded-sm bg-white transition-transform duration-200 ease-in-out', showFilters ? 'translate-x-0 transform-none border' : ''),
                onClose: ()=>setShowFilters(false)
            }) : /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: (0, $kIarK$classnames)('grid rounded-sm bg-white transition-[grid-template-rows] duration-200 ease-in-out', showFilters ? 'mb-8 grid-rows-[1fr]' : 'grid-rows-[0fr]'),
                onTransitionEnd: ()=>{
                    if (showFilters && overflowRef.current) overflowRef.current.style.overflow = 'unset';
                },
                children: /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                    ref: overflowRef,
                    className: "overflow-hidden",
                    children: /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: "rounded border p-3",
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $856529f8aa3dc483$export$92a576f896a9bf72), {})
                    })
                })
            })
        ]
    });
};
const $f3ebaacb498d1c64$export$2ddb90ad54e5f587 = /*#__PURE__*/ (0, $kIarK$forwardRef)((props, ref)=>{
    const { children: children, className: className, headerContent: headerContent } = props;
    const { isMobile: isMobile, showFilters: showFilters } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    (0, $kIarK$useEffect)(()=>{
        if (!showFilters || !ref?.current) return;
        ref.current.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        showFilters,
        ref
    ]);
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        ref: ref,
        className: (0, $kIarK$classnames)('relative flex w-full flex-col overflow-x-hidden lg:px-4', className),
        children: [
            isMobile ? null : /*#__PURE__*/ (0, $kIarK$jsxs)($f3ebaacb498d1c64$var$PanelHeader, {
                children: [
                    " ",
                    headerContent
                ]
            }),
            children
        ]
    });
});
















var $BO02E = parcelRequire("BO02E");

const $5116544d189893b5$var$NavigationComponent = ()=>{
    (0, $kIarK$useLingui)();
    const scenes = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.scenes);
    const { setActiveScene: setActiveScene, setAppHistory: setAppHistory, appHistory: appHistory, isMobile: isMobile } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const navigationItems = appHistory.map((uuid)=>scenes.find((scene)=>scene.uuid === uuid)).filter(Boolean);
    const goBack = ()=>{
        const navigationItem = navigationItems?.[navigationItems.length - 2];
        setActiveScene(navigationItem.uuid);
        setAppHistory(appHistory.slice(0, appHistory.indexOf(navigationItem.uuid) + 1));
    };
    const props = {
        goBack: goBack,
        navigationItems: navigationItems
    };
    return isMobile ? /*#__PURE__*/ (0, $kIarK$jsx)($5116544d189893b5$var$MobileRenderer, {
        ...props
    }) : /*#__PURE__*/ (0, $kIarK$jsx)($5116544d189893b5$var$DesktopRenderer, {
        ...props
    });
};
const $5116544d189893b5$var$MobileRenderer = ({ navigationItems: navigationItems, goBack: goBack })=>{
    (0, $kIarK$useLingui)();
    const navigationItem = navigationItems?.[navigationItems.length - 1];
    const tid = (0, $kIarK$useTestId)('mobile-back-button');
    if (navigationItems.length === 1) return null;
    return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        className: "border-primary absolute top-3 left-3 flex cursor-pointer flex-row items-center justify-between gap-2 rounded-sm border bg-white px-2 py-1 select-none",
        onClick: goBack,
        ...tid(),
        children: /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Text), {
            variant: "heading6",
            className: "flex flex-row items-center gap-1",
            title: navigationItem?.title,
            children: [
                /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$CaretLeft), {
                    size: 16
                }),
                /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                    id: "iH8pgl"
                })
            ]
        })
    });
};
const $5116544d189893b5$var$DesktopRenderer = ({ navigationItems: navigationItems, goBack: goBack })=>{
    (0, $kIarK$useLingui)();
    const navigationItem = navigationItems?.[navigationItems.length - 2];
    const tid = (0, $kIarK$useTestId)('desktop-back-button');
    if (!navigationItem) return null;
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "border-primary bg-custom-ui-100 absolute top-3 left-3 flex h-[68px] min-w-[142px] cursor-pointer flex-row items-center justify-between gap-2 rounded-l border p-1 select-none",
        onClick: goBack,
        ...tid(),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsxs)("span", {
                className: "flex flex-row items-center gap-1 overflow-hidden text-ellipsis whitespace-nowrap",
                title: navigationItem.title,
                children: [
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$ArrowLeft), {
                        className: "ml-1",
                        size: 16
                    }),
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                        variant: "heading6",
                        className: "text-custom-background-text-primary max-w-[70px] overflow-hidden text-ellipsis whitespace-nowrap",
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                            id: "iH8pgl"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("img", {
                className: "h-[60px] w-24 rounded-sm",
                src: navigationItem.asset.optimizedUrl ?? navigationItem.asset.url,
                alt: "Previous angle preview",
                ...tid('preview-img')
            })
        ]
    });
};
const $5116544d189893b5$export$b8a61e5c71402559 = /*#__PURE__*/ (0, $kIarK$memo)($5116544d189893b5$var$NavigationComponent);







var $BO02E = parcelRequire("BO02E");

var $dqNEo = parcelRequire("dqNEo");
const $091a3caa649e2696$export$e59b156aeac1007d = (props)=>{
    const { activeScene: activeScene, allScenesInOrder: allScenesInOrder } = props;
    const indexOfActiveScene = allScenesInOrder.indexOf(activeScene);
    if (indexOfActiveScene === -1) return {
        nextScene: null,
        previousScene: null
    };
    const previousScene = indexOfActiveScene > 0 ? allScenesInOrder[indexOfActiveScene - 1] : null;
    const nextScene = indexOfActiveScene < allScenesInOrder.length - 1 ? allScenesInOrder[indexOfActiveScene + 1] : null;
    return {
        previousScene: previousScene,
        nextScene: nextScene
    };
};




const $0b5bd51331ae649d$export$5afd6f7eb9f43a07 = ()=>{
    const { setActiveScene: setActiveScene, view: activeScene, setAppHistory: setAppHistory, appHistory: appHistory } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const tid = (0, $kIarK$useTestId)('desktop-angle-arrow-block');
    const scenes = (0, $39e51ae0969551d7$export$26531d8e255edf16)((state)=>state.scenes);
    const relatedScenes = (0, $kIarK$useMemo)(()=>{
        return scenes.filter((scene)=>activeScene.relatedScenes.includes(scene.uuid));
    }, [
        scenes,
        activeScene
    ]);
    const orderedScenes = (0, $7e80c8905f947009$export$2dfde3f1d1c9e8ac)([
        ...relatedScenes,
        activeScene
    ]);
    const { previousScene: previousScene, nextScene: nextScene } = (0, $091a3caa649e2696$export$e59b156aeac1007d)({
        activeScene: activeScene,
        allScenesInOrder: orderedScenes
    });
    const handleDirectionChange = (newView)=>{
        const history = appHistory.slice(0, appHistory.length - 1);
        (0, $dqNEo.default)('View change', newView);
        setActiveScene(newView);
        setAppHistory(history.concat([
            newView
        ]));
    };
    const buttonBaseClassName = 'm-3 w-8 border border-primary pointer-events-auto';
    const hideAngleSwitcher = !previousScene && !nextScene;
    if (hideAngleSwitcher) return null;
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "pointer-events-none absolute flex h-full w-full flex-row items-center justify-between",
        ...tid(),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                className: buttonBaseClassName,
                onClick: ()=>handleDirectionChange(previousScene.uuid),
                disabled: !previousScene,
                icon: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$CaretLeft), {
                    size: 16
                }),
                theme: "white",
                testId: "desktop-arrow-left-scene-button"
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                className: buttonBaseClassName,
                onClick: ()=>handleDirectionChange(nextScene.uuid),
                disabled: !nextScene,
                icon: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$CaretRight), {
                    size: 16
                }),
                theme: "white",
                testId: "desktop-arrow-right-scene-button"
            })
        ]
    });
};










var $BO02E = parcelRequire("BO02E");

var $f9meZ = parcelRequire("f9meZ");

const $66bb35d4a1cec1eb$export$925eec8bc614a73e = (min, max, initial)=>{
    const length = max - min + 1;
    let index = initial - min;
    return (modifier = 0)=>{
        // Calculate the new index with modifier
        index = (index + modifier) % length;
        // Adjust index if negative
        if (index < 0) index += length;
        // Return the corresponding value in the range
        return min + index;
    };
};


const $590f7356e40951f7$export$cf4759cf15f7d9e2 = 320;
const $590f7356e40951f7$export$1391212d75b2ee65 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $590f7356e40951f7$var$isMouseEvent = (e)=>e && 'screenX' in e;
const $590f7356e40951f7$var$defaultOptions = {
    index: 0,
    tolerance: 10,
    beforeChange: ()=>{},
    afterChange: ()=>{},
    onEnd: ()=>{},
    scenes: [],
    draggableRef: {
        current: false
    }
};
const $590f7356e40951f7$var$parseOptions = (opts)=>({
        ...$590f7356e40951f7$var$defaultOptions,
        ...opts
    });
const $590f7356e40951f7$var$getMousePosition = (e)=>$590f7356e40951f7$var$isMouseEvent(e) ? e.pageX : e.touches[0].pageX;
const $590f7356e40951f7$var$setPointerDown = ({ element: element, value: value })=>{
    element?.parentElement?.classList.toggle('cursor-grabbing', value);
};
const $590f7356e40951f7$var$initElement = (elem, instance, opts)=>{
    $590f7356e40951f7$var$setPointerDown({
        element: elem,
        value: false
    });
    let startIndex = null;
    let startPosition = null;
    const isDragging = ()=>startIndex !== null && startPosition !== null;
    const start = (e)=>{
        startIndex = instance.current;
        startPosition = $590f7356e40951f7$var$getMousePosition(e);
    };
    const move = (e)=>{
        if (!opts.draggableRef.current || !isDragging()) return;
        e.stopPropagation();
        const currentPosition = $590f7356e40951f7$var$getMousePosition(e);
        const distance = startPosition - currentPosition;
        const offset = Math.round(distance / opts.tolerance);
        if (startIndex + offset === instance.current) return;
        instance.goTo(startIndex + offset);
    };
    const end = ()=>{
        if (opts.onEnd && startIndex != null) opts.onEnd(startIndex);
        startIndex = null;
        startPosition = null;
    };
    elem.addEventListener('touchstart', start, {
        passive: true
    });
    elem.addEventListener('mousedown', start, {
        passive: true
    });
    elem.addEventListener('touchmove', move, {
        passive: true
    });
    elem.addEventListener('mousemove', move, {
        passive: true
    });
    elem.addEventListener('touchend', end, {
        passive: true
    });
    elem.addEventListener('mouseup', end, {
        passive: true
    });
    elem.addEventListener('pointerleave', end, {
        passive: true
    });
    return ()=>{
        elem.removeEventListener('touchstart', start);
        elem.removeEventListener('mousedown', start);
        elem.removeEventListener('touchmove', move);
        elem.removeEventListener('mousemove', move);
        elem.removeEventListener('touchend', end);
        elem.removeEventListener('mouseup', end);
        elem.removeEventListener('pointerleave', end);
    };
};
const $590f7356e40951f7$export$185802fd694ee1f5 = (elem, opts)=>{
    const options = $590f7356e40951f7$var$parseOptions(opts);
    const scenes = opts.scenes;
    const c = (0, $66bb35d4a1cec1eb$export$925eec8bc614a73e)(0, scenes.length - 1, options.index);
    const activeScene = options.scenes[c()];
    const goTo = (newIndex, oldIndex = instance.current)=>{
        if (options.beforeChange({
            newIndex: newIndex,
            oldIndex: oldIndex
        }) === false) return;
        const currentIndex = (0, $66bb35d4a1cec1eb$export$925eec8bc614a73e)(0, scenes.length - 1, newIndex)();
        instance.current = currentIndex;
        if (currentIndex !== oldIndex) options.afterChange({
            newIndex: currentIndex,
            oldIndex: oldIndex
        });
        instance.activeScene = options.scenes[currentIndex];
        const event = new CustomEvent('rotate', {
            detail: {
                currentIndex: currentIndex,
                oldIndex: oldIndex,
                activeScene: instance.activeScene
            }
        });
        instance.element.dispatchEvent(event);
    };
    const prev = ()=>goTo(c(-1), c());
    const next = ()=>goTo(c(1), c());
    const compassDirections = {
        N: 0,
        E: 2,
        S: 4,
        W: 6
    };
    const getIndex = (direction)=>{
        const index = options.scenes.findIndex((scene)=>scene.compassDirection === compassDirections[direction]);
        return index === -1 ? 0 : index;
    };
    const goLeft = ()=>{
        const total = scenes.length;
        const ratio = Math.floor(total / 4);
        const diff = instance.current - ratio;
        const newIndex = diff < 0 ? total + diff : diff;
        instance.rotateTo({
            newIndex: newIndex,
            direction: 'left',
            speed: 0.7
        });
    };
    const goRight = ()=>{
        const total = scenes.length;
        const ratio = Math.floor(total / 4);
        const diff = instance.current + ratio;
        const newIndex = diff % total;
        instance.rotateTo({
            newIndex: newIndex,
            direction: 'right',
            speed: 0.7
        });
    };
    const getRotationSign = (newIndex, oldIndex)=>{
        let distance = (newIndex - oldIndex + scenes.length) % scenes.length;
        if (distance > scenes.length / 2) distance -= scenes.length;
        return Math.sign(distance);
    };
    const rotateTo = ({ newIndex: newIndex, direction: direction, duration: duration, speed: speed = 1, onEnd: onEnd })=>{
        const oldIndex = instance.current;
        const cleanup = ()=>{
            if (!instance.animationState) return;
            cancelAnimationFrame(instance.animationState.rafRef);
            $590f7356e40951f7$var$setPointerDown({
                element: elem,
                value: false
            });
            delete instance.animationState;
        };
        $590f7356e40951f7$var$setPointerDown({
            element: elem,
            value: true
        });
        let sign = 1;
        if (!direction) sign = getRotationSign(newIndex, oldIndex);
        else if (direction === 'left') sign = -1;
        cleanup();
        const frameCount = Math.abs(newIndex - oldIndex);
        const animate = ()=>{
            if (instance.current !== newIndex) {
                const diff = Math.abs(newIndex - instance.current);
                const easing = (0, $kIarK$easeExpInOut)(1 - diff / (scenes.length - 1));
                const delayMs = (duration ? Math.min(duration / frameCount, 1000 / 60) : easing * diff + 10) / speed;
                $590f7356e40951f7$export$1391212d75b2ee65(delayMs).then(()=>{
                    if (animationId !== instance.animationState?.id) return;
                    const index = sign + instance.current;
                    instance.goTo(index, oldIndex);
                    instance.animationState.rafRef = requestAnimationFrame(animate);
                });
            } else {
                if (opts.onEnd) opts.onEnd(oldIndex);
                if (onEnd) onEnd();
                cleanup();
            }
        };
        const animationId = requestAnimationFrame(animate);
        instance.animationState = {
            id: animationId,
            rafRef: animationId
        };
    };
    const instance = {
        current: (0, $66bb35d4a1cec1eb$export$925eec8bc614a73e)(0, scenes.length - 1, options.index)(),
        goTo: goTo,
        prev: prev,
        next: next,
        rotateTo: rotateTo,
        goRight: goRight,
        goLeft: goLeft,
        getIndex: getIndex,
        element: document.createElement('div'),
        activeScene: activeScene,
        cleanup: ()=>{}
    };
    const cleanup = $590f7356e40951f7$var$initElement(elem, instance, options);
    instance.cleanup = cleanup;
    return instance;
};







var $BO02E = parcelRequire("BO02E");

var $4A1DC = parcelRequire("4A1DC");


var $f9meZ = parcelRequire("f9meZ");


var $1KlOg = parcelRequire("1KlOg");








const $138de80403171134$export$caa9c6fe5a7d95e7 = (node)=>(0, $kIarK$renderToString)(/*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$I18nProvider), {
        i18n: (0, $kIarK$i18n),
        children: node
    }));









function $34e18f7dd1073436$export$cf157e14e63535b0(points) {
    const yOffset = 5;
    const yBuffer = 15;
    const hull = (0, $kIarK$polygonHull)(points);
    const minY = Math.min(...hull.map((point)=>point[1])) - yOffset;
    const topPoints = hull.filter((point)=>point[1] <= minY + yBuffer);
    const xCoordinates = topPoints.map((point)=>point[0]);
    const minX = Math.min(...xCoordinates);
    const maxX = Math.max(...xCoordinates);
    const midX = (minX + maxX) / 2;
    return [
        midX,
        minY
    ];
}
const $34e18f7dd1073436$var$mapPoints = (0, $kIarK$pipe)((0, $kIarK$uniqBy)(({ x: x, y: y })=>`${x}${y}`), (0, $kIarK$map)(({ x: x, y: y })=>[
        x,
        y
    ]));
function $34e18f7dd1073436$var$NumberTooltipComponent(props, ref) {
    const { uuid: uuid, topText: topText, bottomText: bottomText, show: show, points: points, position: position, style: style = {}, ...rest } = props;
    const height = topText && bottomText ? 50 : 24;
    const uniquePoints = $34e18f7dd1073436$var$mapPoints(points);
    const [x, y] = $34e18f7dd1073436$export$cf157e14e63535b0(uniquePoints);
    const elementClassName = 'rounded-md shadow-md absolute overflow-visible select-none';
    const contentJsx = (style)=>/*#__PURE__*/ (0, $kIarK$jsxs)("div", {
            className: "flex flex-col items-center justify-center rounded-sm px-1.5 py-1 whitespace-nowrap",
            style: style,
            children: [
                /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                    className: "bg-tooltip absolute h-full w-full rounded-md backdrop-blur-[6px]"
                }),
                /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                    className: "bg-arrow clip-path-arrow absolute bottom-px left-1/2 h-2 w-[14px] -translate-x-1/2 translate-y-full transform backdrop-blur-xs"
                }),
                topText ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                    variant: "bodyXSMedium",
                    className: "z-10",
                    children: topText
                }) : null,
                bottomText ? /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Text), {
                    variant: "bodyXS",
                    className: "z-10",
                    children: [
                        "(",
                        bottomText,
                        ")"
                    ]
                }) : null
            ]
        });
    const width = 110;
    const elementProps = {
        ...rest,
        id: `numberTooltip-${uuid}`,
        style: style,
        className: elementClassName,
        children: contentJsx({
            opacity: show ? 1 : 0,
            maxHeight: `${height}px`
        })
    };
    const divStyle = {
        left: `${position?.x || x - width / 2}px`,
        top: `${position?.y || y - height}px`,
        width: `${width}px`,
        height: `${height}px`,
        ...style
    };
    return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        ...elementProps,
        style: divStyle,
        ref: ref
    });
}
const $34e18f7dd1073436$export$4a657eec83cc7989 = /*#__PURE__*/ (0, $kIarK$forwardRef)($34e18f7dd1073436$var$NumberTooltipComponent);
const $34e18f7dd1073436$var$createElement = (name)=>document.createElementNS('http://www.w3.org/2000/svg', name);
function $34e18f7dd1073436$var$SVGNumberTooltipComponent(props, ref) {
    const { uuid: uuid, topText: topText, bottomText: bottomText, points: points, position: position, style: style = {}, sceneGroup: sceneGroup, backgroundFill: backgroundFill = 'url(#tooltipGradient)', backgroundFilter: backgroundFilter = 'url(#blurFilter)', ...rest } = props;
    const height = topText && bottomText ? 50 : 24;
    const uniquePoints = $34e18f7dd1073436$var$mapPoints(points);
    const [x, y] = $34e18f7dd1073436$export$cf157e14e63535b0(uniquePoints);
    const arrowWidth = 6;
    const arrowHeight = 8;
    const getLabels = (width = 0)=>/*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Fragment), {
            children: [
                topText ? /*#__PURE__*/ (0, $kIarK$jsx)("text", {
                    x: width / 2,
                    textAnchor: "middle",
                    y: bottomText ? 20 : 17,
                    fontSize: ".875rem",
                    fontWeight: "500",
                    children: topText
                }) : null,
                bottomText ? /*#__PURE__*/ (0, $kIarK$jsx)("text", {
                    x: width / 2,
                    textAnchor: "middle",
                    y: topText ? 41 : 16,
                    fontSize: ".875rem",
                    fontWeight: "400",
                    children: bottomText
                }) : null
            ]
        });
    const width = (()=>{
        const padding = 20;
        const g = $34e18f7dd1073436$var$createElement('g');
        g.innerHTML = (0, $kIarK$renderToString)(getLabels());
        sceneGroup.appendChild(g);
        const result = (g?.getBBox().width ?? 0) + padding;
        setTimeout(()=>g.remove());
        return result < height ? height : result;
    })();
    const elementProps = {
        id: `numberTooltip-${uuid}`,
        x: position?.x || x - width / 2,
        y: position?.y || y - height,
        width: `${width}px`,
        height: `${height}px`,
        className: 'select-none cursor-default overflow-hidden',
        style: style,
        ...rest
    };
    return /*#__PURE__*/ (0, $kIarK$jsxs)("g", {
        ...elementProps,
        ref: ref,
        transform: `translate(${elementProps.x}, ${elementProps.y})`,
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)("rect", {
                rx: "4",
                ry: "4",
                fill: backgroundFill,
                filter: backgroundFilter,
                width: elementProps.width,
                height: elementProps.height
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("rect", {
                rx: "4",
                ry: "4",
                fill: backgroundFill,
                width: elementProps.width,
                height: elementProps.height
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("polygon", {
                fill: backgroundFill,
                points: `-${arrowWidth},0 0,${arrowHeight} ${arrowWidth},0`,
                transform: `translate(${width / 2}, ${height})`
            }),
            getLabels(width)
        ]
    });
}
const $34e18f7dd1073436$export$de13c294243403cd = /*#__PURE__*/ (0, $kIarK$forwardRef)($34e18f7dd1073436$var$SVGNumberTooltipComponent);


const $488327469636d236$export$2a6eb0b949768c43 = (args)=>{
    const { sceneGroup: sceneGroup, scenes: scenes, elements: elements, filters: filters, reference: reference, project: project, isMobile: isMobile } = args;
    const element = elements.find(({ uuid: uuid })=>uuid === reference.parent);
    const isComingForSale = element?.comingForSale || element?.state === 'coming_for_sale';
    if (!element || element.notAvailable && !isComingForSale || element.type === 'unit') return null;
    const availableUnitsCount = (0, $d6bae723e3580231$export$22132c7d12dc1e4c)((0, $4a2330ccd45e58ac$export$c0e506a8d7518b9c)({
        uuid: element.uuid,
        type: element.type,
        scenes: scenes,
        elements: elements
    }), filters).filter(({ state: state })=>[
            'for_sale',
            'for_rent'
        ].includes(state));
    const allUnitsCount = (0, $13a15ab8aff721fc$export$65a660940c71277b)({
        uuid: element.uuid,
        type: element.type,
        elements: elements,
        project: project
    });
    const countLabel = availableUnitsCount.length > allUnitsCount.length ? `${availableUnitsCount.length}` : `${availableUnitsCount.length}/${allUnitsCount.length}`;
    let extraProps = {};
    if (isComingForSale) extraProps = {
        backgroundFill: 'var(--color-pp-coming-for-sale)',
        backgroundFilter: '',
        bottomText: '',
        topText: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "PJR11c"
        }),
        fill: '#fff'
    };
    return sceneGroup.node().insertAdjacentHTML('beforeend', (0, $138de80403171134$export$caa9c6fe5a7d95e7)(/*#__PURE__*/ (0, $kIarK$jsx)((0, $34e18f7dd1073436$export$de13c294243403cd), {
        sceneGroup: sceneGroup.node(),
        uuid: reference?.id,
        topText: isMobile ? null : element.title,
        bottomText: (0, $kIarK$i18n)._(/*i18n*/ {
            id: "Ig4phb",
            values: {
                countLabel: countLabel
            }
        }),
        points: reference.points,
        position: reference.tooltipPosition,
        ...extraProps
    })));
};



var $9APwq = parcelRequire("9APwq");

var $647nY = parcelRequire("647nY");




var $BO02E = parcelRequire("BO02E");



var $1KlOg = parcelRequire("1KlOg");
const $fbb1b0baf018a5e9$export$5fed9cc43865dc7e = (uuid)=>{
    $fbb1b0baf018a5e9$export$baa63844d4ace691();
    (0, $kIarK$select)(`[id^="scene-"] [data-uuid="${uuid}"]`).classed((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).focused, true);
};
const $fbb1b0baf018a5e9$export$baa63844d4ace691 = ()=>(0, $kIarK$selectAll)(`.${(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).focused}`).classed((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).focused, false);
const $fbb1b0baf018a5e9$export$aedc931e82562f4e = ({ focusSourceRef: focusSourceRef, focusedElementRef: focusedElementRef, scenes: scenes })=>{
    const { rendererType: rendererType, elements: elements, settings: settings, levels: levels } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { focusedElement: focusedElement, activeAngle: activeAngle, rotateInstanceRef: rotateInstanceRef, setShowUnconfiguredOverlay: setShowUnconfiguredOverlay } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const is2D = rendererType === '2d';
    (0, $kIarK$useEffect)(()=>{
        focusedElementRef.current = focusedElement;
        $fbb1b0baf018a5e9$export$baa63844d4ace691();
        if (!focusedElement) return;
        if (is2D) {
            $fbb1b0baf018a5e9$export$5fed9cc43865dc7e(focusedElement);
            return;
        }
        const isPolygonInView = focusSourceRef.current === 'polygon' || scenes[activeAngle.current]?.references.some((ref)=>ref.parent === focusedElement);
        const newIndex = isPolygonInView ? activeAngle.current : (0, $82cb673ceac8e05a$export$812f044f0b2222f0)({
            levels: levels,
            scene: scenes[activeAngle.current],
            elementUuid: focusedElement
        });
        focusSourceRef.current = null;
        if ((0, $kIarK$isNil)(newIndex) || !settings.autoRotateToFavorableAngle) {
            $fbb1b0baf018a5e9$export$5fed9cc43865dc7e(focusedElement);
            return;
        }
        rotateInstanceRef.current.rotateTo({
            newIndex: newIndex,
            duration: 200,
            onEnd: ()=>{
                const isInView = scenes[activeAngle.current]?.references.some((ref)=>ref.parent === focusedElement);
                setShowUnconfiguredOverlay(!isInView);
                $fbb1b0baf018a5e9$export$5fed9cc43865dc7e(focusedElement);
            }
        });
    }, [
        setShowUnconfiguredOverlay,
        levels,
        focusedElement,
        is2D,
        elements,
        rotateInstanceRef,
        scenes,
        activeAngle,
        focusedElementRef,
        focusSourceRef,
        settings.autoRotateToFavorableAngle
    ]);
};


const $6eb831bd70db8754$var$searchParams = new URLSearchParams(window.location.search);
const $6eb831bd70db8754$var$environment = $6eb831bd70db8754$var$searchParams.get('environment');
const $6eb831bd70db8754$export$c52de51160cdfcaf = ({ focusedElementRef: focusedElementRef, scenesArg: scenesArg } = {})=>{
    const { elements: elements, settings: settings, project: project, scenes: allScenes, rendererType: rendererType } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const scenes = scenesArg ?? allScenes;
    const { activeAngle: activeAngle, activeScene: activeScene, showSplashScreen: showSplashScreen, isLoading: isFullLoading } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const filters = (0, $kIarK$useContext)((0, $670000472aba54a3$export$2e3feefe77201a07));
    const isMobile = (0, $f9meZ.useIsMobile)();
    const isLoading = showSplashScreen || isFullLoading;
    const drawScene = (0, $kIarK$useCallback)(()=>{
        requestAnimationFrame(()=>{
            const is2D = rendererType === '2d';
            const currentScene = is2D ? scenes.find((_scene)=>_scene.uuid === activeScene) : scenes[activeAngle.current];
            if (!currentScene) return;
            const showPartiallyOwnedStatus = settings.settings?.showPartiallyOwnedStatus;
            const showPolygonsForSoldUnits = settings.showPolygonsForSoldUnits;
            const references = (0, $d6bae723e3580231$export$bf6953c147a3aa6f)({
                references: currentScene.references,
                elements: elements,
                filters: filters,
                showPolygons: showPolygonsForSoldUnits
            });
            const sceneGroup = (0, $kIarK$select)(`#scene-${currentScene.uuid}`);
            if (sceneGroup.empty()) return;
            const polygonsData = references.map((reference)=>{
                const element = elements.find(({ uuid: uuid })=>uuid === reference.parent);
                if (!(0, $647nY.shouldRenderPolygon)({
                    reference: reference
                })) return null;
                const { definitions: definitions, ...attributes } = (0, $9APwq.getPolygonAttributes)({
                    points: reference.points,
                    element: element,
                    colorProperties: (0, $4A1DC.getPolygonColorProperties)({
                        settings: settings,
                        element: element
                    }),
                    showPartiallyOwnedStatus: showPartiallyOwnedStatus
                });
                return {
                    definitions: definitions,
                    uuid: element.uuid,
                    id: reference.id,
                    className: attributes.className
                };
            }).filter(Boolean);
            (0, $kIarK$select)(`svg.${(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).scenesContainer}`).selectAll('g > *').filter(function() {
                return !(this instanceof SVGImageElement);
            }).remove();
            polygonsData.forEach((data)=>{
                const group = sceneGroup.append('g').attr('data-uuid', data.uuid).attr('data-reference', data.id).attr('class', (0, $kIarK$classnames)(data.className, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).isLoading]: isLoading
                }));
                data.definitions.forEach((definition)=>{
                    group.append('path').attr('d', definition);
                });
            });
            // Re-focus existing focusedElement after drawing the polygons
            if (focusedElementRef?.current) (0, $fbb1b0baf018a5e9$export$5fed9cc43865dc7e)(focusedElementRef.current);
            if (!settings.settings?.showUnitsCountTooltip) return;
            references.filter((ref)=>ref.type !== 'unit' && (!ref.draft || $6eb831bd70db8754$var$environment === 'preview')).forEach((reference)=>(0, $488327469636d236$export$2a6eb0b949768c43)({
                    sceneGroup: sceneGroup,
                    scenes: allScenes,
                    elements: elements,
                    filters: filters,
                    reference: reference,
                    project: project,
                    isMobile: isMobile
                }));
        });
    }, [
        scenes,
        elements,
        settings,
        filters,
        activeAngle,
        activeScene,
        rendererType,
        allScenes,
        isMobile,
        project,
        isLoading,
        focusedElementRef
    ]);
    return drawScene;
};


const $c08bef83e238a762$export$f9764fe7072b7f91 = ()=>{
    const animationRef = (0, $kIarK$useRef)();
    const holdTimeoutRef = (0, $kIarK$useRef)();
    const { rotateInstanceRef: rotateRef } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const isMobile = (0, $f9meZ.useIsMobile)();
    const cleanup = (0, $kIarK$useCallback)(()=>{
        cancelAnimationFrame(animationRef.current);
        clearTimeout(holdTimeoutRef.current);
        animationRef.current = undefined;
    }, []);
    const drawScene = (0, $6eb831bd70db8754$export$c52de51160cdfcaf)();
    const onPointerDown = (increment)=>{
        holdTimeoutRef.current = setTimeout(()=>{
            cleanup();
            const animate = ()=>{
                (0, $590f7356e40951f7$export$1391212d75b2ee65)(1000 / 30).then(()=>{
                    if (!animationRef.current) return;
                    rotateRef.current.goTo(rotateRef.current.current + increment);
                    animationRef.current = requestAnimationFrame(animate);
                });
            };
            animationRef.current = requestAnimationFrame(animate);
        }, 250);
    };
    const onPointerUp = (0, $kIarK$useCallback)((direction)=>{
        if (animationRef.current) {
            cleanup();
            drawScene();
        } else {
            if (direction === 'left') rotateRef.current.goLeft();
            else rotateRef.current.goRight();
            cleanup();
        }
    }, [
        cleanup,
        rotateRef,
        drawScene
    ]);
    (0, $kIarK$useEffect)(()=>{
        return cleanup;
    }, [
        cleanup
    ]);
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: "border-primary pointer-events-auto flex h-8 transform items-center gap-x-1 rounded-sm border bg-white",
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                "aria-label": "rotate-left",
                theme: "white",
                className: (0, $kIarK$classnames)('h-full px-2', isMobile ? 'hover:border-transparent hover:bg-inherit' : ''),
                icon: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$CaretLeft), {
                    size: 16
                }),
                onPointerDown: ()=>onPointerDown(-1),
                onPointerCancel: cleanup,
                onPointerLeave: cleanup,
                onPointerUp: ()=>onPointerUp('left')
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                variant: "heading6",
                className: "px-1 select-none lg:px-2",
                children: "360\xb0"
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                "aria-label": "rotate-right",
                theme: "white",
                className: (0, $kIarK$classnames)('h-full px-2', isMobile ? 'hover:border-transparent hover:bg-inherit' : ''),
                icon: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$CaretRight), {
                    size: 16
                }),
                onPointerCancel: cleanup,
                onPointerLeave: cleanup,
                onPointerUp: ()=>onPointerUp('right'),
                onPointerDown: ()=>onPointerDown(1)
            })
        ]
    });
};









const $18b79f281afcb2fd$export$ebf20dcba3b4a744 = (props)=>{
    const { handleClick: handleClick, rotateRef: rotateRef, svgSize: svgSize, isMobile: isMobile, textSize: textSize } = props;
    (0, $kIarK$useLingui)();
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: (0, $kIarK$classnames)('pointer-events-auto right-2 flex cursor-pointer items-center justify-center', isMobile ? 'bottom-12' : 'bottom-3'),
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: "inset-0 flex items-center justify-center",
                ref: rotateRef,
                children: /*#__PURE__*/ (0, $kIarK$jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 211.15 211.15",
                    width: svgSize,
                    height: svgSize,
                    children: [
                        /*#__PURE__*/ (0, $kIarK$jsx)("defs", {
                            children: /*#__PURE__*/ (0, $kIarK$jsxs)("filter", {
                                id: "drop-shadow-1",
                                filterUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, $kIarK$jsx)("feOffset", {
                                        dx: "2",
                                        dy: "2"
                                    }),
                                    /*#__PURE__*/ (0, $kIarK$jsx)("feGaussianBlur", {
                                        result: "blur",
                                        stdDeviation: "4"
                                    }),
                                    /*#__PURE__*/ (0, $kIarK$jsx)("feFlood", {
                                        floodColor: "#000",
                                        floodOpacity: ".2"
                                    }),
                                    /*#__PURE__*/ (0, $kIarK$jsx)("feComposite", {
                                        in2: "blur",
                                        operator: "in"
                                    }),
                                    /*#__PURE__*/ (0, $kIarK$jsx)("feComposite", {
                                        in: "SourceGraphic"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $kIarK$jsx)("circle", {
                            cx: "105.58",
                            cy: "105.58",
                            r: "86.72",
                            fill: "#fff",
                            filter: "url(#drop-shadow-1)",
                            strokeWidth: "0"
                        }),
                        /*#__PURE__*/ (0, $kIarK$jsx)("path", {
                            d: "M104.81,23.64c.37-.55,1.18-.55,1.54,0l14.3,21.67c.41.61-.04,1.43-.77,1.43h-28.6c-.74,0-1.18-.82-.77-1.43l14.3-21.67Z",
                            fill: "#e7583b",
                            strokeWidth: "0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                className: "absolute flex items-center justify-center text-black",
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                    className: textSize,
                    children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                        id: "eKhYz9"
                    })
                })
            })
        ]
    });
};



var $BO02E = parcelRequire("BO02E");
// TODO: The direction (E<->W) is inverted intentionally to match current BE implementation

const $055749f4595fd522$export$a6adcf9d06deb046 = (angle)=>{
    if (angle >= 337.5 && angle < 360 || angle < 22.5 && angle >= 0) return (0, $kIarK$i18n)._(/*i18n*/ {
        id: "eKhYz9"
    });
    else if (angle >= 22.5 && angle < 67.5) return (0, $kIarK$i18n)._(/*i18n*/ {
        id: "K38WB7"
    });
    else if (angle >= 67.5 && angle < 112.5) return (0, $kIarK$i18n)._(/*i18n*/ {
        id: "QnXXNN"
    });
    else if (angle >= 112.5 && angle < 157.5) return (0, $kIarK$i18n)._(/*i18n*/ {
        id: "7Kfz4p"
    });
    else if (angle >= 157.5 && angle < 202.5) return (0, $kIarK$i18n)._(/*i18n*/ {
        id: "ZQA8ce"
    });
    else if (angle >= 202.5 && angle < 247.5) return (0, $kIarK$i18n)._(/*i18n*/ {
        id: "a9d3NA"
    });
    else if (angle >= 247.5 && angle < 292.5) return (0, $kIarK$i18n)._(/*i18n*/ {
        id: "dcb95U"
    });
    else if (angle >= 292.5 && angle < 337.5) return (0, $kIarK$i18n)._(/*i18n*/ {
        id: "C+dBfp"
    });
    return '';
};


const $d9c043905a203bc5$export$dc822bae8b0446c8 = (direction)=>{
    const totalDirections = 8;
    const clampedDirection = Math.min(Math.max(direction, 0), totalDirections - 0.01);
    const degrees = clampedDirection / totalDirections * 360;
    return Math.floor(degrees);
};



var $f9meZ = parcelRequire("f9meZ");
const $4e08714edf0d045b$export$87ae43576cc53e22 = ()=>{
    const { i18n: i18n } = (0, $kIarK$useLingui)();
    const isMobile = (0, $f9meZ.useIsMobile)();
    const { rotateInstanceRef: rotateInstanceRef } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const rotateRef = (0, $kIarK$useRef)(null);
    const cardinalDirectionRef = (0, $kIarK$useRef)(null);
    const handleClick = ()=>{
        if (!rotateInstanceRef.current) return;
        rotateInstanceRef.current.rotateTo({
            newIndex: rotateInstanceRef.current.getIndex('N'),
            duration: 200
        });
    };
    const svgSize = isMobile ? '40' : '50';
    const textSize = isMobile ? 'text-xs' : 'text-sm';
    (0, $kIarK$useEffect)(()=>{
        const node = rotateInstanceRef.current?.element;
        if (!node) return undefined;
        const handleOnRotate = ()=>{
            const activeSceneCompassDirection = rotateInstanceRef.current?.activeScene?.compassDirection;
            const normalizedDirection = (0, $d9c043905a203bc5$export$dc822bae8b0446c8)(activeSceneCompassDirection);
            const directionLetter = (0, $055749f4595fd522$export$a6adcf9d06deb046)(normalizedDirection);
            if (!rotateRef.current) return;
            rotateRef.current.style.transform = `rotate(${normalizedDirection}deg)`;
            if (!cardinalDirectionRef.current) return;
            cardinalDirectionRef.current.textContent = directionLetter;
        };
        handleOnRotate();
        node.addEventListener('rotate', handleOnRotate);
        return ()=>node.removeEventListener('rotate', handleOnRotate);
    }, [
        rotateInstanceRef,
        rotateInstanceRef.current?.element,
        rotateRef,
        i18n.locale
    ]);
    // TODO: MT3-6462 Conditionally render NorthCompass or AllDirectionsCompass based on config
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $18b79f281afcb2fd$export$ebf20dcba3b4a744), {
        handleClick: handleClick,
        rotateRef: rotateRef,
        svgSize: svgSize,
        textSize: textSize,
        isMobile: isMobile
    });
};



var $f9meZ = parcelRequire("f9meZ");
const $8ed99cc372ebafd2$export$7c9c61e12d23e82c = ()=>{
    const isMobile = (0, $f9meZ.useIsMobile)();
    return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        className: "pointer-events-none sticky inset-0 flex justify-center",
        children: /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
            className: (0, $kIarK$classnames)('absolute flex w-full items-center justify-between px-2', isMobile ? 'bottom-2' : 'bottom-3'),
            children: [
                /*#__PURE__*/ (0, $kIarK$jsx)((0, $4e08714edf0d045b$export$87ae43576cc53e22), {}),
                /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                    className: "absolute left-1/2 -translate-x-1/2 transform",
                    children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $c08bef83e238a762$export$f9764fe7072b7f91), {})
                })
            ]
        })
    });
};



var $BO02E = parcelRequire("BO02E");
const $14e29a6cb5abc501$export$fb76bb1a9271d29 = (props)=>{
    const { scenes: scenes, currentCompassDirection: currentCompassDirection } = props;
    if (!scenes.length) return 0;
    if (scenes.length === 1) return scenes[0].compassDirection;
    const exactCompassMatch = scenes.findIndex((scene)=>scene.compassDirection === currentCompassDirection);
    if (exactCompassMatch !== -1) return exactCompassMatch;
    const closestIndex = scenes.reduce((closest, scene, index)=>{
        const currentDiff = Math.min(Math.abs(scene.compassDirection - currentCompassDirection), 8 - Math.abs(scene.compassDirection - currentCompassDirection));
        const closestDiff = Math.min(Math.abs(scenes[closest].compassDirection - currentCompassDirection), 8 - Math.abs(scenes[closest].compassDirection - currentCompassDirection));
        return currentDiff < closestDiff ? index : closest;
    }, 0);
    return closestIndex;
};



const $51ab922e73581c8c$export$852a2d21695e281d = ()=>(0, $kIarK$bowser).getParser(window.navigator.userAgent);
const $51ab922e73581c8c$export$6d629c114b9fc461 = ()=>$51ab922e73581c8c$export$852a2d21695e281d().getBrowser().name === (0, $kIarK$bowser).BROWSER_MAP.firefox;



var $f9meZ = parcelRequire("f9meZ");


var $dqNEo = parcelRequire("dqNEo");
const $82fc683722f61b69$export$69a3209f1a06c04d = new Map([]);
const $82fc683722f61b69$export$6b05b21262ec0515 = async ({ images: images, fetchPriority: fetchPriority })=>{
    let promises = [];
    try {
        promises = images.map(({ uuid: uuid, url: url })=>new Promise((resolve)=>{
                const alreadyPreloaded = $82fc683722f61b69$export$69a3209f1a06c04d.get(uuid);
                if (alreadyPreloaded) return resolve(alreadyPreloaded.error ? null : alreadyPreloaded);
                const img = new Image();
                img.onload = ()=>{
                    const props = {
                        uuid: uuid,
                        url: url,
                        height: img.height,
                        width: img.width,
                        error: false
                    };
                    $82fc683722f61b69$export$69a3209f1a06c04d.set(uuid, props);
                    resolve(props);
                };
                img.onerror = ()=>{
                    $82fc683722f61b69$export$69a3209f1a06c04d.set(uuid, {
                        uuid: uuid,
                        url: url,
                        error: true
                    });
                    resolve(null);
                };
                if (fetchPriority) img.fetchPriority = fetchPriority;
                img.src = url;
            }));
    } catch (e) {
        (0, $dqNEo.default)('Error loading image', e);
    }
    return Promise.all(promises).then((data)=>data.filter(Boolean));
};
const $82fc683722f61b69$var$mapScenesToImages = (scenes)=>scenes.map(({ asset: asset })=>({
            uuid: asset.uuid,
            url: asset.optimizedUrl ?? asset.url
        }));
const $82fc683722f61b69$export$4cd6903bc907aab2 = (args)=>{
    const { rootSceneUuid: rootSceneUuid, scenes: scenes, onFirstImageLoaded: onFirstImageLoaded } = args;
    const [isLoading, setIsLoading] = (0, $kIarK$useState)(false);
    const preload = (0, $kIarK$useCallback)(async ()=>{
        setIsLoading(true);
        const scene = scenes.find(({ uuid: uuid })=>uuid === rootSceneUuid) ?? scenes.find(({ main: main })=>main) ?? scenes[0] ?? {};
        if (!scene?.uuid) {
            (0, $dqNEo.default)('rootView not found: ', {
                rootView: scene?.uuid,
                scenes: scenes
            });
            return;
        }
        await $82fc683722f61b69$export$6b05b21262ec0515({
            images: $82fc683722f61b69$var$mapScenesToImages([
                scene
            ]),
            fetchPriority: 'high'
        });
        if (onFirstImageLoaded) onFirstImageLoaded();
        await $82fc683722f61b69$export$6b05b21262ec0515({
            images: $82fc683722f61b69$var$mapScenesToImages(scenes)
        });
        setIsLoading(false);
    }, [
        scenes,
        onFirstImageLoaded,
        rootSceneUuid
    ]);
    return (0, $kIarK$useMemo)(()=>({
            isLoading: isLoading,
            images: Array.from($82fc683722f61b69$export$69a3209f1a06c04d.values()),
            preload: preload
        }), [
        isLoading,
        preload
    ]);
};












var $6SLKk = parcelRequire("6SLKk");


var $BO02E = parcelRequire("BO02E");

var $beILY = parcelRequire("beILY");

const $3609f8d6bb611ebe$var$excludedProperties = [
    'state',
    'unitId'
];
const $3609f8d6bb611ebe$export$2f9b8ee79476a739 = (args)=>{
    const { element: element, propertiesList: propertiesList = [] } = args;
    return propertiesList.reduce((acc, key)=>{
        const value = element.properties[key];
        if (value && !$3609f8d6bb611ebe$var$excludedProperties.includes(key)) acc[key] = value;
        return acc;
    }, {});
};




var $1KlOg = parcelRequire("1KlOg");
const $7816de56623962c9$export$83f4e8a3a05204df = /*#__PURE__*/ (0, $kIarK$memo)(/*#__PURE__*/ (0, $kIarK$forwardRef)((_, ref)=>{
    const filters = (0, $kIarK$useContext)((0, $670000472aba54a3$export$2e3feefe77201a07));
    const { hovered: hovered, floorplans: floorplans } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const { elements: elements, settings: settings, scenes: scenes, project: project } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { showPartiallyOwnedStatus: showPartiallyOwnedStatus, partiallyOwnedLabel: partiallyOwnedLabel } = settings.settings;
    const floorplan = floorplans[hovered]?.url;
    const [show, setShow] = (0, $kIarK$useState)(!floorplan);
    const arrowRef = (0, $kIarK$useRef)(null);
    const tid = (0, $kIarK$useTestId)('tooltip-floorplan');
    const { refs: refs, floatingStyles: floatingStyles, context: context } = (0, $kIarK$useFloating)({
        placement: 'top',
        whileElementsMounted: (0, $kIarK$autoUpdate),
        middleware: [
            (0, $kIarK$flip)({
                fallbackAxisSideDirection: 'start',
                crossAxis: false
            }),
            (0, $kIarK$shift)(),
            (0, $kIarK$offset)(10),
            (0, $kIarK$arrow)({
                element: arrowRef
            })
        ]
    });
    (0, $kIarK$useLayoutEffect)(()=>{
        refs.setReference(ref.current);
    }, [
        ref,
        refs
    ]);
    const element = elements.find((element)=>element.uuid === hovered);
    const properties = (0, $kIarK$useMemo)(()=>{
        return element.type === 'unit' ? (0, $3609f8d6bb611ebe$export$2f9b8ee79476a739)({
            element: element,
            propertiesList: settings.properties[element.type].default
        }) : (0, $7b24a01339a4f667$export$a9bf3957f10f87e8)({
            element: element,
            elements: elements,
            scenes: scenes,
            filters: filters,
            project: project,
            propertiesList: settings.properties[element.type].default
        });
    }, [
        elements,
        element,
        scenes,
        filters,
        project,
        settings.properties
    ]);
    if (element.type !== 'unit') delete properties.title;
    const badges = [
        showPartiallyOwnedStatus && element.partiallyOwned && !(0, $kIarK$isNil)(partiallyOwnedLabel) ? {
            type: 'partiallyOwned',
            value: partiallyOwnedLabel
        } : null,
        {
            type: (0, $kIarK$camelize)(element.state),
            value: (0, $beILY.canonicalUnitStates)[element.state]
        }
    ].filter(Boolean);
    const onFloorplanLoad = (0, $kIarK$useCallback)(()=>{
        setShow(true);
    }, []);
    return /*#__PURE__*/ (0, $kIarK$createPortal)(/*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        id: `tooltip-${hovered}`,
        className: (0, $kIarK$classnames)((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).tooltip, 'animate-fade-in', show ? '' : 'hidden'),
        ref: refs.setFloating,
        style: floatingStyles,
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $6SLKk.Card), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).card,
                sections: [
                    {
                        label: {
                            label: element.title,
                            badges: badges,
                            displayValue: element.title
                        },
                        properties: properties
                    }
                ],
                children: floorplan ? /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).floorplan,
                    children: /*#__PURE__*/ (0, $kIarK$jsx)("img", {
                        src: floorplan,
                        onLoad: onFloorplanLoad,
                        alt: "floorplan",
                        ...tid()
                    })
                }) : null
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$FloatingArrow), {
                fill: "#FFF",
                stroke: "#FFF",
                ref: arrowRef,
                context: context
            })
        ]
    }), document.body);
}));










var $BO02E = parcelRequire("BO02E");





const $f65af37219336243$export$3d0a521cf1fe849a = ({ videos: videos, firstFrame: firstFrame, onEnded: onEnded })=>{
    const isMobile = (0, $51ab922e73581c8c$export$852a2d21695e281d)().getPlatformType() !== (0, $kIarK$bowser).PLATFORMS_MAP.desktop;
    const videoRef = (0, $kIarK$useRef)(null);
    const video = isMobile ? videos.mobileVideo : videos.desktopVideo;
    const videoProps = firstFrame ? {
        poster: firstFrame.url
    } : {};
    const attemptPlay = ()=>{
        if (!videoRef.current) return;
        videoRef.current.play().catch(onEnded);
    };
    // Required because of an issue with Safari skipping through video
    const videoStartAt = isMobile ? '#t=0.1' : '';
    return /*#__PURE__*/ (0, $kIarK$jsxs)("video", {
        ref: videoRef,
        preload: "auto",
        autoPlay: true,
        muted: true,
        playsInline: true,
        width: "100%",
        height: "100%",
        onClick: attemptPlay,
        onEnded: onEnded,
        onError: onEnded,
        ...videoProps,
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)("source", {
                src: `${video?.url}${videoStartAt}`,
                type: video?.contentType
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("source", {
                src: `${videos.originalVideo?.url}${videoStartAt}`,
                type: videos.originalVideo?.contentType
            })
        ]
    });
};


const $5b8989858b8957bd$export$b3c44ac484b3c461 = ({ navigationRef: navigationRef })=>{
    const { hasPlayed: hasPlayed, setHasPlayed: setHasPlayed } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const { videos: videos, firstFrame: firstFrame } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const hasVideos = videos && !(0, $kIarK$isEmpty)(videos);
    const { state: show, toggleOff: toggleOff } = (0, $kIarK$useToggle)(hasVideos && !hasPlayed);
    const onEnded = ()=>{
        toggleOff();
        setTimeout(()=>{
            setHasPlayed(true);
        }, 500);
    };
    (0, $kIarK$useEffect)(()=>{
        if (!navigationRef.current) return;
        if (show) navigationRef.current.dataset.disableHover = 'true';
        else delete navigationRef.current.dataset.disableHover;
    }, [
        show,
        navigationRef
    ]);
    if (!hasVideos || hasPlayed) return null;
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: (0, $kIarK$classnames)('absolute inset-0 z-10 transition-opacity duration-500', show ? 'opacity-100' : 'pointer-events-none opacity-0'),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $f65af37219336243$export$3d0a521cf1fe849a), {
                videos: videos,
                firstFrame: firstFrame,
                onEnded: onEnded
            }),
            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                className: "absolute bottom-0 flex w-full justify-between bg-linear-to-t from-white/30 via-transparent/0 to-transparent p-4",
                children: [
                    /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                        className: "grid-col grid text-white",
                        children: [
                            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                                variant: "bodyXSPlus",
                                className: "text-xs",
                                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                                    id: "g2UNkE"
                                })
                            }),
                            /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Text), {
                                variant: "heading4",
                                className: "-mt-1",
                                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                                    id: "/QcZLG"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Button), {
                        type: "button",
                        className: "pointer-events-auto absolute right-4 bottom-4",
                        onClick: (e)=>{
                            e.stopPropagation();
                            onEnded();
                        },
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Trans), {
                            id: "INHBKa"
                        })
                    })
                ]
            })
        ]
    });
};







var $BO02E = parcelRequire("BO02E");

var $1KlOg = parcelRequire("1KlOg");
const $5786c9f81ee5b018$var$useSize = (target)=>{
    const [size, setSize] = (0, $kIarK$useState)();
    (0, $kIarK$useLayoutEffect)(()=>{
        if (!target) return;
        setSize(target.getBoundingClientRect());
    }, [
        target
    ]);
    (0, $kIarK$reacthookresizeobserver)(target, (entry)=>setSize(entry.contentRect));
    return size;
};
const $5786c9f81ee5b018$var$heightThreshold = 500;
const $5786c9f81ee5b018$var$toggleBuffer = 100;
const $5786c9f81ee5b018$export$eef7c7c048667e2c = /*#__PURE__*/ (0, $kIarK$memo)(({ setIsExpanded: setIsExpanded, toggled: toggled })=>{
    const element = document.querySelector(`.${(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).visual}`);
    const { activeScene: activeScene } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const sceneRef = (0, $kIarK$useRef)(activeScene);
    const size = $5786c9f81ee5b018$var$useSize(element);
    (0, $kIarK$useLayoutEffect)(()=>{
        if (!toggled || !element) return;
        setTimeout(()=>{
            if (!element) return;
            const scrollTop = (element.scrollHeight - element.clientHeight) / 2;
            const scrollLeft = (element.scrollWidth - element.clientWidth) / 2;
            element.scrollTo({
                top: scrollTop,
                left: scrollLeft,
                behavior: 'smooth'
            });
        });
    }, [
        toggled,
        element
    ]);
    (0, $kIarK$useEffect)(()=>{
        if (activeScene !== sceneRef.current) {
            setIsExpanded(false);
            sceneRef.current = activeScene;
        }
    }, [
        activeScene,
        sceneRef,
        setIsExpanded
    ]);
    if ($5786c9f81ee5b018$var$heightThreshold - size?.height < $5786c9f81ee5b018$var$toggleBuffer && !toggled) return null;
    const testId = `${toggled ? 'collapse' : 'expand'}-mobile-picker-area-button`;
    return /*#__PURE__*/ (0, $kIarK$jsx)("div", {
        className: "sticky inset-0",
        children: /*#__PURE__*/ (0, $kIarK$jsx)("div", {
            className: "border-primary absolute right-3 bottom-3 flex h-8 w-8 transform cursor-pointer items-center justify-center rounded-sm border bg-white",
            onClick: ()=>setIsExpanded(!toggled),
            "data-testid": testId,
            children: toggled ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$MagnifyingGlassMinus), {
                size: 16
            }) : /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$MagnifyingGlassPlus), {
                size: 16
            })
        })
    });
});




var $1KlOg = parcelRequire("1KlOg");
const $9da363042717d9b0$export$af9ffbca99a36fd2 = (args)=>{
    const { width: width, height: height, is3D: is3D } = args;
    return (0, $kIarK$zoom)().scaleExtent([
        1,
        3
    ]).translateExtent([
        [
            0,
            0
        ],
        [
            width,
            height
        ]
    ]).filter((e)=>e.type === 'wheel' && is3D).on('zoom', (e)=>{
        document.querySelectorAll(`svg.${(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).scenesContainer} > g`).forEach((polygon)=>polygon.setAttribute('transform', e.transform));
    });
};






var $dqNEo = parcelRequire("dqNEo");
const $de0eb6b1efb28219$export$25925f6080f36862 = (0, $kIarK$lodashdebounce)((0, $kIarK$lodashmemoize)((scene)=>{
    try {
        const image = new Image();
        image.onload = ()=>$de0eb6b1efb28219$var$updateSceneAsset(scene);
        image.src = scene.asset.url;
    } catch (err) {
        (0, $dqNEo.default)(err);
    }
}), 250, {
    trailing: true
});
const $de0eb6b1efb28219$var$updateSceneAsset = (scene)=>(0, $kIarK$select)(`[id="scene-${scene.uuid}"] image[data-optimized]`).attr('data-optimized', null).attr('href', scene.asset.url).attr('xlink:href', scene.asset.url);








var $BO02E = parcelRequire("BO02E");


var $37CU7 = parcelRequire("37CU7");




var $37CU7 = parcelRequire("37CU7");

const $8fc9cf35f30e2d38$export$cba16a822c831a5a = ({ navigationRef: navigationRef })=>{
    const { project: project, settings: settings } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { event: event } = (0, $37CU7.useAnalytics)(project.uuid);
    const { setActiveSceneDetails: setActiveSceneDetails } = (0, $7386f75f7d719bee$export$1bd83ba0476307b)();
    const newEvent = (0, $kIarK$useCallback)((type, element)=>event({
            type: type,
            unitUuid: element.uuid,
            additionalParameters: {
                buildingId: element.building,
                stageId: element.stage,
                targetType: 'polygon'
            }
        }), [
        event
    ]);
    const unitClickHandler = (0, $164070db97899be6$export$66b4faa78018d04a)();
    return {
        handleReferenceClick: (element, targetUuid)=>{
            if (element?.notAvailable && !settings.allowNotAvailableInteraction) return;
            if (element?.type === 'unit') {
                newEvent('property_selector_click', element);
                unitClickHandler(element);
            } else setActiveSceneDetails(targetUuid);
            setTimeout(()=>navigationRef.current?.scrollTo(0, 0));
        }
    };
};




var $1KlOg = parcelRequire("1KlOg");



var $1KlOg = parcelRequire("1KlOg");
const $9a7ad57a63778404$var$scaleFactor = 2;
const $9a7ad57a63778404$export$e8f8eccea13c80d = ({ svg: svg, width: width, height: height, target: target, onEnd: onEnd })=>{
    const sceneSelector = `.${(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).scene}.${(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).active}`;
    const targetBox = target.getBBox();
    const scene = svg.select(sceneSelector);
    const sceneEl = scene.node();
    const sceneBox = sceneEl?.getBBox();
    if (!sceneEl || !sceneBox) {
        document.documentElement.style.pointerEvents = 'initial';
        onEnd();
        return;
    }
    // Center of the target
    const centerX = targetBox.x + targetBox.width / 2;
    const centerY = targetBox.y + targetBox.height / 2;
    // Viewport center minus scaled target center gives translation needed
    let translateX = width / 2 - centerX * $9a7ad57a63778404$var$scaleFactor;
    let translateY = height / 2 - centerY * $9a7ad57a63778404$var$scaleFactor;
    // Clamp translation to avoid empty space beyond scene bounds
    const minTranslateX = width - sceneBox.width * $9a7ad57a63778404$var$scaleFactor;
    const minTranslateY = height - sceneBox.height * $9a7ad57a63778404$var$scaleFactor;
    translateX = (0, $kIarK$clamp)(minTranslateX, 0, translateX);
    translateY = (0, $kIarK$clamp)(minTranslateY, 0, translateY);
    scene.transition().ease((0, $kIarK$easeQuadInOut)).duration(1000).on('start', ()=>{
        document.documentElement.style.pointerEvents = 'none';
    }).attr('transform', `translate(${translateX}, ${translateY}) scale(${$9a7ad57a63778404$var$scaleFactor})`).on('end', ()=>{
        svg.select(sceneSelector).attr('transform', null);
        document.documentElement.style.pointerEvents = 'initial';
        onEnd();
    });
};




var $BO02E = parcelRequire("BO02E");

var $1KlOg = parcelRequire("1KlOg");
const $b07e96bff3b59f4a$export$21660964daad7a20 = (ref)=>{
    const { setHovered: setHovered } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const isDragging = (0, $kIarK$useRef)(false);
    const isPointerDown = (0, $kIarK$useRef)(false);
    (0, $kIarK$useEffect)(()=>{
        const node = ref.current;
        const onPointerDown = ()=>{
            setHovered(null);
            isPointerDown.current = true;
            isDragging.current = false;
            node?.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).pointerDown);
        };
        const onPointerUp = ()=>{
            isPointerDown.current = false;
            node?.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).pointerDown);
        };
        node.addEventListener('pointerdown', onPointerDown);
        node.addEventListener('pointerup', onPointerUp);
        node.addEventListener('pointerleave', onPointerUp);
        node.addEventListener('pointercancel', onPointerUp);
        return ()=>{
            node.removeEventListener('pointerdown', onPointerDown);
            node.removeEventListener('pointerup', onPointerUp);
            node.removeEventListener('pointerleave', onPointerUp);
            node.removeEventListener('pointercancel', onPointerUp);
        };
    }, [
        setHovered,
        ref
    ]);
    return {
        isDragging: isDragging,
        isPointerDown: isPointerDown
    };
};


const $91dbaad5e097b21c$export$cda9ab6ffc878336 = (args)=>{
    const { image: image, navigationRef: navigationRef, focusedElementRef: focusedElementRef, focusSourceRef: focusSourceRef, tooltipTarget: tooltipTarget, setShowTooltip: setShowTooltip, references: references, ref: ref } = args;
    const { project: project, scenes: scenes, elements: elements, settings: settings, rendererType: rendererType } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { handleReferenceClick: handleReferenceClick } = (0, $8fc9cf35f30e2d38$export$cba16a822c831a5a)({
        navigationRef: navigationRef
    });
    const { event: event } = (0, $37CU7.useAnalytics)(project.uuid);
    const { setFocusedElement: setFocusedElement, isMobile: isMobile, setHovered: setHovered, isLoading: isLoading } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const { isPointerDown: isPointerDown, isDragging: isDragging } = (0, $b07e96bff3b59f4a$export$21660964daad7a20)(ref);
    const showTooltipTimeoutRef = (0, $kIarK$useRef)();
    const newEvent = (0, $kIarK$useCallback)((type, element)=>event({
            type: type,
            unitUuid: element.uuid,
            additionalParameters: {
                buildingId: element.building,
                stageId: element.stage,
                targetType: 'polygon'
            }
        }), [
        event
    ]);
    (0, $kIarK$useEffect)(()=>{
        const resetFocusedElement = ()=>{
            if (!focusedElementRef?.current) return;
            focusedElementRef.current = null;
            focusSourceRef.current = null;
            setFocusedElement(null);
        };
        const handleClick = async (e)=>{
            if (e.target && e.target instanceof SVGPathElement) {
                const { uuid: elementUuid, reference: referenceId } = e.target.parentNode.dataset;
                const reference = references.find((reference)=>reference.id === referenceId);
                const element = elements.find((el)=>el.uuid === elementUuid);
                if (!element) return;
                if (isDragging.current && rendererType === '3d') return;
                if (isMobile && focusedElementRef.current !== element.uuid && settings.settings.showUnitList) {
                    setFocusedElement(element.uuid);
                    focusSourceRef.current = 'polygon';
                    return;
                }
                if (element.type === 'unit') handleReferenceClick(element, reference.target.id);
                else {
                    if (element.notAvailable && !settings.allowNotAvailableInteraction) return;
                    const unitsCountTooltip = document.getElementById(`numberTooltip-${referenceId}`);
                    if (unitsCountTooltip) unitsCountTooltip.style.visibility = 'inherit';
                    clearTimeout(showTooltipTimeoutRef.current);
                    if (isLoading) return;
                    const animate = ()=>{
                        const target = document.querySelector(`g[data-reference="${reference.id}"]`);
                        if (!target || (0, $6fe00b3b64d7d526$export$d65dbc6ebb5cc0a6)({
                            scenes: scenes,
                            target: reference.target
                        })) return;
                        (0, $9a7ad57a63778404$export$e8f8eccea13c80d)({
                            svg: (0, $kIarK$select)(ref.current),
                            target: target,
                            width: image?.width,
                            height: image?.height,
                            onEnd: ()=>{
                                setHovered(null);
                                clearTimeout(showTooltipTimeoutRef.current);
                                resetFocusedElement();
                                handleReferenceClick(element, reference.target.id);
                            }
                        });
                    };
                    animate();
                }
                isDragging.current = false;
            }
        };
        const handlePointerMove = (e)=>{
            if (e.target && e.target instanceof SVGPathElement) {
                isDragging.current = isPointerDown.current;
                ref.current?.classList.toggle((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).pointerDown, isPointerDown.current);
            }
        };
        const handlePointerUp = (e)=>{
            if (e.target && e.target instanceof SVGPathElement) {
                const { reference: referenceId } = e.target.parentNode.dataset;
                isPointerDown.current = false;
                isDragging.current = false;
                if (focusedElementRef.current) e.stopPropagation();
                if (e.pointerType === 'touch') return;
                const unitsCountTooltip = document.getElementById(`numberTooltip-${referenceId}`);
                if (unitsCountTooltip) unitsCountTooltip.style.visibility = 'hidden';
            } else if (Math.abs(startX - e.clientX) === 0 && Math.abs(startY - e.clientY) === 0) resetFocusedElement();
        };
        const handlePointerOut = (e)=>{
            if (e.target && e.target instanceof SVGPathElement) {
                clearTimeout(showTooltipTimeoutRef.current);
                e.target.parentNode.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).hovered);
                setHovered(null);
                const unitsCountTooltip = document.getElementById(`numberTooltip-${e.target.parentNode.dataset.reference}`);
                if (unitsCountTooltip) unitsCountTooltip.style.visibility = 'inherit';
            }
        };
        const handlePointerOver = (e)=>{
            if (e.target && e.target instanceof SVGPathElement) {
                const elementUuid = e.target.parentNode.dataset.uuid;
                const element = elements.find((el)=>el.uuid === elementUuid);
                const referenceId = e.target.parentNode.dataset.reference;
                const unitsCountTooltip = document.getElementById(`numberTooltip-${referenceId}`);
                const startShowTooltip = ()=>{
                    clearTimeout(showTooltipTimeoutRef.current);
                    showTooltipTimeoutRef.current = setTimeout(()=>{
                        setHovered(elementUuid);
                    }, 200);
                };
                setShowTooltip(e.pointerType !== 'touch');
                e.target.parentNode.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).hovered);
                clearTimeout(showTooltipTimeoutRef.current);
                if (e.pointerType === 'touch') {
                    startShowTooltip();
                    return;
                }
                if (isPointerDown.current) {
                    setHovered(null);
                    if (unitsCountTooltip) unitsCountTooltip.style.visibility = 'inherit';
                    return;
                }
                startShowTooltip();
                if (unitsCountTooltip) unitsCountTooltip.style.visibility = 'hidden';
                tooltipTarget.current = e.target.parentNode;
                if (element?.type === 'unit') newEvent('hover_property', element);
            }
        };
        let startX;
        let startY;
        const handlePointerDown = (e)=>{
            startX = e.clientX;
            startY = e.clientY;
        };
        document.addEventListener('click', handleClick);
        document.addEventListener('pointermove', handlePointerMove);
        document.addEventListener('pointerup', handlePointerUp);
        document.addEventListener('pointerout', handlePointerOut);
        document.addEventListener('pointerover', handlePointerOver);
        document.addEventListener('pointerdown', handlePointerDown);
        return ()=>{
            document.removeEventListener('click', handleClick);
            document.removeEventListener('pointermove', handlePointerMove);
            document.removeEventListener('pointerup', handlePointerUp);
            document.removeEventListener('pointerout', handlePointerOut);
            document.removeEventListener('pointerover', handlePointerOver);
            document.removeEventListener('pointerdown', handlePointerDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        references,
        elements,
        focusedElementRef,
        setFocusedElement,
        ref,
        rendererType,
        isDragging,
        isPointerDown,
        scenes
    ]);
};



var $1KlOg = parcelRequire("1KlOg");
const $cf676ff621ab59ee$export$43c1bab12c0911f6 = (props)=>{
    const { scenes: scenes, className: className, x: x, y: y, showOverlay: showOverlay = false, overlayMessage: overlayMessage, references: references, navigationRef: navigationRef } = props;
    const ref = (0, $kIarK$useRef)(null);
    const renderOverlayTimeoutRef = (0, $kIarK$useRef)();
    const isMobile = (0, $f9meZ.useIsMobile)();
    const { settings: settings, rendererType: rendererType, videos: videos } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const hasVideos = videos && !(0, $kIarK$isEmpty)(videos);
    const defaultMobileZoomedInEnabled = isMobile && !!settings.defaultMobileZoomedIn;
    const draggableRef = (0, $kIarK$useRef)(isMobile ? !defaultMobileZoomedInEnabled : true);
    const { view: scene, hovered: hovered, activeTab: activeTab, setActiveTab: setActiveTab, activeAngle: activeAngle, rotateInstanceRef: rotateInstanceRef, showSplashScreen: showSplashScreen, appHistory: appHistory, hasPlayed: hasPlayed } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const { state: isExpanded, setState: setIsExpanded } = (0, $kIarK$useToggle)(defaultMobileZoomedInEnabled && hasVideos && hasPlayed);
    const [renderOvelay, setRenderOvelay] = (0, $kIarK$useState)(false);
    const [mobileZoomChangedByUser, setMobileZoomChangedByUser] = (0, $kIarK$useState)(false);
    const { state: showTooltip, setState: setShowTooltip } = (0, $kIarK$useToggle)(true);
    const tooltipTarget = (0, $kIarK$useRef)();
    const compassDirectionRef = (0, $kIarK$useRef)();
    const focusSourceRef = (0, $kIarK$useRef)(null);
    const [areScenesLoaded, setAreScenesLoaded] = (0, $kIarK$useState)(false);
    const is2D = rendererType === '2d';
    const visualTestId = `${isExpanded ? 'expanded' : 'collapsed'}-mobile-picker-area`;
    const isVerticalLayout = settings.layout === 'vertical';
    const showDesktopNavigationArrows = !isMobile && !settings.settings.showUnitList && settings.layout !== 'vertical';
    (0, $kIarK$useEffect)(()=>{
        clearTimeout(renderOverlayTimeoutRef.current);
        if (showOverlay) setRenderOvelay(true);
        else renderOverlayTimeoutRef.current = setTimeout(()=>setRenderOvelay(false), 200);
    }, [
        showOverlay
    ]);
    const image = (0, $82fc683722f61b69$export$69a3209f1a06c04d).get(scene?.asset.uuid);
    (0, $kIarK$useEffect)(()=>{
        if (image) return;
        (0, $82fc683722f61b69$export$6b05b21262ec0515)({
            images: [
                {
                    uuid: scene.asset.uuid,
                    url: scene.asset.url
                }
            ],
            fetchPriority: 'high'
        }).then(([img])=>{
            if (!image) return;
            ref.current.setAttribute('viewBox', `0 0 ${img.width} ${img.height}`);
        });
    }, [
        image,
        scene.asset
    ]);
    const defaultSvgWidth = image?.width || 1920;
    const defaultSvgHeight = image?.height || 1080;
    const focusedElementRef = (0, $kIarK$useRef)();
    const drawScene = (0, $6eb831bd70db8754$export$c52de51160cdfcaf)({
        scenesArg: scenes,
        focusedElementRef: focusedElementRef
    });
    const drawSceneRef = (0, $kIarK$useRef)(drawScene);
    /**
  /* Firefox has issues with rendering images inside an svg
  /* We only load one set of images (optimizedUrl)
  /*/ const isFirefox = (0, $51ab922e73581c8c$export$6d629c114b9fc461)();
    (0, $kIarK$useEffect)(()=>{
        const svg = (0, $kIarK$select)(ref.current);
        const mainZoom = (0, $9da363042717d9b0$export$af9ffbca99a36fd2)({
            width: image?.width,
            height: image?.height,
            is3D: !is2D
        });
        svg.call(mainZoom);
        const renderWindow = (currentAngle)=>{
            const existingGroups = svg.selectAll('g').data(scenes, (d)=>d?.uuid);
            existingGroups.interrupt();
            const enterGroups = existingGroups.enter().append('g').attr('id', (d)=>`scene-${d.uuid}`).attr('class', (d)=>(0, $kIarK$classnames)((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).scene, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).active]: d.direction === currentAngle || is2D
                }));
            enterGroups.filter((d)=>d.direction === currentAngle || is2D).style('opacity', 0).transition().ease((0, $kIarK$easeLinear)).duration(400).style('opacity', null);
            let loadedCount = 0;
            enterGroups.append('image').on('load', function() {
                loadedCount++;
                if (loadedCount === scenes.length) setAreScenesLoaded(true);
            }).attr('data-optimized', (d)=>d.asset.optimizedUrl ? true : null).attr('href', (d)=>d.asset.optimizedUrl || d.asset.url).attr('xlink:href', (d)=>d.asset.optimizedUrl || d.asset.url).attr('x', '0').attr('y', '0').attr('height', image?.height).attr('width', image?.width ?? '100%');
            existingGroups.style('opacity', null).attr('class', (d)=>(0, $kIarK$classnames)((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).scene, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).active]: d.direction === currentAngle || is2D
                }));
            const exitGroups = existingGroups.exit();
            exitGroups.interrupt();
            exitGroups.transition().ease((0, $kIarK$easeLinear)).duration(400).style('opacity', 0).remove();
        };
        const nextLevelCompassDirection = (0, $14e29a6cb5abc501$export$fb76bb1a9271d29)({
            scenes: scenes,
            currentCompassDirection: compassDirectionRef.current
        });
        const initialIndex = !(0, $kIarK$isNil)(nextLevelCompassDirection) ? nextLevelCompassDirection : activeAngle.current;
        renderWindow(initialIndex);
        activeAngle.current = initialIndex;
        if ((0, $kIarK$isNil)(compassDirectionRef.current)) compassDirectionRef.current = scenes[initialIndex]?.compassDirection;
        if (!is2D) {
            rotateInstanceRef.current?.cleanup();
            rotateInstanceRef.current = (0, $590f7356e40951f7$export$185802fd694ee1f5)(ref.current, {
                scenes: scenes,
                index: initialIndex,
                afterChange: ({ newIndex: angle })=>{
                    activeAngle.current = angle;
                    compassDirectionRef.current = scenes[angle]?.compassDirection;
                    renderWindow(angle);
                    if (!isMobile && !isFirefox) (0, $de0eb6b1efb28219$export$25925f6080f36862)(scenes[angle]);
                },
                onEnd: (oldIndex)=>{
                    if (oldIndex === activeAngle.current) return;
                    drawSceneRef.current();
                },
                draggableRef: draggableRef,
                tolerance: Math.min(10, (0, $590f7356e40951f7$export$cf4759cf15f7d9e2) / scenes.length)
            });
        }
    }, [
        scenes,
        drawSceneRef,
        image,
        is2D,
        activeAngle,
        isMobile,
        isFirefox,
        rotateInstanceRef
    ]);
    (0, $kIarK$useEffect)(()=>{
        drawScene();
        drawSceneRef.current = drawScene;
    }, [
        image,
        scenes,
        drawScene
    ]);
    (0, $91dbaad5e097b21c$export$cda9ab6ffc878336)({
        image: image,
        navigationRef: navigationRef,
        focusedElementRef: focusedElementRef,
        focusSourceRef: focusSourceRef,
        tooltipTarget: tooltipTarget,
        setShowTooltip: setShowTooltip,
        ref: ref,
        references: references
    });
    (0, $fbb1b0baf018a5e9$export$aedc931e82562f4e)({
        focusedElementRef: focusedElementRef,
        focusSourceRef: focusSourceRef,
        scenes: scenes
    });
    (0, $kIarK$useEffect)(()=>{
        if (!defaultMobileZoomedInEnabled || mobileZoomChangedByUser || !isMobile || hasVideos && !hasPlayed || !appHistory.length) return;
        setIsExpanded(appHistory.length === 1);
    }, [
        hasVideos,
        appHistory,
        defaultMobileZoomedInEnabled,
        isMobile,
        mobileZoomChangedByUser,
        hasPlayed,
        setIsExpanded
    ]);
    return /*#__PURE__*/ (0, $kIarK$jsxs)((0, $kIarK$Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                className: (0, $kIarK$classnames)((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).visual, 'bg-white', {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).expanded]: isExpanded
                }),
                id: "visual",
                "data-testid": visualTestId,
                children: [
                    showDesktopNavigationArrows ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $0b5bd51331ae649d$export$5afd6f7eb9f43a07), {}) : null,
                    is2D && !showDesktopNavigationArrows ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $1a238eb2115705a2$export$68f4fb67dfa813b0), {}) : null,
                    /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: "sticky inset-0 z-10",
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $5116544d189893b5$export$b8a61e5c71402559), {})
                    }),
                    isMobile ? null : /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).navigation,
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $6e56d3a37b98cf3f$export$a87b9398fba7039f), {
                            value: activeTab,
                            onChange: setActiveTab
                        })
                    }),
                    /*#__PURE__*/ (0, $kIarK$jsx)("svg", {
                        ref: ref,
                        viewBox: [
                            x || 0,
                            y || 0,
                            image?.width || defaultSvgWidth,
                            image?.height || defaultSvgHeight
                        ].join(' '),
                        xmlns: "http://www.w3.org/2000/svg",
                        className: (0, $kIarK$classnames)((0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).scenesContainer, className, {
                            [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).rotate]: rendererType === '3d',
                            [(0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).loading]: showSplashScreen
                        }),
                        "data-testid": "pickerArea",
                        preserveAspectRatio: "xMidYMid meet",
                        children: /*#__PURE__*/ (0, $kIarK$jsxs)("defs", {
                            children: [
                                /*#__PURE__*/ (0, $kIarK$jsx)("filter", {
                                    id: "blurFilter",
                                    x: "-20%",
                                    y: "-20%",
                                    width: "140%",
                                    height: "140%",
                                    children: /*#__PURE__*/ (0, $kIarK$jsx)("feGaussianBlur", {
                                        in: "SourceGraphic",
                                        stdDeviation: "6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $kIarK$jsxs)("linearGradient", {
                                    id: "tooltip1",
                                    x1: "0%",
                                    y1: "100%",
                                    x2: "0%",
                                    y2: "0%",
                                    gradientTransform: "rotate(360)",
                                    children: [
                                        /*#__PURE__*/ (0, $kIarK$jsx)("stop", {
                                            offset: "0%",
                                            stopColor: "white",
                                            stopOpacity: "0.8"
                                        }),
                                        /*#__PURE__*/ (0, $kIarK$jsx)("stop", {
                                            offset: "100%",
                                            stopColor: "white",
                                            stopOpacity: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIarK$jsxs)("linearGradient", {
                                    id: "tooltip2",
                                    x1: "0%",
                                    y1: "0%",
                                    x2: "0%",
                                    y2: "0%",
                                    children: [
                                        /*#__PURE__*/ (0, $kIarK$jsx)("stop", {
                                            offset: "0%",
                                            stopColor: "white",
                                            stopOpacity: "0.5"
                                        }),
                                        /*#__PURE__*/ (0, $kIarK$jsx)("stop", {
                                            offset: "100%",
                                            stopColor: "white",
                                            stopOpacity: "0.5"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIarK$jsxs)("pattern", {
                                    id: "tooltipGradient",
                                    patternUnits: "objectBoundingBox",
                                    width: "100%",
                                    height: "100%",
                                    children: [
                                        /*#__PURE__*/ (0, $kIarK$jsx)("rect", {
                                            width: "100%",
                                            height: "100%",
                                            fill: "url(#tooltip1)"
                                        }),
                                        /*#__PURE__*/ (0, $kIarK$jsx)("rect", {
                                            width: "100%",
                                            height: "100%",
                                            fill: "url(#tooltip2)"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: (0, $kIarK$classnames)('pointer-events-none absolute inset-0 z-10 bg-white transition-opacity duration-700', areScenesLoaded ? 'opacity-0' : 'opacity-100'),
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Skeleton), {
                            className: "h-full",
                            containerClassName: "w-full"
                        })
                    }),
                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $5b8989858b8957bd$export$b3c44ac484b3c461), {
                        navigationRef: navigationRef
                    }),
                    showSplashScreen ? /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Spinner), {
                            size: 10
                        })
                    }) : null,
                    renderOvelay ? /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1KlOg))).overlay,
                        style: {
                            opacity: showOverlay ? 1 : 0
                        },
                        children: overlayMessage
                    }) : null,
                    is2D || scenes.length === 1 ? null : /*#__PURE__*/ (0, $kIarK$jsx)((0, $8ed99cc372ebafd2$export$7c9c61e12d23e82c), {})
                ]
            }),
            isMobile && (hasVideos ? hasPlayed : true) ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $5786c9f81ee5b018$export$eef7c7c048667e2c), {
                setIsExpanded: (value)=>{
                    draggableRef.current = !value;
                    setIsExpanded(value);
                    setMobileZoomChangedByUser(true);
                },
                toggled: isExpanded
            }) : null,
            is2D && (isMobile || isVerticalLayout) ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $712f560112679da6$export$810cc735c73f5876), {}) : null,
            showTooltip && hovered && tooltipTarget ? /*#__PURE__*/ (0, $kIarK$createPortal)(/*#__PURE__*/ (0, $kIarK$jsx)((0, $7816de56623962c9$export$83f4e8a3a05204df), {
                ref: tooltipTarget
            }), document.body) : null
        ]
    });
};


const $ddf92a411d4ec256$var$Scenes = ()=>{
    const { settings: settings, scenes: allScenes, rendererType: rendererType } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const { focusedElement: focusedElement, showUnconfiguredOverlay: showUnconfiguredOverlay, setShowUnconfiguredOverlay: setShowUnconfiguredOverlay, isMobile: isMobile, view: scene, activeScene: activeScene, hovered: hovered } = (0, $kIarK$useContext)((0, $BO02E.MainContext));
    const is2D = rendererType === '2d';
    const scenesToReference = (0, $kIarK$useMemo)(()=>{
        const rootScene = allScenes.find((scene)=>scene.uuid === activeScene);
        const renderScenes = [
            activeScene,
            ...rootScene?.relatedScenes ?? []
        ];
        return allScenes.filter((scene)=>renderScenes.includes(scene.uuid));
    }, [
        allScenes,
        activeScene
    ]);
    const scenesToRender = (0, $kIarK$useMemo)(()=>{
        const rootScene = allScenes.find((scene)=>scene.uuid === activeScene);
        const renderScenes = [
            activeScene,
            ...is2D ? [] : rootScene?.relatedScenes ?? []
        ];
        return allScenes.filter((scene)=>renderScenes.includes(scene.uuid));
    }, [
        allScenes,
        activeScene,
        is2D
    ]);
    const baseReferences = (0, $kIarK$useMemo)(()=>scenesToReference.flatMap(({ references: references })=>references), [
        scenesToReference
    ]);
    const references = (0, $d6bae723e3580231$export$ebce7778ea73786e)(baseReferences);
    const navigationRef = (0, $kIarK$useRef)();
    const uniqueReferences = (0, $kIarK$useMemo)(()=>(0, $59fbae12ab3bb0e2$export$f07629d55b1eb618)(references), [
        references
    ]);
    const [unitReferences, stagesAndBuildingsReferences] = (0, $kIarK$useMemo)(()=>(0, $kIarK$partition)(({ target: target })=>target.type === 'unit')(uniqueReferences), [
        uniqueReferences
    ]);
    (0, $kIarK$useEffect)(()=>{
        if (!isMobile || !is2D) return;
        const activeReference = references.find((ref)=>ref.parent === focusedElement);
        if (!activeReference) return;
        const isInView = (0, $cc583b72b9237f95$export$5dbb582fe83b74d2)(activeReference.parent, scene?.references);
        setShowUnconfiguredOverlay(!isInView);
    }, [
        isMobile,
        setShowUnconfiguredOverlay,
        references,
        focusedElement,
        scene?.references,
        is2D
    ]);
    (0, $kIarK$useEffect)(()=>{
        setShowUnconfiguredOverlay(false);
    }, [
        scene,
        setShowUnconfiguredOverlay
    ]);
    const showUnitList = settings.layout === 'horizontal' && settings.settings.showUnitList;
    const isVerticalLayout = settings.layout === 'vertical';
    const activeReference = references.find((ref)=>ref.parent === (isMobile ? focusedElement : hovered));
    const activeReferenceType = activeReference?.target?.type;
    return /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
        className: (0, $kIarK$classnames)('grid w-full', !isVerticalLayout && 'lg:grid-cols-[auto_min-content] lg:grid-rows-[fit-content(100px)]'),
        children: [
            /*#__PURE__*/ (0, $kIarK$jsx)((0, $cf676ff621ab59ee$export$43c1bab12c0911f6), {
                scenes: scenesToRender,
                asset: scene?.asset,
                references: references,
                showOverlay: showUnconfiguredOverlay,
                overlayMessage: activeReferenceType === 'unit' ? (0, $kIarK$i18n)._(/*i18n*/ {
                    id: "GRqhSA"
                }) : (0, $kIarK$i18n)._(/*i18n*/ {
                    id: "9q90xa"
                }),
                navigationRef: navigationRef
            }),
            showUnitList ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $f3ebaacb498d1c64$export$2ddb90ad54e5f587), {
                ref: navigationRef,
                className: "bg-(--background-custom-primary) lg:w-100",
                headerContent: !isMobile && is2D ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $712f560112679da6$export$810cc735c73f5876), {}) : null,
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $498c087e90fe35fd$export$88ee64ed0ab124b), {
                    navigationRef: navigationRef,
                    unitReferences: unitReferences,
                    references: uniqueReferences,
                    stagesAndBuildingsReferences: stagesAndBuildingsReferences
                })
            }) : null
        ]
    });
};
var $ddf92a411d4ec256$export$2e2bcd8739ae039 = $ddf92a411d4ec256$var$Scenes;



var $BO02E = parcelRequire("BO02E");
const $ec876ceef125ce6c$export$fcbccfb45c61a010 = (elements, references = [], relatedReferences = [])=>{
    const sortByTitle = (ref)=>ref.sort((a, b)=>{
            const firstTitle = elements.find((unit)=>a.parent === unit.uuid)?.title || '';
            const secondTitle = elements.find((unit)=>b.parent === unit.uuid)?.title || '';
            return firstTitle.localeCompare(secondTitle, undefined, {
                numeric: true,
                sensitivity: 'base'
            });
        });
    return [
        ...sortByTitle(references),
        ...sortByTitle(relatedReferences)
    ];
};




const $8c89fe12662c77ae$export$144f0ccd276ee81d = (callback)=>{
    (0, $kIarK$useEffect)(()=>{
        const handler = (e)=>{
            const data = (0, $81c3430b034efb71$export$59c34a18e3d554a9)(e);
            if (data?.type === 'modal:close') callback();
        };
        window.addEventListener('message', handler);
        return ()=>window.removeEventListener('message', handler);
    }, [
        callback
    ]);
};



var $f9meZ = parcelRequire("f9meZ");



var $eqIVn = parcelRequire("eqIVn");


const $b5cde60300118eac$export$1921894b858349af = (references)=>{
    const { getFloorplansPreview: getFloorplansPreview, settings: settings } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const [floorplans, setFloorplans] = (0, $kIarK$useState)({});
    const uuids = (0, $kIarK$useMemo)(()=>(0, $kIarK$sort)((0, $kIarK$ascend)((0, $kIarK$identity)), (0, $kIarK$uniq)(references.map((r)=>r.parent))), [
        references
    ]);
    (0, $kIarK$useEffect)(()=>{
        if (!getFloorplansPreview) return;
        const contentTypes = (0, $eqIVn.getContentTypes)(settings?.unitPlanType);
        (async ()=>{
            try {
                const floorplans = await getFloorplansPreview(uuids);
                const filteredFloorplans = contentTypes ? Object.entries(floorplans).filter(([, asset])=>contentTypes.includes(asset.content_type)) : Object.entries(floorplans);
                (0, $82fc683722f61b69$export$6b05b21262ec0515)({
                    images: filteredFloorplans.map(([uuid, asset])=>({
                            uuid: uuid,
                            url: asset.url
                        }))
                });
                setFloorplans(Object.fromEntries(filteredFloorplans));
            } catch (error) {
                console.error('Error fetching floorplans:', error);
            }
        })();
    }, [
        getFloorplansPreview,
        settings?.unitPlanType,
        uuids
    ]);
    return floorplans;
};










const $f1f3c9721c8f38fb$export$f586639adbe81750 = ({ scene: scene, scenes: scenes })=>{
    const { preload: preload, images: images } = (0, $82fc683722f61b69$export$4cd6903bc907aab2)({
        rootSceneUuid: scene?.uuid,
        scenes: scenes
    });
    (0, $kIarK$useEffect)(()=>{
        preload();
    }, [
        preload
    ]);
    return images?.find((image)=>image.uuid === scene?.asset.uuid);
};


const $d9efcf56ea14b140$var$getUnitReference = (element, references)=>references?.find((reference)=>reference.target.type === 'unit' && reference.target.id === element?.uuid);
const $d9efcf56ea14b140$export$81f874fc6ff139d2 = (args)=>{
    const { unit: unit, scenes: scenes, activeScene: activeScene, activeAngle: activeAngle, rendererType: rendererType } = args;
    const currentScene = (0, $kIarK$useMemo)(()=>scenes.find((scene)=>scene.uuid === activeScene), [
        scenes,
        activeScene
    ]);
    const relevantScenes = (0, $kIarK$useMemo)(()=>{
        const uniqueScenes = (0, $kIarK$uniqBy)((0, $kIarK$prop)('uuid'))([
            currentScene,
            ...scenes
        ]);
        return uniqueScenes.filter((scene)=>$d9efcf56ea14b140$var$getUnitReference(unit, scene?.references));
    }, [
        unit,
        currentScene,
        scenes
    ]);
    const matchedScene = (0, $kIarK$useMemo)(()=>{
        if (rendererType === '3d') return relevantScenes.find((scene)=>scene.direction === activeAngle);
        return relevantScenes[0];
    }, [
        rendererType,
        relevantScenes,
        activeAngle
    ]);
    const image = (0, $f1f3c9721c8f38fb$export$f586639adbe81750)({
        scene: matchedScene,
        scenes: scenes
    });
    return (0, $kIarK$useMemo)(()=>{
        if (!matchedScene) return {};
        return {
            reference: $d9efcf56ea14b140$var$getUnitReference(unit, matchedScene.references),
            image: image
        };
    }, [
        matchedScene,
        unit,
        image
    ]);
};




const $c20fcd8603824228$var$hashParams = window.location.hash.substring(1).split('&').map((v)=>v.split('=')).reduce((pre, [key, value])=>({
        ...pre,
        [key]: value
    }), {});
const $c20fcd8603824228$export$861edd1ccea2f746 = (props)=>{
    const { isLoading: isLoading, previewMode: previewMode = false, parentEndpoint: parentEndpoint, onRegisterInterestSubmit: onRegisterInterestSubmit, lang: lang, showSplashScreen: showSplashScreen } = props;
    const { elements: elements, scenes: scenes, rootView: rootView, settings: settings, project: project, getUnitsAssets: getUnitsAssets, isWrapped: isWrapped } = (0, $39e51ae0969551d7$export$26531d8e255edf16)();
    const implementationRef = /*#__PURE__*/ (0, $kIarK$createRef)();
    const rotateInstanceRef = (0, $kIarK$useRef)(null);
    const [activeScene, setActiveScene] = (0, $kIarK$useState)(null);
    const [activeUnit, setActiveUnit] = (0, $kIarK$useState)(null);
    const [appHistory, setAppHistory] = (0, $kIarK$useState)([]);
    const [share, setShare] = (0, $kIarK$useState)(false);
    const [showUnconfiguredOverlay, setShowUnconfiguredOverlay] = (0, $kIarK$useState)(false);
    const [activeTab, setActiveTab] = (0, $kIarK$useState)('images');
    const [detailsView, setDetailsView] = (0, $kIarK$useState)('cards');
    const [hovered, setHovered] = (0, $kIarK$useState)(null);
    const [showFilters, setShowFilters] = (0, $kIarK$useState)(false);
    const activeAngle = (0, $kIarK$useRef)(0);
    const isMobile = (0, $f9meZ.useIsMobile)();
    const [unitsAssets, setUnitsAssets] = (0, $kIarK$useState)({});
    const [focusedElement, setFocusedElement] = (0, $kIarK$useState)();
    const [hasPlayed, setHasPlayed] = (0, $kIarK$useState)(false);
    const fallbackView = scenes.find((view)=>view.uuid === rootView) ?? scenes[0];
    const view = scenes.find((view)=>appHistory[appHistory.length - 1] === view.uuid) ?? fallbackView;
    const unit = elements.find(({ uuid: uuid })=>uuid === activeUnit);
    const onFirstImageLoaded = (0, $kIarK$useCallback)(()=>{
        if (showSplashScreen || !isWrapped || isLoading) return;
        window.parent.postMessage('module-ready', '*');
    }, [
        showSplashScreen,
        isWrapped,
        isLoading
    ]);
    const { preload: preloadImages, images: sceneImages } = (0, $82fc683722f61b69$export$4cd6903bc907aab2)({
        rootSceneUuid: rootView,
        scenes: scenes,
        onFirstImageLoaded: onFirstImageLoaded
    });
    (0, $kIarK$useEffect)(()=>{
        preloadImages();
    }, [
        preloadImages
    ]);
    (0, $kIarK$useEffect)(()=>{
        getUnitsAssets?.().then(setUnitsAssets).catch((error)=>{
            console.error(`Failed loading unit assets: ${error}`);
        });
    }, [
        getUnitsAssets
    ]);
    const references = (0, $kIarK$useMemo)(()=>(0, $ec876ceef125ce6c$export$fcbccfb45c61a010)(elements, view?.references, view?.relatedReferences), [
        elements,
        view?.references,
        view?.relatedReferences
    ]);
    const floorplans = (0, $b5cde60300118eac$export$1921894b858349af)(references);
    (0, $kIarK$useEffect)(()=>{
        const nextSceneUuid = rootView ?? view?.uuid;
        if ((0, $kIarK$isNil)(activeScene) && !(0, $kIarK$isNil)(nextSceneUuid)) {
            setActiveScene(nextSceneUuid);
            setAppHistory([
                nextSceneUuid
            ]);
        }
    }, [
        activeScene,
        rootView,
        view?.uuid,
        implementationRef
    ]);
    (0, $kIarK$useEffect)(()=>{
        if (showSplashScreen || !$c20fcd8603824228$var$hashParams.shareUnitId) return;
        const shareUnitId = $c20fcd8603824228$var$hashParams.shareUnitId;
        delete $c20fcd8603824228$var$hashParams.shareUnitId;
        setShare(true);
        setActiveUnit(shareUnitId);
        setAppHistory([
            rootView,
            shareUnitId
        ]);
        implementationRef.current?.scrollIntoView({
            block: 'start',
            inline: 'nearest'
        });
        window.history.pushState('', document.title, `${window.location.pathname}${window.location.search}`);
    }, [
        implementationRef,
        rootView,
        showSplashScreen
    ]);
    (0, $kIarK$useEffect)(()=>{
        setActiveTab(scenes.length ? 'images' : 'list');
    }, [
        scenes.length
    ]);
    const onClose = ()=>{
        setActiveScene(share ? rootView : appHistory[appHistory.length - 1]);
        setShare(false);
        setActiveUnit(null);
    };
    (0, $8c89fe12662c77ae$export$144f0ccd276ee81d)(onClose);
    const showModal = unit && activeUnit;
    const { reference: reference, image: image } = (0, $d9efcf56ea14b140$export$81f874fc6ff139d2)({
        unit: unit,
        activeScene: activeScene,
        activeAngle: activeAngle.current,
        scenes: scenes,
        rendererType: settings?.rendererType
    });
    const unitLocation = (0, $kIarK$useMemo)(()=>({
            reference: reference,
            image: image
        }), [
        reference,
        image
    ]);
    (0, $kIarK$useEffect)(()=>{
        if (!showModal || !isWrapped) return;
        const value = {
            unit: unit,
            floorplans: unitsAssets[unit.uuid]?.floorplans ?? [],
            gallery: unitsAssets[unit.uuid]?.gallery ?? [],
            lang: lang,
            settings: settings,
            project: project,
            location: unitLocation
        };
        window.parent.postMessage(JSON.stringify({
            type: 'modal:open',
            value: value
        }), '*');
    }, [
        unit,
        showModal,
        isWrapped,
        activeScene,
        activeAngle,
        unitsAssets,
        lang,
        scenes,
        settings,
        project,
        unitLocation
    ]);
    if (!sceneImages?.length) return null;
    const isVerticalLayout = settings.layout === 'vertical';
    const isListViewActive = activeTab === 'list';
    const showUnitList = (settings.settings.showUnitList || isListViewActive) && (isListViewActive || isVerticalLayout);
    return /*#__PURE__*/ (0, $kIarK$jsxs)((0, $BO02E.MainContext).Provider, {
        value: {
            isLoading: isLoading,
            showSplashScreen: showSplashScreen,
            activeUnit: activeUnit,
            setActiveUnit: setActiveUnit,
            activeScene: activeScene,
            activeAngle: activeAngle,
            showUnconfiguredOverlay: showUnconfiguredOverlay,
            setShowUnconfiguredOverlay: setShowUnconfiguredOverlay,
            appHistory: appHistory,
            setActiveScene: setActiveScene,
            setAppHistory: setAppHistory,
            share: share,
            setShare: setShare,
            isMobile: isMobile,
            onRegisterInterestSubmit: onRegisterInterestSubmit,
            implementationRef: implementationRef,
            previewMode: previewMode,
            hovered: hovered,
            setHovered: setHovered,
            view: view,
            references: references,
            parentEndpoint: parentEndpoint,
            lang: lang,
            sceneImages: sceneImages,
            activeTab: activeTab,
            setActiveTab: setActiveTab,
            detailsView: detailsView,
            setDetailsView: setDetailsView,
            showFilters: showFilters,
            setShowFilters: setShowFilters,
            rotateInstanceRef: rotateInstanceRef,
            focusedElement: focusedElement,
            setFocusedElement: setFocusedElement,
            floorplans: floorplans,
            hasPlayed: hasPlayed,
            setHasPlayed: setHasPlayed
        },
        children: [
            showModal && !isWrapped ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $kIarK$Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $7f2ddd8f5333af3c$export$2e2bcd8739ae039), {
                    unit: unit,
                    location: unitLocation,
                    onClose: onClose,
                    settings: settings,
                    gallery: unitsAssets[unit.uuid]?.gallery,
                    floorplans: unitsAssets[unit.uuid]?.floorplans,
                    onRegisterInterestSubmit: onRegisterInterestSubmit,
                    project: project
                })
            }) : null,
            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                className: "min-h-80 w-full bg-white",
                style: {
                    maxWidth: settings.width || '100%',
                    backgroundColor: 'var(--background-custom-primary)'
                },
                children: [
                    isMobile ? /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                        className: "flex flex-row items-center justify-between pt-2 pb-4",
                        children: [
                            /*#__PURE__*/ (0, $kIarK$jsx)((0, $5e1721c22e0362b0$export$6e977ee002f5c8c), {
                                className: "max-w-[calc(100%-100px)]"
                            }),
                            /*#__PURE__*/ (0, $kIarK$jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $kIarK$jsx)((0, $6e56d3a37b98cf3f$export$a87b9398fba7039f), {
                                        value: activeTab,
                                        onChange: setActiveTab
                                    }),
                                    isVerticalLayout || isListViewActive ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $856529f8aa3dc483$export$92a576f896a9bf72), {}) : null
                                ]
                            })
                        ]
                    }) : null,
                    activeTab === 'images' && /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                        className: "flex flex-row justify-end lg:items-center lg:justify-center",
                        style: {
                            backgroundColor: 'var(--background-custom-primary)'
                        },
                        children: /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                            className: "relative flex h-full w-full flex-col-reverse items-start justify-end lg:flex-row lg:justify-start",
                            ref: implementationRef,
                            children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $ddf92a411d4ec256$export$2e2bcd8739ae039), {})
                        })
                    }),
                    showUnitList ? /*#__PURE__*/ (0, $kIarK$jsx)((0, $f3ebaacb498d1c64$export$2ddb90ad54e5f587), {
                        className: "min-h-120",
                        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $e50315c32b80c5ce$export$2e2bcd8739ae039), {})
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $kIarK$jsx)("div", {
                "data-iframe-height": true
            })
        ]
    });
};




var $6wwRp = parcelRequire("6wwRp");

var $3ZQmJ = parcelRequire("3ZQmJ");

const $c2f930c36120df7b$export$58081aedf094d85b = ({ type: type, uuid: uuid, project: project })=>{
    switch(type){
        case 'project':
            return project;
        case 'stage':
            return project.stages.find((stage)=>stage.uuid === uuid);
        case 'building':
            return project.buildings.find((building)=>building.uuid === uuid);
        default:
            return null;
    }
};



const $7ebda1ffcc55a4d1$export$9850a39246f694f6 = (args)=>{
    const { scene: scene, project: project } = args;
    const isBuilding = scene.promotable.type === 'building';
    const references = scene.references.filter((reference)=>{
        if (scene.promotable.type === 'project') return true;
        return (0, $36b627c59aa1ba74$export$80a4a465fb11c8af)({
            uuid: reference.parent,
            project: project
        });
    }).map((reference)=>({
            ...reference,
            type: isBuilding ? 'unit' : null,
            target: {
                id: reference.target?.id || null,
                type: reference.target?.type || null
            }
        }));
    return references;
};


const $f21b24691c69faf0$export$c05346853bca05b3 = ({ scenes: scenes, scene: scene })=>scenes.flatMap((item)=>item.references).filter((ref)=>!scene.references.some((reference)=>reference.parent === ref.parent)).map((ref)=>({
            ...ref,
            points: []
        }));


const $50990dd3e520b68b$export$ce6b28d5674097ce = ({ sceneUuid: sceneUuid, promotableUuid: promotableUuid, scenes: scenes })=>scenes.filter((view)=>view.promotable.uuid === promotableUuid && view.uuid !== sceneUuid);


const $909012729677ccf0$export$711e443a5ee0abdb = ({ scenes: allScenes, project: project })=>{
    const scenes = allScenes.filter((scene)=>scene.uuid && scene.promotable);
    return scenes.map((scene)=>{
        const { promotable: promotable, uuid: uuid } = scene;
        const parent = (0, $c2f930c36120df7b$export$58081aedf094d85b)({
            type: promotable.type,
            uuid: promotable.uuid,
            project: project
        });
        const references = (0, $7ebda1ffcc55a4d1$export$9850a39246f694f6)({
            scene: scene,
            project: project
        });
        const relatedScenes = (0, $50990dd3e520b68b$export$ce6b28d5674097ce)({
            sceneUuid: uuid,
            promotableUuid: promotable.uuid,
            scenes: scenes
        });
        const relatedScenesUuids = relatedScenes.map(({ uuid: uuid })=>uuid);
        const relatedReferences = (0, $f21b24691c69faf0$export$c05346853bca05b3)({
            scene: scene,
            scenes: relatedScenes
        });
        return {
            ...scene,
            title: parent?.name || '',
            parent: parent?.uuid,
            references: references,
            element: promotable.uuid,
            type: promotable.type,
            relatedReferences: relatedReferences,
            promotable: promotable,
            relatedScenes: relatedScenesUuids
        };
    });
};




const $fba587bc1b5c696c$export$c412b95aac4f098c = (settings = {})=>{
    if (!settings?.properties?.stage?.default) settings.properties = {
        stage: {
            default: [
                'title',
                'availableUnits',
                'unitTypes',
                'purchasePrice',
                'sizeM2'
            ]
        },
        building: {
            default: [
                'title',
                'availableUnits',
                'unitTypes',
                'purchasePrice',
                'sizeM2'
            ]
        },
        unit: {
            default: [
                'unitId',
                'roomCount',
                'floorNumber',
                'sizeM2',
                'purchasePrice'
            ],
            details: [
                'unitId',
                'type',
                'ownershipType',
                'roomCount',
                'bedroomCount',
                'bathroomCount',
                'floorNumber',
                'sizeM2',
                'usableAreaM2',
                'grossFloorAreaM2'
            ],
            prices: [
                'purchasePrice',
                'totalCosts',
                'jointDebt',
                'sharedPrice',
                'totalPrice',
                'deposit'
            ],
            list: [
                'unitId',
                'type',
                'ownershipType',
                'roomCount',
                'bedroomCount',
                'bathroomCount',
                'floorNumber',
                'sizeM2',
                'usableAreaM2',
                'grossFloorAreaM2',
                'purchasePrice',
                'totalCosts',
                'jointDebt',
                'sharedPrice',
                'totalPrice',
                'deposit',
                'buildingName',
                'stageName'
            ]
        }
    };
    return settings;
};



const $cc0f53bc1abab444$var$defaultToTrue = (0, $kIarK$defaultTo)(true);
const $cc0f53bc1abab444$export$d09e0c111bdd4aed = (settings)=>{
    const nestedSettings = settings.settings ?? {};
    return {
        ...settings,
        unitPlanType: (0, $kIarK$defaultTo)([])(settings.unitPlanType),
        settings: {
            ...nestedSettings,
            showUnitList: $cc0f53bc1abab444$var$defaultToTrue(nestedSettings.showUnitList),
            showUnitsCountTooltip: $cc0f53bc1abab444$var$defaultToTrue(nestedSettings.showUnitsCountTooltip)
        }
    };
};


const $7a90471fcb6f5867$export$9115b42802a3e44f = (settings)=>(0, $kIarK$useMemo)(()=>(0, $kIarK$compose)((0, $cc0f53bc1abab444$export$d09e0c111bdd4aed))((0, $fba587bc1b5c696c$export$c412b95aac4f098c)(settings)), [
        settings
    ]);



const $8a406af47c78ce28$export$3bb977b3ba9d3b59 = (props)=>{
    const { isLoading: isLoading, project: project, settings: baseSettings, scenes: scenes, rendererType: rendererType = '2d', lang: lang = 'en', previewMode: previewMode, parentEndpoint: parentEndpoint, onRegisterInterestSubmit: onRegisterInterestSubmit, startView: startView, levels: levels, showSplashScreen: showSplashScreen, videos: videos, ...rest } = props;
    const settings = (0, $7a90471fcb6f5867$export$9115b42802a3e44f)(baseSettings);
    (0, $kIarK$useEffect)(()=>{
        if (!project) return;
        const parsedScenes = (0, $909012729677ccf0$export$711e443a5ee0abdb)({
            scenes: scenes,
            project: project
        });
        const elements = (0, $4bd134a5c27c9e53$export$73eac51a39d6b0eb)({
            project: project,
            settings: settings
        });
        const rootView = (0, $e6fe67a25e431570$export$fd004ce6bcba12e3)({
            scenes: parsedScenes,
            elements: elements,
            project: project,
            startView: startView
        });
        (0, $39e51ae0969551d7$export$26531d8e255edf16).setState({
            project: project,
            currency: project.currency,
            settings: settings,
            rendererType: rendererType,
            scenes: parsedScenes,
            elements: elements,
            rootView: rootView,
            videos: videos,
            levels: levels,
            ...rest
        });
        (0, $3ZQmJ.setBrandingColors)(settings);
    }, [
        project,
        scenes,
        settings,
        startView,
        rendererType,
        levels,
        videos,
        rest
    ]);
    return /*#__PURE__*/ (0, $kIarK$jsx)((0, $6wwRp.LinguiProvider), {
        lang: lang,
        children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $670000472aba54a3$export$905df3588d1d8c75), {
            children: /*#__PURE__*/ (0, $kIarK$jsx)((0, $c20fcd8603824228$export$861edd1ccea2f746), {
                isLoading: isLoading,
                previewMode: previewMode,
                parentEndpoint: parentEndpoint,
                onRegisterInterestSubmit: onRegisterInterestSubmit,
                lang: lang,
                showSplashScreen: showSplashScreen
            })
        })
    });
};


parcelRequire("03tHb");



var $kE5BV = parcelRequire("kE5BV");



var $f34bfe15bc444429$export$93d4e7f90805808f = parcelRequire("kE5BV").useTheme;
var $f34bfe15bc444429$export$164de7ab8df77ef0 = parcelRequire("kE5BV").defaultTheme;
var $f1a29ef58a0b983e$export$28f3bb13af512577 = parcelRequire("hGnqz").saleStates;
var $f1a29ef58a0b983e$export$ec55e7edc35ff440 = parcelRequire("hGnqz").availableUnitStates;
var $f1a29ef58a0b983e$export$f978264a445a9948 = parcelRequire("hGnqz").unavailableUnitStates;
var $f1a29ef58a0b983e$export$947ceeb5312d4f1f = parcelRequire("hGnqz").unitStates;
var $2c72fc00c5c70175$export$f1e8f31da7383564 = parcelRequire("4l8zw").isBadgeType;
var $aabc524a7210db72$export$18932e8706af151c = parcelRequire("eYvp0").filterTypes;
var $aabc524a7210db72$export$76a1f5f3b098ab67 = parcelRequire("eYvp0").FilterToPropertyMap;
var $aabc524a7210db72$export$1c961c4c1212e7ea = parcelRequire("eYvp0").norwegianFilters;
var $aabc524a7210db72$export$25629b43b3340b0f = parcelRequire("eYvp0").rangeFilters;
var $aabc524a7210db72$export$430b53e6132181a7 = parcelRequire("eYvp0").checkboxFilters;
var $aabc524a7210db72$export$fe1b9a1a77be3bc5 = parcelRequire("eYvp0").booleanFilters;
var $aabc524a7210db72$export$742c4abf52faf26e = parcelRequire("eYvp0").isNorwegianFilter;
var $68250e1d00a08e90$export$e9d90cf6acb280f6 = parcelRequire("2FtpP").supportedUILanguages;
export {$8a406af47c78ce28$export$3bb977b3ba9d3b59 as PropertyPicker, $34e18f7dd1073436$export$4a657eec83cc7989 as NumberTooltip, $34e18f7dd1073436$export$cf157e14e63535b0 as getTopCenterPosition, $6684c96130c0c59b$export$b23207294f708114 as AngleSwitcherCard, $f34bfe15bc444429$export$93d4e7f90805808f as useTheme, $f34bfe15bc444429$export$164de7ab8df77ef0 as defaultTheme, $7f2ddd8f5333af3c$export$2e2bcd8739ae039 as UnitModal, $f1a29ef58a0b983e$export$28f3bb13af512577 as saleStates, $f1a29ef58a0b983e$export$ec55e7edc35ff440 as availableUnitStates, $f1a29ef58a0b983e$export$f978264a445a9948 as unavailableUnitStates, $f1a29ef58a0b983e$export$947ceeb5312d4f1f as unitStates, $2c72fc00c5c70175$export$f1e8f31da7383564 as isBadgeType, $aabc524a7210db72$export$18932e8706af151c as filterTypes, $aabc524a7210db72$export$76a1f5f3b098ab67 as FilterToPropertyMap, $aabc524a7210db72$export$1c961c4c1212e7ea as norwegianFilters, $aabc524a7210db72$export$25629b43b3340b0f as rangeFilters, $aabc524a7210db72$export$430b53e6132181a7 as checkboxFilters, $aabc524a7210db72$export$fe1b9a1a77be3bc5 as booleanFilters, $aabc524a7210db72$export$742c4abf52faf26e as isNorwegianFilter, $68250e1d00a08e90$export$e9d90cf6acb280f6 as supportedUILanguages};
//# sourceMappingURL=module.js.map
